// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { userApp } from "../Admin/Utility";
// import ReactTable from "../General/ReactTable";
// import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
// import { useDispatch, useSelector } from "react-redux";
// import $ from "jquery";
// import CustomizedSelectoption from "./CustomizedSelectoption";
// import { ShowHide_Popup } from "../ReduxStore/Transactionstates";

// // ═══════════════════════════════════════════════════════════════
// //  TOAST — exact match to EInvoice
// // ═══════════════════════════════════════════════════════════════
// function Toast({ toasts, onDismiss }) {
//   const typeConfig = {
//     success: { bg: "darkgreen", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "darkgreen", icon: "✔" },
//     error:   { bg: "#c0392b", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "#c0392b", icon: "✕" },
//     info:    { bg: "#1a6fba", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "#1a6fba", icon: "i" },
//     warning: { bg: "#d35400", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "#d35400", icon: "!" },
//   };
//   return (
//     <div style={{ position: "fixed", top: 18, right: 18, zIndex: 99999, display: "flex", flexDirection: "column", gap: 8, pointerEvents: "none" }}>
//       {toasts.map((t) => {
//         const cfg = typeConfig[t.type] || typeConfig.info;
//         return (
//           <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 10, background: cfg.bg, color: cfg.textColor, padding: "10px 14px 10px 12px", borderRadius: 5, fontSize: 13, fontWeight: 600, minWidth: 300, maxWidth: 420, pointerEvents: "all", animation: "toastSlide 0.25s ease-out", boxShadow: "0 2px 8px rgba(0,0,0,0.25)", letterSpacing: "0.01em" }}>
//             <div style={{ width: 20, height: 20, borderRadius: "50%", background: cfg.iconBg, color: cfg.iconColor, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 900, flexShrink: 0 }}>{cfg.icon}</div>
//             <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>
//             <button onClick={() => onDismiss && onDismiss(t.id)} style={{ background: "none", border: "none", color: cfg.textColor, cursor: "pointer", fontSize: 18, fontWeight: 400, lineHeight: 1, padding: "0 0 0 6px", opacity: 0.9, flexShrink: 0 }}>×</button>
//           </div>
//         );
//       })}
//       <style>{`@keyframes toastSlide { from { opacity:0; transform:translateX(50px); } to { opacity:1; transform:translateX(0); } }`}</style>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  CREDENTIAL MODAL
// // ═══════════════════════════════════════════════════════════════
// function CredentialModal({ cred, onChange, onSave, onClose, saving }) {
//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 10000, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <div style={{ background: "#fff", borderRadius: 14, width: 420, boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)", overflow: "hidden" }}>
//         <div style={{ background: "linear-gradient(135deg,#0f172a,#1e3a5f)", padding: "24px 28px", display: "flex", alignItems: "center", gap: 14 }}>
//           <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🔐</div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>NIC E-Way Bill Credentials</div>
//             <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", marginTop: 2 }}>GST Portal Login — required for API access</div>
//           </div>
//         </div>
//         <div style={{ padding: "24px 28px 20px" }}>
//           <div style={{ marginBottom: 16 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, letterSpacing: "0.5px", textTransform: "uppercase" }}>GST Username</label>
//             <input type="text" className="form-control" placeholder="Enter GST portal username" value={cred.ApiUserName} onChange={(e) => onChange({ ...cred, ApiUserName: e.target.value })} autoComplete="off" style={{ fontSize: 13 }} />
//           </div>
//           <div style={{ marginBottom: 24 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, letterSpacing: "0.5px", textTransform: "uppercase" }}>GST Password</label>
//             <input type="password" className="form-control" placeholder="Enter GST portal password" value={cred.ApiPassword} onChange={(e) => onChange({ ...cred, ApiPassword: e.target.value })} autoComplete="new-password" style={{ fontSize: 13 }} />
//           </div>
//           <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 12px", marginBottom: 20, fontSize: 11.5, color: "#1e40af", lineHeight: 1.5 }}>
//             ℹ️ These credentials are used only for NIC E-Way Bill API authentication. They are stored securely and encrypted.
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button onClick={onClose} disabled={saving} style={{ flex: 1, padding: "10px", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 13, cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.5 : 1 }}>Cancel</button>
//             <button onClick={onSave} disabled={saving} style={{ flex: 1, padding: "10px", borderRadius: 8, border: "none", background: saving ? "#9ca3af" : "linear-gradient(135deg,#0f172a,#1e3a5f)", color: "#fff", fontWeight: 700, fontSize: 13, cursor: saving ? "not-allowed" : "pointer" }}>
//               {saving ? "Saving..." : "Save & Generate"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  VALIDATION MODAL — EWayBill (exact EInvoice flow)
// // ═══════════════════════════════════════════════════════════════
// function ValidationModal({ errors, warnings, ewb, onProceed, onClose }) {
//   const hasErrors  = errors.length > 0;
//   const inv        = ewb || {};
//   const doc        = inv.DocDtls   || {};
//   const seller     = inv.SellerDtls || {};
//   const buyer      = inv.BuyerDtls  || {};
//   const ewbDtls    = inv.EwbDtls    || {};
//   const val        = inv.ValDtls    || {};
//   const items      = inv.itemList   || [];

//   const checks = [
//     { label: "Invoice Number",    ok: !!doc.No,                                       val: doc.No          || "Missing" },
//     { label: "Invoice Date",      ok: !!doc.Dt,                                       val: doc.Dt          || "Missing" },
//     { label: "From GSTIN",        ok: (seller.Gstin || "").length === 15 || seller.Gstin === "URP", val: seller.Gstin || "Missing" },
//     { label: "To GSTIN",          ok: (buyer.Gstin  || "").length === 15 || buyer.Gstin  === "URP", val: buyer.Gstin  || "Missing" },
//     { label: "From Pincode",      ok: /^\d{6}$/.test(String(seller.Pin || "")),       val: String(seller.Pin || "Missing") },
//     { label: "To Pincode",        ok: /^\d{6}$/.test(String(buyer.Pin  || "")),       val: String(buyer.Pin  || "Missing") },
//     { label: "Transport Mode",    ok: ["1","2","3","4"].includes(String(ewbDtls.TransMode || "")), val: ewbDtls.TransMode ? String(ewbDtls.TransMode) : "Missing" },
//     { label: "Vehicle Number",    ok: (String(ewbDtls.VehNo || "").trim().length >= 4), val: ewbDtls.VehNo  || "Missing" },
//     { label: "Distance (km)",     ok: Number(ewbDtls.Distance || 0) >= 0,              val: String(ewbDtls.Distance || 0) + " km" },
//     { label: "Total Invoice Val", ok: Number(val.TotInvVal || 0) > 0,                 val: "₹" + Number(val.TotInvVal || 0).toLocaleString("en-IN") },
//     { label: "Items",             ok: items.length > 0,                               val: items.length + " item(s)" },
//   ];

//   const passCount  = checks.filter((c) => c.ok).length;
//   const totalCount = checks.length;
//   const progress   = Math.round((passCount / totalCount) * 100);

//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
//       <div style={{ background: "#fff", borderRadius: 16, width: 580, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: "0 32px 100px rgba(0,0,0,0.35)", animation: "modalPop 0.28s cubic-bezier(0.34,1.56,0.64,1)", overflow: "hidden" }}>

//         {/* ── Header ── */}
//         <div style={{ background: hasErrors ? "#dc2626" : "darkgreen", padding: "22px 24px" }}>
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//               <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>
//                 {hasErrors ? "🛑" : "✅"}
//               </div>
//               <div>
//                 <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
//                   {hasErrors
//                     ? `${errors.length} Error${errors.length > 1 ? "s" : ""} Found — Cannot Generate`
//                     : "All Checks Passed — Ready to Generate"}
//                 </div>
//                 <div style={{ fontSize: 12, color: "rgba(255,255,255,0.65)", marginTop: 2 }}>
//                   {hasErrors
//                     ? "Fix the errors in the invoice and try again"
//                     : `${warnings.length > 0 ? warnings.length + " warning(s) noted · " : ""}Confirm to submit to NIC portal`}
//                 </div>
//               </div>
//             </div>
//             <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
//           </div>

//           {/* Progress bar */}
//           <div>
//             <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
//               <span style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", fontWeight: 600 }}>VALIDATION PROGRESS</span>
//               <span style={{ fontSize: 11, color: "rgba(255,255,255,0.9)", fontWeight: 700 }}>{passCount}/{totalCount} checks passed</span>
//             </div>
//             <div style={{ height: 6, background: "rgba(255,255,255,0.2)", borderRadius: 3, overflow: "hidden" }}>
//               <div style={{ height: "100%", width: `${progress}%`, background: hasErrors ? "#fca5a5" : "rgba(255,255,255,0.75)", borderRadius: 3, transition: "width 0.5s ease" }} />
//             </div>
//           </div>
//         </div>

//         {/* ── Body ── */}
//         <div style={{ overflowY: "auto", flex: 1 }}>

//           {/* Field Checklist */}
//           <div style={{ padding: "16px 24px 0" }}>
//             <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", letterSpacing: "0.7px", marginBottom: 10, textTransform: "uppercase" }}>Field Validation Checklist</div>
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 10px" }}>
//               {checks.map((c, i) => (
//                 <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", borderRadius: 7, background: c.ok ? "#f0fdf4" : "#fef2f2", border: `1px solid ${c.ok ? "#bbf7d0" : "#fecaca"}` }}>
//                   <span style={{ width: 18, height: 18, borderRadius: "50%", flexShrink: 0, background: c.ok ? "#dcfce7" : "#fee2e2", color: c.ok ? "#15803d" : "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700 }}>
//                     {c.ok ? "✓" : "✕"}
//                   </span>
//                   <div style={{ minWidth: 0 }}>
//                     <div style={{ fontSize: 10.5, fontWeight: 700, color: c.ok ? "darkgreen" : "#991b1b" }}>{c.label}</div>
//                     <div style={{ fontSize: 10, color: c.ok ? "darkgreen" : "#f87171", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>{c.val}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Errors */}
//           {errors.length > 0 && (
//             <div style={{ padding: "16px 24px 0" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
//                 <div style={{ background: "#dc2626", color: "#fff", borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700, letterSpacing: "0.5px" }}>
//                   {errors.length} ERROR{errors.length > 1 ? "S" : ""}
//                 </div>
//                 <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}>Must be fixed in the invoice before generating</div>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                 {errors.map((e, i) => (
//                   <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 12px" }}>
//                     <span style={{ width: 18, height: 18, borderRadius: "50%", background: "#fee2e2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✕</span>
//                     <span style={{ fontSize: 12, color: "#7f1d1d", lineHeight: 1.5 }}>{e}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Warnings */}
//           {warnings.length > 0 && (
//             <div style={{ padding: "16px 24px 0" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
//                 <div style={{ background: "#d97706", color: "#fff", borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700, letterSpacing: "0.5px" }}>
//                   {warnings.length} WARNING{warnings.length > 1 ? "S" : ""}
//                 </div>
//                 <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}>Safe to proceed — but verify these</div>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                 {warnings.map((w, i) => (
//                   <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 12px" }}>
//                     <span style={{ width: 18, height: 18, borderRadius: "50%", background: "#fef3c7", color: "#d97706", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>!</span>
//                     <span style={{ fontSize: 12, color: "#78350f", lineHeight: 1.5 }}>{w}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Items Summary */}
//           {items.length > 0 && (
//             <div style={{ padding: "16px 24px 0" }}>
//               <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", letterSpacing: "0.7px", marginBottom: 10, textTransform: "uppercase" }}>Item Summary</div>
//               <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//                 {items.slice(0, 5).map((item, i) => {
//                   const hsnOk  = !!item.HsnCd  && /^\d{4,8}$/.test(String(item.HsnCd));
//                   const qtyOk  = Number(item.Qty || 0) > 0;
//                   const amtOk  = Number(item.AssAmt ?? item.TotAmt ?? 0) > 0;
//                   const itemOk = hsnOk && qtyOk && amtOk;
//                   return (
//                     <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: itemOk ? "#f0fdf4" : "#fef2f2", border: `1px solid ${itemOk ? "#bbf7d0" : "#fecaca"}`, borderRadius: 8, padding: "8px 12px" }}>
//                       <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                         <span style={{ width: 18, height: 18, borderRadius: "50%", flexShrink: 0, background: itemOk ? "#dcfce7" : "#fee2e2", color: itemOk ? "#15803d" : "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700 }}>
//                           {itemOk ? "✓" : "✕"}
//                         </span>
//                         <div>
//                           <div style={{ fontSize: 11.5, fontWeight: 600, color: "#0f172a" }}>{item.PrdDesc || "—"}</div>
//                           <div style={{ fontSize: 10, color: "#6b7280" }}>
//                             HSN: {item.HsnCd || <span style={{ color: "#dc2626" }}>Missing</span>} &nbsp;·&nbsp; Qty: {item.Qty} {item.Unit} &nbsp;·&nbsp; Taxable: ₹{Number(item.AssAmt || 0).toLocaleString("en-IN")}
//                           </div>
//                         </div>
//                       </div>
//                       <div style={{ fontSize: 12, fontWeight: 700, color: "#1e40af" }}>
//                         ₹{Number(item.TotItemVal || 0).toLocaleString("en-IN")}
//                       </div>
//                     </div>
//                   );
//                 })}
//                 {items.length > 5 && (
//                   <div style={{ fontSize: 11, color: "#6b7280", textAlign: "center", padding: "4px 0" }}>
//                     + {items.length - 5} more item(s)
//                   </div>
//                 )}
//               </div>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "linear-gradient(135deg,#0f172a,#1e3a5f)", borderRadius: 9, padding: "12px 16px", marginTop: 10 }}>
//                 <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, fontWeight: 600 }}>Total Invoice Value</span>
//                 <span style={{ color: "#fbbf24", fontSize: 17, fontWeight: 700 }}>₹{Number(val.TotInvVal || 0).toLocaleString("en-IN")}</span>
//               </div>
//             </div>
//           )}

//           <div style={{ height: 16 }} />
//         </div>

//         {/* ── Footer ── */}
//         <div style={{ padding: "14px 24px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fafafa" }}>
//           <div style={{ fontSize: 12, fontWeight: 600, color: hasErrors ? "#dc2626" : "darkgreen" }}>
//             {hasErrors
//               ? `❌ ${errors.length} error${errors.length > 1 ? "s" : ""} — fix in invoice first`
//               : warnings.length > 0
//                 ? `⚠ ${warnings.length} warning${warnings.length > 1 ? "s" : ""} noted · safe to proceed`
//                 : "✅ All validations passed"}
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             {hasErrors ? (
             
//               <button
//                 onClick={onClose}
//                 style={{
//                   padding: "9px 22px", borderRadius: 8, border: "none",
//                   background: "#dc2626", color: "#fff",
//                   fontWeight: 700, fontSize: 13, cursor: "pointer",
//                   display: "flex", alignItems: "center", gap: 8,
//                   boxShadow: "0 4px 16px rgba(220,38,38,0.35)"
//                 }}
//               >
//                 🔧 Go &amp; Fix Errors
//               </button>
//             ) : (
             
//               <>
//                 <button
//                   onClick={onClose}
//                   style={{
//                     padding: "9px 22px", borderRadius: 8,
//                     border: "1.5px solid #e5e7eb", background: "#fff",
//                     color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer"
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={onProceed}
//                   style={{
//                     padding: "9px 22px", borderRadius: 8, border: "none",
//                     background: "darkgreen", color: "#fff",
//                     fontWeight: 700, fontSize: 13, cursor: "pointer",
//                     boxShadow: "0 4px 16px rgba(22,101,52,0.35)",
//                     display: "flex", alignItems: "center", gap: 8
//                   }}
//                 >
//                   ✅ Confirm &amp; Generate
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  DUPLICATE EWB POPUP — Error 604
// // ═══════════════════════════════════════════════════════════════
// function DuplicateEWBModal({ onUseExisting, onClose }) {
//   const [ewbNo,     setEwbNo]     = useState("");
//   const [ewbDt,     setEwbDt]     = useState("");
//   const [validTill, setValidTill] = useState("");
//   const [error,     setError]     = useState("");

//   const handleConfirm = () => {
//     const trimmed = ewbNo.trim();
//     if (!trimmed) { setError("Please enter the E-Way Bill Number."); return; }
//     if (!/^\d{12}$/.test(trimmed)) { setError("EWB Number must be exactly 12 digits."); return; }
//     onUseExisting({ ewbNo: trimmed, ewbDt, ewbValidTill: validTill, status: "ACT", cancelDate: null });
//   };

//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 10001, background: "rgba(0,0,0,0.65)", backdropFilter: "blur(5px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <div style={{ background: "#fff", borderRadius: 16, width: 480, boxShadow: "0 32px 80px rgba(0,0,0,0.35)", animation: "modalPop 0.28s cubic-bezier(0.34,1.56,0.64,1)", overflow: "hidden" }}>
//         <div style={{ background: "linear-gradient(135deg,#78350f,#b45309)", padding: "20px 24px", display: "flex", alignItems: "center", gap: 12 }}>
//           <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>⚠️</div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 15, color: "#fff" }}>E-Way Bill Already Generated</div>
//             <div style={{ fontSize: 12, color: "rgba(255,255,255,0.72)", marginTop: 2 }}>Error 604 — Same document number</div>
//           </div>
//         </div>
//         <div style={{ padding: "22px 24px" }}>
//           <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "12px 14px", marginBottom: 18, fontSize: 13, color: "#92400e", lineHeight: 1.6 }}>
//             GST Portal says an E-Way Bill is already generated for this document.<br />
//             <strong>Enter the existing EWB Number below</strong> to view, print, or cancel it.
//           </div>
//           <div style={{ marginBottom: 14 }}>
//             <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, letterSpacing: "0.5px", textTransform: "uppercase" }}>E-Way Bill Number <span style={{ color: "#dc2626" }}>*</span></label>
//             <input type="text" className="form-control" placeholder="Enter 12-digit EWB Number" value={ewbNo} onChange={(e) => { setEwbNo(e.target.value.replace(/\D/g, "").slice(0, 12)); setError(""); }} maxLength={12} autoFocus style={{ fontSize: 16, fontFamily: "monospace", letterSpacing: 2, fontWeight: 700 }} />
//             {error && <div style={{ color: "#dc2626", fontSize: 12, marginTop: 5 }}>⚠ {error}</div>}
//           </div>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: 20 }}>
//             <div>
//               <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, textTransform: "uppercase" }}>Generated Date (optional)</label>
//               <input type="date" className="form-control" value={ewbDt} onChange={(e) => setEwbDt(e.target.value)} style={{ fontSize: 13 }} />
//             </div>
//             <div>
//               <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, textTransform: "uppercase" }}>Valid Till (optional)</label>
//               <input type="date" className="form-control" value={validTill} onChange={(e) => setValidTill(e.target.value)} style={{ fontSize: 13 }} />
//             </div>
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button onClick={onClose} style={{ flex: 1, padding: "10px 0", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Cancel</button>
//             <button onClick={handleConfirm} style={{ flex: 1.6, padding: "10px 0", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#0f172a,#1e3a5f)", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
//               ✔ Use This EWB — Show Print &amp; Cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  SHARED CONSTANTS
// // ═══════════════════════════════════════════════════════════════
// const CANCEL_REASONS = [
//   { val: "1", label: "Duplicate" },
//   { val: "2", label: "Order Cancelled" },
//   { val: "3", label: "Data Entry Mistake" },
//   { val: "4", label: "Others" },
// ];

// const TRANS_MODES   = [{ val: "1", label: "Road" }, { val: "2", label: "Rail" }, { val: "3", label: "Air" }, { val: "4", label: "Ship" }];
// const VEHICLE_TYPES = [{ val: "R", label: "Regular" }, { val: "O", label: "Over Dimensional Cargo (ODC)" }];

// const VEHICLE_UPDATE_REASONS = [
//   { val: "1", label: "Break Down" },
//   { val: "2", label: "Trans Shipment" },
//   { val: "3", label: "Others" },
//   { val: "4", label: "First Time" },
// ];

// const EXTEND_REASONS = [
//   { val: "1",  label: "Natural Calamity" },
//   { val: "2",  label: "Law & Order Situation" },
//   { val: "3",  label: "Transhipment" },
//   { val: "4",  label: "Accident" },
//   { val: "99", label: "Others" },
// ];

// const INDIA_STATES = [
//   { val: "1",  label: "01 — Jammu & Kashmir" },
//   { val: "2",  label: "02 — Himachal Pradesh" },
//   { val: "3",  label: "03 — Punjab" },
//   { val: "4",  label: "04 — Chandigarh" },
//   { val: "5",  label: "05 — Uttarakhand" },
//   { val: "6",  label: "06 — Haryana" },
//   { val: "7",  label: "07 — Delhi" },
//   { val: "8",  label: "08 — Rajasthan" },
//   { val: "9",  label: "09 — Uttar Pradesh" },
//   { val: "10", label: "10 — Bihar" },
//   { val: "11", label: "11 — Sikkim" },
//   { val: "12", label: "12 — Arunachal Pradesh" },
//   { val: "13", label: "13 — Nagaland" },
//   { val: "14", label: "14 — Manipur" },
//   { val: "15", label: "15 — Mizoram" },
//   { val: "16", label: "16 — Tripura" },
//   { val: "17", label: "17 — Meghalaya" },
//   { val: "18", label: "18 — Assam" },
//   { val: "19", label: "19 — West Bengal" },
//   { val: "20", label: "20 — Jharkhand" },
//   { val: "21", label: "21 — Odisha" },
//   { val: "22", label: "22 — Chhattisgarh" },
//   { val: "23", label: "23 — Madhya Pradesh" },
//   { val: "24", label: "24 — Gujarat" },
//   { val: "25", label: "25 — Daman & Diu" },
//   { val: "26", label: "26 — Dadra & Nagar Haveli" },
//   { val: "27", label: "27 — Maharashtra" },
//   { val: "28", label: "28 — Andhra Pradesh (Old)" },
//   { val: "29", label: "29 — Karnataka" },
//   { val: "30", label: "30 — Goa" },
//   { val: "31", label: "31 — Lakshadweep" },
//   { val: "32", label: "32 — Kerala" },
//   { val: "33", label: "33 — Tamil Nadu" },
//   { val: "34", label: "34 — Puducherry" },
//   { val: "35", label: "35 — Andaman & Nicobar Islands" },
//   { val: "36", label: "36 — Telangana" },
//   { val: "37", label: "37 — Andhra Pradesh" },
//   { val: "38", label: "38 — Ladakh" },
//   { val: "97", label: "97 — Other Territory" },
//   { val: "99", label: "99 — Centre Jurisdiction" },
// ];

// // ═══════════════════════════════════════════════════════════════
// //  CANCEL MODAL — Others → Remarks mandatory
// // ═══════════════════════════════════════════════════════════════
// function CancelEWBModal({ ewbNo, onConfirm, onClose, onAlert }) {
//   const [reason,  setReason]  = useState("1");
//   const [remarks, setRemarks] = useState("");

//   const isOthers = reason === "4";

//   const handleConfirm = () => {
//     if (isOthers && !remarks.trim()) {
//       onAlert("Remarks is required when Cancel Reason is 'Others'.", "error");
//       return;
//     }
//     onConfirm(reason, remarks.trim() || "Cancelled by user");
//   };

//   const inputStyle = { width: "100%", padding: "8px 10px", border: "1.5px solid #d1d5db", borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" };

//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <div style={{ background: "#fff", borderRadius: 14, width: 460, padding: "32px 32px 24px", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)", border: "1px solid #fee2e2" }}>

//         {/* Header */}
//         <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: 20 }}>
//           <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#fef2f2", border: "2px solid #fecaca", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14, fontSize: 24 }}>⛔</div>
//           <div style={{ fontWeight: 700, fontSize: 17, color: "#111", marginBottom: 6 }}>Cancel E-Way Bill?</div>
//           <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>This will cancel the EWB on the GST portal. This action is permanent.</div>
//         </div>

//         {/* EWB Number chip */}
//         <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", marginBottom: 18 }}>
//           <div style={{ fontSize: 10, color: "#9ca3af", fontWeight: 700, letterSpacing: "0.8px", marginBottom: 4 }}>E-WAY BILL NUMBER</div>
//           <div style={{ fontFamily: "monospace", fontSize: 14, color: "#374151", fontWeight: 700 }}>{ewbNo}</div>
//         </div>

//         {/* Reason */}
//         <div style={{ marginBottom: 14 }}>
//           <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6, display: "block" }}>
//             Cancel Reason <span style={{ color: "#dc2626" }}>*</span>
//           </label>
//           <select
//             value={reason}
//             onChange={(e) => { setReason(e.target.value); setRemarks(""); }}
//             style={inputStyle}
//           >
//             {CANCEL_REASONS.map((r) => <option key={r.val} value={r.val}>{r.label}</option>)}
//           </select>
//         </div>

//         {/* Remarks — always visible, mandatory only for Others */}
//         <div style={{ marginBottom: 22 }}>
//           <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
//             Remarks
//             {isOthers && <span style={{ color: "#dc2626" }}>*</span>}
//             {isOthers && (
//               <span style={{ fontSize: 10, color: "#dc2626", fontWeight: 500, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 4, padding: "1px 6px" }}>
//                 Required for Others
//               </span>
//             )}
//           </label>
//           <input
//             type="text"
//             value={remarks}
//             onChange={(e) => setRemarks(e.target.value)}
//             placeholder={isOthers ? "Describe the reason for cancellation..." : "Optional remarks"}
//             maxLength={100}
//             style={{
//               ...inputStyle,
//               borderColor: isOthers && !remarks.trim() ? "#fca5a5" : "#d1d5db",
//               background:  isOthers && !remarks.trim() ? "#fff7f7" : "#fff",
//             }}
//           />
//           {isOthers && !remarks.trim() && (
//             <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>
//               ⚠ Please describe the reason before cancelling.
//             </div>
//           )}
//         </div>

//         {/* Buttons */}
//         <div style={{ display: "flex", gap: 10 }}>
//           <button
//             onClick={onClose}
//             style={{ flex: 1, padding: 11, borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
//           >
//             Keep EWB
//           </button>
//           <button
//             onClick={handleConfirm}
//             style={{ flex: 1, padding: 11, borderRadius: 8, border: "none", background: "#dc2626", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}
//           >
//             ⛔ Cancel EWB
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  UPDATE VEHICLE MODAL — Reason dropdown + Others → Remarks + State dropdown
// // ═══════════════════════════════════════════════════════════════
// function UpdateVehicleModal({ ewbNo, onConfirm, onClose, onAlert }) {
//   const [form, setForm] = useState({
//     VehicleNo: "", VehicleType: "R",
//     TransMode: "1",
//     ReasonCode: "1", Remarks: "",
//     FromPlace: "", FromState: "",
//     RemainingDistance: "",
//     TransDocNo: "", TransDocDate: "",
//   });

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const isOthers = form.ReasonCode === "3";

//   const handleConfirm = () => {
//     if (!form.VehicleNo.trim())
//       { onAlert("Vehicle Number is required.", "error"); return; }
//     if (!form.FromPlace.trim())
//       { onAlert("From Place is required.", "error"); return; }
//     if (!form.FromState)
//       { onAlert("From State is required.", "error"); return; }
//     if (isOthers && !form.Remarks.trim())
//       { onAlert("Remarks is required when reason is 'Others'.", "error"); return; }
//     onConfirm(form);
//   };

//   const inputStyle  = { width: "100%", padding: "7px 10px", border: "1.5px solid #d1d5db", borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" };
//   const labelStyle  = { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4, display: "block" };

//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <div style={{ background: "#fff", borderRadius: 14, width: 560, padding: "28px 28px 22px", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)" }}>

//         {/* Header */}
//         <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
//           <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#eff6ff", border: "2px solid #bfdbfe", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🚛</div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 16, color: "#111" }}>Update Vehicle</div>
//             <div style={{ fontSize: 12, color: "#6b7280" }}>EWB: <span style={{ fontFamily: "monospace", fontWeight: 600 }}>{ewbNo}</span></div>
//           </div>
//         </div>

//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "13px 18px", marginBottom: 18 }}>

       
//           <div>
//             <label style={labelStyle}>Vehicle No <span style={{ color: "#dc2626" }}>*</span></label>
//             <input style={inputStyle} value={form.VehicleNo} onChange={(e) => set("VehicleNo", e.target.value.toUpperCase())} placeholder="e.g. TN38AK1234" maxLength={20} />
//           </div>
//           <div>
//             <label style={labelStyle}>Vehicle Type</label>
//             <select style={inputStyle} value={form.VehicleType} onChange={(e) => set("VehicleType", e.target.value)}>
//               {VEHICLE_TYPES.map((v) => <option key={v.val} value={v.val}>{v.label}</option>)}
//             </select>
//           </div>

          
//           <div>
//             <label style={labelStyle}>Transport Mode</label>
//             <select style={inputStyle} value={form.TransMode} onChange={(e) => set("TransMode", e.target.value)}>
//               {TRANS_MODES.map((m) => <option key={m.val} value={m.val}>{m.label}</option>)}
//             </select>
//           </div>
//           <div>
//             <label style={labelStyle}>Update Reason <span style={{ color: "#dc2626" }}>*</span></label>
//             <select style={inputStyle} value={form.ReasonCode} onChange={(e) => { set("ReasonCode", e.target.value); set("Remarks", ""); }}>
//               {VEHICLE_UPDATE_REASONS.map((r) => <option key={r.val} value={r.val}>{r.label}</option>)}
//             </select>
//           </div>

//           {/* Others Remarks — full width, conditional */}
//           {isOthers && (
//             <div style={{ gridColumn: "1/-1" }}>
//               <label style={{ ...labelStyle, display: "flex", alignItems: "center", gap: 6 }}>
//                 Remarks <span style={{ color: "#dc2626" }}>*</span>
//                 <span style={{ fontSize: 10, color: "#dc2626", fontWeight: 500, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 4, padding: "1px 6px" }}>
//                   Required for Others
//                 </span>
//               </label>
//               <input
//                 style={{ ...inputStyle, borderColor: !form.Remarks.trim() ? "#fca5a5" : "#d1d5db", background: !form.Remarks.trim() ? "#fff7f7" : "#fff" }}
//                 value={form.Remarks}
//                 onChange={(e) => set("Remarks", e.target.value)}
//                 placeholder="Describe reason for vehicle update..."
//                 maxLength={100}
//                 autoFocus
//               />
//               {!form.Remarks.trim() && (
//                 <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>⚠ Please describe the reason.</div>
//               )}
//             </div>
//           )}

//           {/* Row 3 — From Place + From State (Dropdown) */}
//           <div>
//             <label style={labelStyle}>From Place <span style={{ color: "#dc2626" }}>*</span></label>
//             <input style={inputStyle} value={form.FromPlace} onChange={(e) => set("FromPlace", e.target.value)} placeholder="City / Town" maxLength={50} />
//           </div>
//           <div>
//             <label style={labelStyle}>From State <span style={{ color: "#dc2626" }}>*</span></label>
//             <select style={inputStyle} value={form.FromState} onChange={(e) => set("FromState", e.target.value)}>
//               <option value="">— Select State —</option>
//               {INDIA_STATES.map((s) => <option key={s.val} value={s.val}>{s.label}</option>)}
//             </select>
//           </div>

//           {/* Row 4 — Remaining Distance + Trans Doc No */}
//           <div>
//             <label style={labelStyle}>Remaining Distance (KM)</label>
//             <input style={inputStyle} type="number" value={form.RemainingDistance} onChange={(e) => set("RemainingDistance", e.target.value)} placeholder="e.g. 200" min={0} />
//           </div>
//           <div>
//             <label style={labelStyle}>Trans Doc No</label>
//             <input style={inputStyle} value={form.TransDocNo} onChange={(e) => set("TransDocNo", e.target.value)} placeholder="Optional" maxLength={15} />
//           </div>

//           {/* Row 5 — Trans Doc Date */}
//           <div style={{ gridColumn: "1/-1" }}>
//             <label style={labelStyle}>Trans Doc Date</label>
//             <input style={inputStyle} type="date" value={form.TransDocDate} onChange={(e) => set("TransDocDate", e.target.value)} max={new Date().toISOString().split("T")[0]} />
//           </div>
//         </div>

//         {/* Buttons */}
//         <div style={{ display: "flex", gap: 10 }}>
//           <button onClick={onClose} style={{ flex: 1, padding: 11, borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
//             Cancel
//           </button>
//           <button onClick={handleConfirm} style={{ flex: 1, padding: 11, borderRadius: 8, border: "none", background: "#1d4ed8", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
//             🚛 Update Vehicle
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  EXTEND VALIDITY MODAL — Others → ExtnRemarks + State dropdown
// // ═══════════════════════════════════════════════════════════════
// function ExtendModal({ ewbNo, onConfirm, onClose, onAlert }) {
//   const [form, setForm] = useState({
//     VehicleNo: "", VehicleType: "R",
//     TransMode: "1", Consignment: "M",
//     FromPlace: "", FromState: "", FromPincode: "",
//     RemainingDistance: "",
//     ExtnRsnCode: "1", ExtnRemarks: "",
//     TransDocNo: "", TransDocDate: "",
//   });

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const isOthers = form.ExtnRsnCode === "99";

//   const handleConfirm = () => {
//     if (!form.VehicleNo.trim())
//       { onAlert("Vehicle Number is required.", "error"); return; }
//     if (!form.FromPlace.trim())
//       { onAlert("From Place is required.", "error"); return; }
//     if (!form.FromState)
//       { onAlert("From State is required.", "error"); return; }
//     if (!form.FromPincode || String(form.FromPincode).length !== 6)
//       { onAlert("From Pincode must be exactly 6 digits.", "error"); return; }
//     if (!form.RemainingDistance || Number(form.RemainingDistance) <= 0)
//       { onAlert("Remaining Distance (KM) must be greater than 0.", "error"); return; }
//     if (isOthers && !form.ExtnRemarks.trim())
//       { onAlert("Remarks is required when Extension Reason is 'Others'.", "error"); return; }
//     onConfirm(form);
//   };

//   const inputStyle = { width: "100%", padding: "7px 10px", border: "1.5px solid #d1d5db", borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" };
//   const labelStyle = { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4, display: "block" };

//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <div style={{ background: "#fff", borderRadius: 14, width: 580, padding: "28px 28px 22px", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)", maxHeight: "92vh", overflowY: "auto" }}>

//         {/* Header */}
//         <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
//           <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#f0fdf4", border: "2px solid #bbf7d0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>⏳</div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 16, color: "#111" }}>Extend EWB Validity</div>
//             <div style={{ fontSize: 12, color: "#6b7280" }}>EWB: <span style={{ fontFamily: "monospace", fontWeight: 600 }}>{ewbNo}</span></div>
//           </div>
//         </div>

//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "13px 18px", marginBottom: 18 }}>

//           {/* Row 1 — Vehicle No + Type */}
//           <div>
//             <label style={labelStyle}>Vehicle No <span style={{ color: "#dc2626" }}>*</span></label>
//             <input style={inputStyle} value={form.VehicleNo} onChange={(e) => set("VehicleNo", e.target.value.toUpperCase())} placeholder="e.g. TN38AK1234" maxLength={20} />
//           </div>
//           <div>
//             <label style={labelStyle}>Vehicle Type</label>
//             <select style={inputStyle} value={form.VehicleType} onChange={(e) => set("VehicleType", e.target.value)}>
//               {VEHICLE_TYPES.map((v) => <option key={v.val} value={v.val}>{v.label}</option>)}
//             </select>
//           </div>

//           {/* Row 2 — Trans Mode + Consignment */}
//           <div>
//             <label style={labelStyle}>Transport Mode</label>
//             <select style={inputStyle} value={form.TransMode} onChange={(e) => set("TransMode", e.target.value)}>
//               {TRANS_MODES.map((m) => <option key={m.val} value={m.val}>{m.label}</option>)}
//             </select>
//           </div>
//           <div>
//             <label style={labelStyle}>Consignment Type</label>
//             <select style={inputStyle} value={form.Consignment} onChange={(e) => set("Consignment", e.target.value)}>
//               <option value="M">Moving (M)</option>
//               <option value="T">In Transit (T)</option>
//               <option value="O">Others (O)</option>
//             </select>
//           </div>

//           {/* Row 3 — From Place + From State (Dropdown) */}
//           <div>
//             <label style={labelStyle}>From Place <span style={{ color: "#dc2626" }}>*</span></label>
//             <input style={inputStyle} value={form.FromPlace} onChange={(e) => set("FromPlace", e.target.value)} placeholder="City / Town" maxLength={50} />
//           </div>
//           <div>
//             <label style={labelStyle}>From State <span style={{ color: "#dc2626" }}>*</span></label>
//             <select style={inputStyle} value={form.FromState} onChange={(e) => set("FromState", e.target.value)}>
//               <option value="">— Select State —</option>
//               {INDIA_STATES.map((s) => <option key={s.val} value={s.val}>{s.label}</option>)}
//             </select>
//           </div>

//           {/* Row 4 — From Pincode + Remaining Distance */}
//           <div>
//             <label style={labelStyle}>From Pincode <span style={{ color: "#dc2626" }}>*</span></label>
//             <input
//               style={inputStyle}
//               type="text"
//               inputMode="numeric"
//               value={form.FromPincode}
//               onChange={(e) => set("FromPincode", e.target.value.replace(/\D/g, "").slice(0, 6))}
//               placeholder="e.g. 641001"
//               maxLength={6}
//             />
//           </div>
//           <div>
//             <label style={labelStyle}>Remaining Distance (KM) <span style={{ color: "#dc2626" }}>*</span></label>
//             <input style={inputStyle} type="number" value={form.RemainingDistance} onChange={(e) => set("RemainingDistance", e.target.value)} placeholder="e.g. 150" min={1} />
//           </div>

//           {/* Row 5 — Extension Reason + Trans Doc No */}
//           <div>
//             <label style={labelStyle}>Extension Reason <span style={{ color: "#dc2626" }}>*</span></label>
//             <select style={inputStyle} value={form.ExtnRsnCode} onChange={(e) => { set("ExtnRsnCode", e.target.value); set("ExtnRemarks", ""); }}>
//               {EXTEND_REASONS.map((r) => <option key={r.val} value={r.val}>{r.label}</option>)}
//             </select>
//           </div>
//           <div>
//             <label style={labelStyle}>Trans Doc No</label>
//             <input style={inputStyle} value={form.TransDocNo} onChange={(e) => set("TransDocNo", e.target.value)} placeholder="Optional" maxLength={15} />
//           </div>

//           {/* Others Remarks — full width, conditional */}
//           {isOthers && (
//             <div style={{ gridColumn: "1/-1" }}>
//               <label style={{ ...labelStyle, display: "flex", alignItems: "center", gap: 6 }}>
//                 Extension Remarks <span style={{ color: "#dc2626" }}>*</span>
//                 <span style={{ fontSize: 10, color: "#dc2626", fontWeight: 500, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 4, padding: "1px 6px" }}>
//                   Required for Others
//                 </span>
//               </label>
//               <input
//                 style={{ ...inputStyle, borderColor: !form.ExtnRemarks.trim() ? "#fca5a5" : "#d1d5db", background: !form.ExtnRemarks.trim() ? "#fff7f7" : "#fff" }}
//                 value={form.ExtnRemarks}
//                 onChange={(e) => set("ExtnRemarks", e.target.value)}
//                 placeholder="Describe reason for validity extension..."
//                 maxLength={100}
//                 autoFocus
//               />
//               {!form.ExtnRemarks.trim() && (
//                 <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>⚠ Please describe the reason before extending.</div>
//               )}
//             </div>
//           )}

//           {/* Trans Doc Date — full width */}
//           <div style={{ gridColumn: "1/-1" }}>
//             <label style={labelStyle}>Trans Doc Date</label>
//             <input style={inputStyle} type="date" value={form.TransDocDate} onChange={(e) => set("TransDocDate", e.target.value)} max={new Date().toISOString().split("T")[0]} />
//           </div>
//         </div>

//         {/* Buttons */}
//         <div style={{ display: "flex", gap: 10 }}>
//           <button onClick={onClose} style={{ flex: 1, padding: 11, borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
//             Cancel
//           </button>
//           <button onClick={handleConfirm} style={{ flex: 1, padding: 11, borderRadius: 8, border: "none", background: "#16a34a", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
//             ⏳ Extend Validity
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  COPY EWB NUMBER
// // ═══════════════════════════════════════════════════════════════
// function CopyEWBNo({ ewbNo }) {
//   const [copied, setCopied] = useState(false);
//   const copy = () => {
//     if (!ewbNo) return;
//     navigator.clipboard?.writeText(ewbNo)
//       .then(() => { setCopied(true); setTimeout(() => setCopied(false), 1800); })
//       .catch(() => {
//         const el = document.createElement("textarea");
//         el.value = ewbNo;
//         document.body.appendChild(el);
//         el.select();
//         document.execCommand("copy");
//         document.body.removeChild(el);
//         setCopied(true);
//         setTimeout(() => setCopied(false), 1800);
//       });
//   };
//   return (
//     <button onClick={copy} title={copied ? "Copied!" : "Copy EWB No"} style={{ background: "none", border: "none", cursor: "pointer", padding: "2px 6px", borderRadius: 5, color: copied ? "#16a34a" : "#64748b", fontSize: 15, transition: "color 0.2s" }}>
//       {copied ? "✔" : "⎘"}
//     </button>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  FORMAT DATE HELPER
// // ═══════════════════════════════════════════════════════════════
// function formatEWBDate(raw) {
//   if (!raw) return "";
//   try {
//     const str = String(raw).trim();

//     // ── Format 1: "22/05/2026 11:59:00 PM"  or  "20/05/2026 11:48:00 AM"
//     const m1 = str.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?)?$/i);
//     if (m1) {
//       const [, dd, mm, yyyy, hRaw, min, ampm] = m1;
//       const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
//       const monStr = months[parseInt(mm, 10) - 1] || mm;
//       if (hRaw) {
//         let h = parseInt(hRaw, 10);
//         const ap = (ampm || "").toUpperCase();
//         if (ap === "PM" && h < 12) h += 12;
//         if (ap === "AM" && h === 12) h = 0;
//         const hDisp = h % 12 === 0 ? 12 : h % 12;
//         const suffix = h < 12 ? "AM" : "PM";
//         return `${dd} ${monStr} ${yyyy} · ${String(hDisp).padStart(2,"0")}:${min} ${suffix}`;
//       }
//       return `${dd} ${monStr} ${yyyy}`;
//     }

//     // ── Format 2: "2026-05-20T11:48:00" or "2026-05-20 11:48:00 AM"
//     const parts = str.replace("T", " ").split(" ");
//     const datePart = parts[0] || "";
//     const timePart = parts[1] || "";
//     const ampm     = parts[2] || "";

//     let d;
//     if (datePart.includes("/")) {
//       const [dd, mm, yyyy] = datePart.split("/");
//       d = new Date(`${yyyy}-${mm}-${dd}`);
//     } else {
//       d = new Date(datePart);
//     }
//     if (isNaN(d)) return raw;

//     const day = String(d.getDate()).padStart(2, "0");
//     const mon = d.toLocaleString("en-IN", { month: "short" });
//     const yr  = d.getFullYear();

//     const timeStr = timePart
//       ? ` · ${timePart.substring(0, 5)}${ampm ? " " + ampm : ""}`
//       : "";

//     return `${day} ${mon} ${yr}${timeStr}`;
//   } catch { return raw; }
// }

// // ═══════════════════════════════════════════════════════════════
// //  MAIN COMPONENT — EWayBill
// // ═══════════════════════════════════════════════════════════════
// function EWayBill() {
//   const dispatch     = useDispatch();
//   const _Common      = useSelector((store) => store.states.Common);
//   const _HT          = useSelector((store) => store.states.Header);
//   const _selecrparem = useSelector((state) => state.SelectOption.parems);

//   // ── States ─────────────────────────────────────────────────
//   const [iScrId,        setiScrId]        = useState(0);
//   const [isSetting,     setisSetting]     = useState(false);
//   const [iAreaId,       setiAreaId]       = useState(0);
//   const [iColId,        setiColId]        = useState(0);
//   const [strColName,    setstrColName]    = useState("");
//   const [strAliasName,  setstrAliasName]  = useState("");
//   const [strDatatype,   setstrDatatype]   = useState("string");
//   const [strTransName,  setstrTransName]  = useState("");
//   const [strdefaultval, setstrdefaultval] = useState("");
//   const [strval,        setstrval]        = useState("");
//   const [isShow,        setisShow]        = useState(true);

//   const [ListEntItem, setListEntItem] = useState([]);
//   const [arrEntArea,  setarrEntArea]  = useState([]);
//   const [arrEntCol,   setarrEntCol]   = useState([]);
//   const [EntJsonEwb,  setEntJsonEwb]  = useState([]);

//   // ── EWB Response ────────────────────────────────────────────
//   const [ewbResp, setEwbResp] = useState(null);

//   // ── Modal states ────────────────────────────────────────────
//   const [showCancelModal,    setShowCancelModal]    = useState(false);
//   const [showVehicleModal,   setShowVehicleModal]   = useState(false);
//   const [showExtendModal,    setShowExtendModal]    = useState(false);
//   const [showDuplicateModal, setShowDuplicateModal] = useState(false);

//   // ── Credential popup ────────────────────────────────────────
//   const [showCredPopup, setShowCredPopup] = useState(false);
//   const [nicCred,       setNicCred]       = useState({ ApiUserName: "", ApiPassword: "" });
//   const [credSaving,    setCredSaving]    = useState(false);

//   // ── Validation modal (exact EInvoice flow) ──────────────────
//   const [showValidModal, setShowValidModal] = useState(false);
//   const [validErrors,    setValidErrors]    = useState([]);
//   const [validWarnings,  setValidWarnings]  = useState([]);

//   // ── Toast ───────────────────────────────────────────────────
//   const [toasts, setToasts] = useState([]);
//   const showToast = useCallback((message, type = "success", duration = 3500) => {
//     const id = Date.now() + Math.random();
//     setToasts((prev) => [...prev, { id, message, type }]);
//     setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), duration);
//   }, []);
//   const dismissToast = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

//   // ── Alert helper ────────────────────────────────────────────
//   const AlertMessage = (Message, Icon) => {
//     dispatch(Show_MsgBox({ Message, Type: Icon, isMsg: true }));
//   };

//   // ── Status helpers ──────────────────────────────────────────
//   const hasEWBNo    = ewbResp?.ewbNo;
//   const isActive    = hasEWBNo && ewbResp?.status !== "CNL";
//   const isCancelled = hasEWBNo && ewbResp?.status === "CNL";

 
//   // Parent already passes the correct SelectedVouchId at mount time
//   useEffect(() => {
//     Load_EWayBill(_Common.iScrId, _HT.SelectedVouchId);
//   }, []);

//   // ──────────────────────────────────────────────────────────────
//   //  LOAD
//   // ──────────────────────────────────────────────────────────────
//   const Load_EWayBill = async (ScrId, VouchId) => {
//     try {
//       setiScrId(ScrId);
//       dispatch(setload_Screen(true));
//       const Res = await userApp.get(
//         `GST/Load_EWayBill/${ScrId}/${VouchId}/${Number(localStorage.ComId)}/${Number(localStorage.FYId)}/${localStorage.db}/${localStorage.Msdb}`
//       );
//       if (Res.data.strStatus === "Success") {
//         await AssignVoucher_Data(ScrId, Res.data);
//         const ewb = Res.data.EWayBill || Res.data.eWayBill || null;
//         // DB returns PascalCase (EwbNo, EwbDt, EwbValidTill, Status, CancelDate)
//         // check both cases so either works
//         const ewbNo = ewb?.EwbNo || ewb?.ewbNo || "";
// if (ewb && ewbNo) {
//   setEwbResp(prev => ({
//     ...(prev || {}),
//     ewbNo:        ewb.EwbNo        || ewb.ewbNo        || "",
//     ewbDt:        ewb.EwbDt        || ewb.ewbDt        || "",
//     ewbValidTill: ewb.EwbValidTill || ewb.ewbValidTill || "",
//     status:       ewb.Status       || ewb.status       || "ACT",
//     cancelDate:   ewb.CancelDate   || ewb.cancelDate   || null,
//     vehicleNo:    ewb.VehicleNo    || ewb.vehicleNo    || prev?.vehicleNo || "",
//     transMode:    ewb.TransMode    || ewb.transMode    || prev?.transMode || "",
//     vehicleType:  ewb.VehicleType  || ewb.vehicleType  || prev?.vehicleType || "",
//     transDocNo:   ewb.TransDocNo   || ewb.transDocNo   || prev?.transDocNo || "",
//     transDocDate: ewb.TransDocDate || ewb.transDocDate || prev?.transDocDate || "",
//     // ── EInvoice-linked fields (null if normal EWB) ──
//     distance:     Number(ewb.Distance || ewb.distance || 0) || prev?.distance || 0,
//     irn:   ewb.Irn   || ewb.irn   || null,
//     ackNo: ewb.AckNo || ewb.ackNo || null,
//     ackDt: ewb.AckDt || ewb.ackDt || null,
//   }));
// } else {
//           setEwbResp(null);   // this invoice has no EWB — safe to clear now
//         }
//       } else {
//         setEwbResp(null);
//       }
//     } catch (err) {
//       showToast(err?.message || "Failed to load E-Way Bill data.", "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  ASSIGN VOUCHER DATA
//   // ──────────────────────────────────────────────────────────────
//   const AssignVoucher_Data = async (ScrId, InvtDT) => {
//     const EntArea    = InvtDT.EntArea;
//     const EntCol     = InvtDT.EntCol;
//     const EntTax     = InvtDT.objEntTax;
//     const EntSummary = InvtDT.objEntSummary;
//     let   Summary    = EntSummary[0];
//     const EntHT      = InvtDT.objEntHT;
//     const EntParty   = InvtDT.Party;
//     const EntShipAdd = InvtDT.EntShippingAdd;
//     const EntCompany = InvtDT.Company;
//     const EntItem    = InvtDT.objEntDT;
//     const TaxRelId       = EntHT[0].iTaxTypeId;
//     const iTCSApplicable = EntHT[0].iTCSApplicable;

//     let dSGST = 0, dCGST = 0, dIGST = 0, dCESS = 0, dTCS = 0;

//     const checkbuyerseller = (arrParty, arrcompany, type) => {
//       switch (ScrId) {
//         case 11: return type === "Sell" ? arrParty   : arrcompany;
//         case 17: return type === "Sell" ? arrcompany : arrParty;
//         case 67: return type === "Sell" ? arrcompany : arrParty;
//         case 73: return type === "Sell" ? arrcompany : arrParty;
//         case 76: return type === "Sell" ? arrParty   : arrcompany;
//         case 78: return type === "Sell" ? arrParty   : arrcompany;
//         default: return type === "Sell" ? arrParty   : arrcompany; // ✅ safe fallback — no undefined crash
//       }
//     };

//     EntTax.forEach((dt) => {
//       if      (dt.taxDesc.startsWith("SGST") && TaxRelId === 1) dSGST += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("CGST") && TaxRelId === 1) dCGST += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("IGST") && TaxRelId === 2) dIGST += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("CESS"))                   dCESS += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("TCS") && iTCSApplicable === 1) dTCS += dt.taxAmt;
//     });

//     Summary = { ...Summary, sgst: dSGST, cgst: dCGST, igst: dIGST, cess: dCESS, tcs: dTCS };

//     const objData = [
//       { iAreaId: 1, data: EntHT[0] },
//       { iAreaId: 2, data: EntHT[0] },
//       { iAreaId: 3, data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell") },
//       { iAreaId: 4, data: checkbuyerseller(EntParty[0], EntCompany[0], "Buy") },
//       { iAreaId: 5, data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell") },
//       { iAreaId: 6, data: EntShipAdd || EntParty[0] || {} },
//       { iAreaId: 7, data: Summary },
//       { iAreaId: 8, data: EntHT[0] },
//       { iAreaId: 9, data: EntItem },
//     ];

//     let objEwb = {};

//     EntArea.forEach((area) => {
//       const AreaCol = EntCol.filter((col) => col.iAreaId === area.iAreaId);
//       const Entdt   = objData.filter((col) => col.iAreaId === area.iAreaId)[0].data;

//       if (area.iAreaId !== 9) {
//         let objDT = {};
//         AreaCol.forEach((col) => {
//           if (col.strConditionCol === "") {
//             if (col.strdatatype === "cmb")
//               objDT = { ...objDT, [col.strGstcolName]: col.strValue };
//             else if (col.strdatatype === "decimal")
//               objDT = { ...objDT, [col.strGstcolName]: Number(col.strdefaultvalue) };
//             else
//               objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
//           } else {
//             let value = Entdt[col.strConditionCol];
//             if (col.strGstcolName === "docDate" || col.strGstcolName === "transDocDate") {
//               if (value) {
//                 const dt = new Date(value);
//                 if (!isNaN(dt))
//                   value = `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
//                 else value = "";
//               }
//             } else if (["fromPincode", "toPincode", "fromStateCode", "toStateCode"].includes(col.strGstcolName)) {
//               value = value ? String(value) : "";
//             } else if (col.strdatatype === "decimal") {
//               value = value ? Number(value) : 0;
//             }
//             objDT = { ...objDT, [col.strGstcolName]: value };
//           }
//         });
//         objEwb = { ...objEwb, [area.strAreaCol]: objDT };
//       } else {
//         const arrItem = [];
//         Entdt.forEach((dt) => {
//           let objDT = {};
//           AreaCol.forEach((col) => {
//             if (col.strConditionCol === "") {
//               if (col.strdatatype === "decimal") {
//                 switch (col.strGstcolName) {
//                   case "igstRate":
//                     if (TaxRelId === 2) objDT = { ...objDT, [col.strGstcolName]: Number(dt.taxAmt) };
//                     break;
//                   case "cgstRate":
//                   case "sgstRate":
//                     if (TaxRelId === 1) objDT = { ...objDT, [col.strGstcolName]: Number(dt.taxAmt / 2) };
//                     break;
//                   default:
//                     objDT = { ...objDT, [col.strGstcolName]: Number(col.strdefaultvalue) };
//                     break;
//                 }
//               } else {
//                 objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
//               }
//             } else {
//               let v = dt[col.strConditionCol];
//               if (col.strdatatype === "decimal") v = v ? Number(v) : 0;
//               else if (col.strGstcolName === "hsnCode") {
//                 v = v ? String(v) : null;
//                 if (v && v.length > 8) v = v.substring(0, 8);
//               }
//               objDT = { ...objDT, [col.strGstcolName]: v };
//             }
//           });
//           arrItem.push(objDT);
//         });
//         setListEntItem(arrItem);
//         objEwb = { ...objEwb, itemList: arrItem };
//       }
//     });

//     if (objEwb.DocDtls?.Dt?.includes("-")) {
//       const p = objEwb.DocDtls.Dt.split("-");
//       if (p.length === 3) objEwb.DocDtls.Dt = `${p[2]}/${p[1]}/${p[0]}`;
//     }
//     if (objEwb.docDetails?.docDate?.includes("-")) {
//       const p = objEwb.docDetails.docDate.split("-");
//       if (p.length === 3) objEwb.docDetails.docDate = `${p[2]}/${p[1]}/${p[0]}`;
//     }

//     await View_Distance(objEwb);
//     setarrEntArea(EntArea);
//     setarrEntCol(EntCol);
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  DISTANCE CALCULATION
//   // ──────────────────────────────────────────────────────────────
//   const View_Distance = async (objEwb) => {
//     try {
//       const p1 = objEwb["SellerDtls"]?.["Pin"] || objEwb["fromDetails"]?.["fromPincode"];
//       const p2 = objEwb["ShipDtls"]?.["Pin"]   || objEwb["BuyerDtls"]?.["Pin"] || objEwb["toDetails"]?.["toPincode"];

//       if (!objEwb["EwbDtls"]) objEwb["EwbDtls"] = {};

//       if (!p1 || !p2) {
//         objEwb["EwbDtls"]["Distance"] = 0;
//       } else {
//         const c1 = await fetchCoordinates(p1);
//         const c2 = await fetchCoordinates(p2);
//         if (!c1 || !c2) {
//           objEwb["EwbDtls"]["Distance"] = 0;
//         } else {
//           let roadDistance = 0;
//           try {
//             const osrmRes  = await fetch(`https://router.project-osrm.org/route/v1/driving/${c1.lon},${c1.lat};${c2.lon},${c2.lat}?overview=false`);
//             const osrmData = await osrmRes.json();
//             if (osrmData.code === "Ok" && osrmData.routes?.length > 0)
//               roadDistance = Math.round(osrmData.routes[0].distance / 1000);
//             else throw new Error("OSRM no route");
//           } catch {
//             const R = 6371e3,
//               φ1 = (c1.lat * Math.PI) / 180, φ2 = (c2.lat * Math.PI) / 180,
//               Δφ = ((c2.lat - c1.lat) * Math.PI) / 180,
//               Δλ = ((c2.lon - c1.lon) * Math.PI) / 180;
//             const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
//             roadDistance = Math.round(((R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) / 1000) * 1.35);
//           }
//           objEwb["EwbDtls"]["Distance"] = roadDistance;
//         }
//       }
//       setEntJsonEwb([objEwb]);
//     } catch (err) {
//       showToast(err.message, "error");
//       setEntJsonEwb([objEwb]);
//     }
//   };

//   const fetchCoordinates = async (pincode) => {
//     try {
//       const res  = await fetch(`https://nominatim.openstreetmap.org/search?q=${pincode}&countrycodes=in&format=json`);
//       const data = await res.json();
//       return data?.length > 0 ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) } : null;
//     } catch { return null; }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  INPUT CHANGE
//   // ──────────────────────────────────────────────────────────────
//   const Input_Onchange = (val, element, area) => {
//     setEntJsonEwb((prev) => {
//       const arrJson = prev.map((json) => {
//         const updated = { ...json };
//         switch (element.strdatatype) {
//           case "decimal":
//             updated[area.strAreaCol] = { ...updated[area.strAreaCol], [element.strGstcolName]: Number(val) };
//             break;
//           default:
//             updated[area.strAreaCol] = { ...updated[area.strAreaCol], [element.strGstcolName]: val };
//             break;
//         }
//         return updated;
//       });
//       if (element.strGstcolName === "Pin" && String(val).length === 6) {
//         const updatedEwb = arrJson[0];
//         if (updatedEwb) setTimeout(() => View_Distance(updatedEwb), 0);
//       }
//       return arrJson;
//     });
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  VALIDATE — full NIC EWB rules
//   // ──────────────────────────────────────────────────────────────
//   const validateEWayBill = () => {
//     const ewb = EntJsonEwb?.[0];
//     const errors = [], warnings = [];

//     if (!ewb) {
//       errors.push("EWB data not loaded. Please refresh and try again.");
//       return { errors, warnings };
//     }

//     // ── Document ──────────────────────────────────────────────
//     const docNo = ewb.DocDtls?.No || "";
//     if (!docNo)
//       errors.push("Invoice / Document Number is missing.");
//     else if (!/^([a-zA-Z1-9]{1}[a-zA-Z0-9\/\-]{0,15})$/.test(docNo.trim()))
//       errors.push(`Invoice Number "${docNo}" is invalid — only letters, numbers, / and - allowed. Max 16 chars.`);

//     if (!ewb.DocDtls?.Dt) errors.push("Document Date is missing.");

//     // ── From (Seller) ─────────────────────────────────────────
//     const fromGstin = ewb.SellerDtls?.Gstin || "";
//     if (fromGstin && fromGstin.length !== 15 && fromGstin !== "URP")
//       errors.push(`Supplier GSTIN "${fromGstin}" must be 15 characters or 'URP'.`);

//     const fromPin = String(ewb.SellerDtls?.Pin || "");
//     if (!fromPin || fromPin.length !== 6 || isNaN(fromPin))
//       errors.push(`From Pincode "${fromPin || "empty"}" must be exactly 6 digits.`);

//     // ── To (Buyer) ────────────────────────────────────────────
//     const toGstin = ewb.BuyerDtls?.Gstin || "";
//     if (!toGstin)
//       errors.push("Recipient GSTIN is missing.");
//     else if (toGstin.length !== 15 && toGstin !== "URP")
//       errors.push(`Recipient GSTIN "${toGstin}" must be 15 characters or 'URP'.`);

//     const toPin = String(ewb.BuyerDtls?.Pin || "");
//     if (!toPin || toPin.length !== 6 || isNaN(toPin))
//       errors.push(`To Pincode "${toPin || "empty"}" must be exactly 6 digits.`);

//     // ── EWB Transport Details ─────────────────────────────────
//     const ewbDtls = ewb.EwbDtls;
//     if (ewbDtls) {
//       const transMode = String(ewbDtls.TransMode || "").trim();
//       if (!transMode)
//         errors.push("Transport Mode is missing — select: 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).");
//       else if (!["1", "2", "3", "4"].includes(transMode))
//         errors.push(`Transport Mode "${transMode}" is invalid — must be 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).`);

//       const vehNo = String(ewbDtls.VehNo || "").trim();
//       if (!vehNo)
//         warnings.push("Vehicle Number is empty — NIC may require it for Road transport.");
//       else if (vehNo.length < 4)
//         errors.push(`Vehicle Number "${vehNo}" is too short — minimum 4 characters required.`);
//       else if (vehNo.length > 20)
//         errors.push(`Vehicle Number "${vehNo}" is too long — maximum 20 characters allowed.`);
//       else if (!/^[A-Z0-9]+$/i.test(vehNo))
//         errors.push(`Vehicle Number "${vehNo}" contains invalid characters — only letters and numbers allowed.`);

//       const distance = Number(ewbDtls.Distance || 0);
//       if (distance <= 0)
//         warnings.push("Distance is 0 km — verify that seller and buyer pincodes are correct.");
//       else if (distance > 4000)
//         warnings.push(`Distance of ${distance} km seems unusually high — please verify pincodes.`);

//       const vehType = ewbDtls.VehType || "";
//       if (vehType && !["R", "O"].includes(vehType))
//         errors.push(`Vehicle Type "${vehType}" is invalid — must be R (Regular) or O (ODC).`);

//       const transDocNo = String(ewbDtls.TransDocNo || "").trim();
//       if (transDocNo && (transDocNo.length < 1 || transDocNo.length > 15))
//         errors.push(`Transport Document No "${transDocNo}" must be between 1 and 15 characters.`);
//     }

//     // ── Items ─────────────────────────────────────────────────
//     const items = ewb.itemList || [];
//     if (!items.length)
//       errors.push("No items found — at least 1 item is required.");
//     else if (items.length > 250)
//       errors.push(`Invoice has ${items.length} items — NIC EWB allows maximum 250 items.`);
//     else {
//       items.forEach((item, i) => {
//         const n    = i + 1;
//         const name = item.PrdDesc || `Item ${n}`;
//         const hsnCd = String(item.HsnCd || "").trim();
//         if (!hsnCd)
//           errors.push(`Item ${n} (${name}): HSN Code is missing.`);
//         else if (!/^\d+$/.test(hsnCd))
//           errors.push(`Item ${n} (${name}): HSN Code must contain digits only.`);
//         else if (hsnCd.length < 4 || hsnCd.length > 8)
//           errors.push(`Item ${n} (${name}): HSN Code must be 4–8 digits.`);

//         if (!(Number(item.AssAmt ?? item.TotAmt ?? 0) > 0))
//           errors.push(`Item ${n} (${name}): Taxable Amount must be greater than 0.`);
//         if (!(Number(item.Qty || 0) > 0))
//           errors.push(`Item ${n} (${name}): Quantity must be greater than 0.`);
//       });
//     }

//     // ── Value Details ─────────────────────────────────────────
//     if (!(Number(ewb.ValDtls?.TotInvVal || 0) > 0))
//       errors.push("Total Invoice Value must be greater than 0.");

//     return { errors, warnings };
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  HANDLE GENERATE CLICK — exact EInvoice flow
//   //  1. guard: already generated?  2. validate  3. open ValidationModal
//   // ──────────────────────────────────────────────────────────────
//   const Handle_Generate_Click = () => {
//     // ── GUARD: EWB already exists for this invoice ──────────────
//     if (ewbResp?.ewbNo) {
//       showToast(
//         `E-Way Bill ${ewbResp.ewbNo} already generated for this invoice. Use Print / Cancel / Extend buttons.`,
//         "warning",
//         5000
//       );
//       return;
//     }
//     const { errors, warnings } = validateEWayBill();
//     setValidErrors(errors);
//     setValidWarnings(warnings);
//     setShowValidModal(true);
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  BUILD EWB PAYLOAD
//   // ──────────────────────────────────────────────────────────────
//   const buildEwbPayload = (ewb) => {
//     const toEwbDate = (d) => {
//       if (!d) return "";
//       if (d.includes("-")) { const [y, m, dd] = d.split("-"); return `${dd}/${m}/${y}`; }
//       return d;
//     };
//     return {
//       supplyType:        "O",
//       subSupplyType:     "1",
//       docType:           ewb.DocDtls?.Typ  || "INV",
//       docNo:             ewb.DocDtls?.No   || "",
//       docDate:           toEwbDate(ewb.DocDtls?.Dt || ""),

//       fromGstin:         ewb.SellerDtls?.Gstin  || "",
//       fromTrdName:       ewb.SellerDtls?.TrdNm  || "",
//       fromAddr1:         ewb.SellerDtls?.Addr1  || "",
//       fromAddr2:         ewb.SellerDtls?.Addr2  || "",
//       fromPlace:         ewb.SellerDtls?.Loc    || "",
//       fromPincode:       Number(ewb.SellerDtls?.Pin)  || 0,
//       fromStateCode:     Number(ewb.SellerDtls?.Stcd) || 0,
//       actFromStateCode:  Number(ewb.SellerDtls?.Stcd) || 0,

//       toGstin:           ewb.BuyerDtls?.Gstin   || "",
//       toTrdName:         ewb.BuyerDtls?.TrdNm   || "",
//       toAddr1:           ewb.BuyerDtls?.Addr1   || "",
//       toAddr2:           ewb.BuyerDtls?.Addr2   || "",
//       toPlace:           ewb.BuyerDtls?.Loc     || "",
//       toPincode:         Number(ewb.BuyerDtls?.Pin)   || 0,
//       toStateCode:       Number(ewb.BuyerDtls?.Stcd)  || 0,
//       actToStateCode:    Number(ewb.BuyerDtls?.Stcd)  || 0,

//       transactionType:   1,

//       totalValue:        Number(ewb.ValDtls?.AssVal)    || 0,
//       cgstValue:         Number(ewb.ValDtls?.CgstVal)   || 0,
//       sgstValue:         Number(ewb.ValDtls?.SgstVal)   || 0,
//       igstValue:         Number(ewb.ValDtls?.IgstVal)   || 0,
//       cessValue:         Number(ewb.ValDtls?.CesVal)    || 0,
//       cessNonAdvolValue: 0,
//       totInvValue:       Number(ewb.ValDtls?.TotInvVal) || 0,

//       transporterId:     "",
//       transporterName:   "",
//       transDocNo:        ewb.EwbDtls?.TransDocNo   || "",
//       transDocDate:      ewb.EwbDtls?.TransDocDate || "",
//       transMode:         ewb.EwbDtls?.TransMode    || "1",
//       transDistance:     Number(ewb.EwbDtls?.Distance) || 1,
//       vehicleNo:         ewb.EwbDtls?.VehNo    || "",
//       vehicleType:       ewb.EwbDtls?.VehType  || "R",

//       itemList: (ewb.itemList || []).map((item, i) => ({
//         itemNo:        i + 1,
//         productName:   item.PrdDesc   || "",
//         productDesc:   item.PrdDesc   || "",
//         hsnCode:       String(item.HsnCd || ""),
//         quantity:      Number(item.Qty)     || 0,
//         qtyUnit:       item.Unit            || "NOS",
//         taxableAmount: Number(item.AssAmt)  || 0,
//         sgstRate:      Number(item.SgstAmt) || 0,
//         cgstRate:      Number(item.CgstAmt) || 0,
//         igstRate:      Number(item.IgstAmt) || 0,
//         cessRate:      Number(item.CesAmt)  || 0,
//       })),
//     };
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  GENERATE EWB — called from ValidationModal onProceed
//   // ──────────────────────────────────────────────────────────────
//   const Create_EWayBill = async () => {
//     try {
//       // ── Safety net: if EWB was loaded between modal open and confirm ──
//       if (ewbResp?.ewbNo) {
//         showToast(
//           `E-Way Bill ${ewbResp.ewbNo} already exists. Generation aborted.`,
//           "warning",
//           5000
//         );
//         return;
//       }

//       dispatch(setload_Screen(true));

//       const ewbJson = buildEwbPayload(EntJsonEwb[0]);
//       console.log("FULL EWB JSON:", JSON.stringify(EntJsonEwb[0], null, 2));

//       const payload = {
//         iSalInvId:    _HT.SelectedVouchId,
//         iClientId:    Number(localStorage.ClientId),
//         strCompanyDB: localStorage.db,
//         EntJsonEwb:   JSON.stringify(ewbJson),
//       };

//       const res = await userApp.post("GST/Generate_EWayBill", payload);

//       if (res?.data?.strStatus === "Success") {
//         const d = res.data.data;
//         const mapped = {
//           // Backend EWayBillResponseModel props (EwbNo, EwbDt, EwbValidTill)
//           // + actual TaxPro API fields (ewayBillNo, ewayBillDate, validUpto) as fallback
//           ewbNo:        d?.EwbNo        || d?.ewbNo        || d?.ewayBillNo?.toString()  || "",
//           ewbDt:        d?.EwbDt        || d?.ewbDt        || d?.ewayBillDate             || "",
//           ewbValidTill: d?.EwbValidTill || d?.ewbValidTill || d?.validUpto                || "",
//           status:       d?.Status       || d?.status       || "ACT",
//           cancelDate:   d?.CancelDate   || d?.cancelDate   || null,
//         };
//         if (!mapped.ewbNo) {
//           showToast("EWB Number not received from server. Please try again.", "error");
//           return;
//         }
//         setEwbResp(mapped);
//         setShowValidModal(false); // ✅ Validation modal close பண்ணு
//         showToast("E-Way Bill generated successfully!", "success");
//       } else {
//         showToast(res.data?.strMessage || "Generation failed. Please try again.", "error");
//       }
//     } catch (err) {
//       const msg = err?.response?.data?.strMessage || err?.response?.data?.message || err.message || "Unexpected error";

//       // Credential not found → show credential popup
//       if (msg?.toLowerCase().includes("nic credential not found") || msg?.toLowerCase().includes("credential not found")) {
//         setShowCredPopup(true);
//         return;
//       }

//       // Duplicate EWB (Error 604) — try DB first, then show popup
//       if (
//         msg === "DUPLICATE_EWB_NOT_IN_DB" ||
//         msg?.includes("604") ||
//         msg?.toLowerCase().includes("duplicate") ||
//         msg?.toLowerCase().includes("already generated") ||
//         msg?.toLowerCase().includes("same document number")
//       ) {
//         showToast("EWB already generated. Checking database...", "info");
//         try {
//           await Load_EWayBill(iScrId, _HT.SelectedVouchId);
//           setTimeout(() => { setShowDuplicateModal(true); }, 800);
//         } catch {
//           setShowDuplicateModal(true);
//         }
//         return;
//       }

//       showToast(msg, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  USE EXISTING EWB (from Duplicate modal)
//   // ──────────────────────────────────────────────────────────────
//   const Handle_UseExistingEWB = (ewbData) => {
//     setEwbResp(ewbData);
//     setShowDuplicateModal(false);
//     showToast(`EWB ${ewbData.ewbNo} loaded — you can now Print or Cancel.`, "success");
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  SAVE CREDENTIAL
//   // ──────────────────────────────────────────────────────────────
//   const Save_Credential = async () => {
//     if (!nicCred.ApiUserName.trim() || !nicCred.ApiPassword.trim()) {
//       showToast("Please enter both Username and Password.", "error");
//       return;
//     }
//     try {
//       setCredSaving(true);
//       const gstin = EntJsonEwb?.[0]?.SellerDtls?.Gstin || "";
//       const res = await userApp.post("GST/Save_NIC_Credential", {
//         ClientId:    Number(localStorage.ClientId),
//         GSTIN:       gstin,
//         ApiUserName: nicCred.ApiUserName.trim(),
//         ApiPassword: nicCred.ApiPassword.trim(),
//       });
//       if (res.data?.strStatus === "Success") {
//         showToast("Credential saved successfully!", "success");
//         setShowCredPopup(false);
//         setNicCred({ ApiUserName: "", ApiPassword: "" });
//         await Create_EWayBill();
//       } else {
//         showToast(res.data?.strMessage || "Failed to save credential.", "error");
//       }
//     } catch (err) {
//       showToast(err?.response?.data?.strMessage || err.message || "Error saving credential.", "error");
//     } finally {
//       setCredSaving(false);
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  CANCEL EWB
//   // ──────────────────────────────────────────────────────────────
//   const Cancel_EWayBill = async (ewbNo, reason, remarks) => {
//     try {
//       dispatch(setload_Screen(true));
//       const payload = {
//         EwbNo:         ewbNo,
//         CancelRsnCode: Number(reason),
//         CancelRmrk:    remarks || "Cancelled by user",
//         iSalInvId:     _HT.SelectedVouchId,
//         iClientId:     Number(localStorage.ClientId),
//         strCompanyDB:  localStorage.db,
//       };
//       const res = await userApp.post("GST/Cancel_EWayBill", payload);
//       if (res.data.strStatus === "Success") {
//         setShowCancelModal(false);
//         showToast("E-Way Bill cancelled successfully.", "success");
//         await Load_EWayBill(iScrId, _HT.SelectedVouchId);
//       } else {
//         const msg = res.data.strMessage || "Cancel failed.";
//         if (msg.includes("312") || msg.toLowerCase().includes("24 hour") || msg.toLowerCase().includes("cannot cancel") || msg.toLowerCase().includes("time limit")) {
//           showToast("Cannot cancel — EWB can only be cancelled within 24 hours of generation.", "error", 7000);
//         } else {
//           showToast(msg, "error");
//         }
//       }
//     } catch (err) {
//       showToast(err.message || "Unexpected error", "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  UPDATE VEHICLE NO
//   // ──────────────────────────────────────────────────────────────
// const Update_VehicleNo = async (form) => {
//   try {
//     dispatch(setload_Screen(true));

//     let transDocDate = "";
//     if (form.TransDocDate && form.TransDocDate.trim().length === 10) {
//       const raw = form.TransDocDate.trim();
//       try {
//         if (raw[4] === "-") {
//           // "yyyy-MM-dd" → "dd/MM/yyyy"
//           const [y, m, d] = raw.split("-");
//           const dt = new Date(`${y}-${m}-${d}`);
//           const today = new Date(); today.setHours(0, 0, 0, 0);
//           if (!isNaN(dt) && dt <= today)
//             transDocDate = `${d}/${m}/${y}`;
//         } else if (raw[2] === "/") {
//           // Already "dd/MM/yyyy" — validate not future
//           const [d, m, y] = raw.split("/");
//           const dt = new Date(`${y}-${m}-${d}`);
//           const today = new Date(); today.setHours(0, 0, 0, 0);
//           if (!isNaN(dt) && dt <= today)
//             transDocDate = raw;
//         }
//       } catch { transDocDate = ""; }
//     }

//     const payload = {
//       VouchId:           _HT.SelectedVouchId,
//       EwbNo:             ewbResp.ewbNo,
//       VehicleNo:         form.VehicleNo.trim().toUpperCase(),
//       FromPlace:         form.FromPlace.trim(),
//       FromState:         Number(form.FromState),
//       RemainingDistance: form.RemainingDistance ? Number(form.RemainingDistance) : 0,
//       TransDocNo:        form.TransDocNo?.trim() || "",
//       TransDocDate:      transDocDate,
//       TransMode:         form.TransMode   || "1",
//       VehicleType:       form.VehicleType || "R",
//       ReasonCode:        Number(form.ReasonCode) || 1,
//       Remarks:           form.Remarks?.trim() || "",
//       iClientId:         Number(localStorage.ClientId),
//       strCompanyDB:      localStorage.db,
//     };

//     const res = await userApp.post("GST/Update_VehicleNo", payload);
//     if (res.data.strStatus === "Success") {
//       setShowVehicleModal(false);

//       setEwbResp(prev => ({
//         ...prev,
//         vehicleNo:         form.VehicleNo.trim().toUpperCase(),
//         transMode:         form.TransMode   || "1",
//         vehicleType:       form.VehicleType || "R",
//         transDocNo:        form.TransDocNo?.trim() || "",
//         transDocDate:      transDocDate,
//         remainingDistance: Number(form.RemainingDistance) > 0 ? Number(form.RemainingDistance) : prev?.remainingDistance || null,
//       }));

//       showToast("Vehicle number updated successfully.", "success");
//       await Load_EWayBill(iScrId, _HT.SelectedVouchId);
//     } else {
//       showToast(res.data.strMessage || "Update failed.", "error");
//     }
//   } catch (err) {
//     showToast(err?.response?.data?.strMessage || err.message || "Unexpected error", "error");
//   } finally {
//     dispatch(setload_Screen(false));
//   }
// };

//   // ──────────────────────────────────────────────────────────────
//   //  EXTEND EWB VALIDITY
//   // ──────────────────────────────────────────────────────────────
// const Extend_EWayBill = async (form) => {
//   try {
//     dispatch(setload_Screen(true));

//     //  TransDocDate: "yyyy-MM-dd" → "dd/MM/yyyy"
//     //  Empty or future date → "" (backend-ல null ஆகும்)
//     let transDocDate = "";
//     if (form.TransDocDate && form.TransDocDate.trim().length === 10) {
//       const [y, m, d] = form.TransDocDate.split("-");
//       if (y && m && d) {
//         const entered = new Date(`${y}-${m}-${d}`);
//         const today   = new Date(); today.setHours(0, 0, 0, 0);
       
//         if (entered <= today) transDocDate = `${d}/${m}/${y}`;
//       }
//     }

//     const payload = {
//       EwbNo:             ewbResp.ewbNo,
//       VehicleNo:         form.VehicleNo.trim().toUpperCase(),
//       FromPlace:         form.FromPlace.trim(),
//       FromState:         Number(form.FromState),
//       FromPincode:       Number(form.FromPincode),
//       RemainingDistance: Number(form.RemainingDistance) || 1, 
//       TransDocNo:        form.TransDocNo?.trim() || "",
//       TransDocDate:      transDocDate,
//       TransMode:         form.TransMode  || "1",
//       VehicleType:       form.VehicleType || "R",
//       Consignment:       form.Consignment || "M",
//       ExtnRsnCode:       Number(form.ExtnRsnCode) || 1,
//       ExtnRemarks:       form.ExtnRemarks?.trim() || "Validity extended",
//       iClientId:         Number(localStorage.ClientId),
//       strCompanyDB:      localStorage.db,
//     };

//     console.log("[EXTEND] Payload:", JSON.stringify(payload, null, 2));

//     const res = await userApp.post("GST/Extend_EWayBill", payload);

//     if (res.data.strStatus === "Success") {
//       setShowExtendModal(false);
//       showToast("E-Way Bill validity extended successfully! ✅", "success");
//       await Load_EWayBill(iScrId, _HT.SelectedVouchId);

//     } else {
//       const msg = res.data.strMessage || "";

//       if (msg.includes("702")) {
//         let nicDist = null;
//         try {
//           const jsonStart = msg.indexOf("{");
//           if (jsonStart !== -1) {
//             const parsed = JSON.parse(msg.substring(jsonStart));
//             nicDist = parsed?.distance || null;
//           }
//         } catch { /* ignore parse error */ }

//         showToast(
//           nicDist
//             ? `Distance too high — NIC maximum allowed is ${nicDist} km. Please enter ${nicDist} or less.`
//             : "Remaining distance exceeds NIC limit. Please reduce and try again.",
//           "warning",
//           7000
//         );
//       } else if (msg.includes("382") || msg.toLowerCase().includes("8 hour") || msg.toLowerCase().includes("extend") && msg.toLowerCase().includes("validity")) {
//         showToast(
//           "Cannot extend now — only allowed within 8 hours before or after EWB expiry. Please try again closer to the expiry time.",
//           "warning",
//           8000
//         );
//       } else {
//         showToast(msg || "Extend failed. Please try again.", "error");
//       }
//     }

//   } catch (err) {
//     showToast(
//       err?.response?.data?.strMessage || err.message || "Unexpected error",
//       "error"
//     );
//   } finally {
//     dispatch(setload_Screen(false));
//   }
// };

//   // ──────────────────────────────────────────────────────────────
//   //  PRINT EWB
//   // ──────────────────────────────────────────────────────────────
// // ──────────────────────────────────────────────────────────────
// //  PRINT EWB — GST Portal Format (Normal + EInvoice combined)
// // ──────────────────────────────────────────────────────────────
// const Print_EWayBill = async (ewbNo) => {
//   try {
//     dispatch(setload_Screen(true));
//     const ewb     = EntJsonEwb?.[0] || {};
//     const seller  = ewb.SellerDtls  || {};
//     const buyer   = ewb.BuyerDtls   || {};
//     const ewbDtls = ewb.EwbDtls     || {};
//     const doc     = ewb.DocDtls     || {};
//     const val     = ewb.ValDtls     || {};
//     const items   = ewb.itemList    || [];

//       // IRN details — from ewbResp state (loaded via DB JOIN with EInvoice table)
//       const irn   = ewbResp?.irn   || null;
//       const ackNo = ewbResp?.ackNo || null;
//       const ackDt = ewbResp?.ackDt || null;

//     openPrintWindow({
//       ewbNo:        ewbResp?.ewbNo        || ewbNo,
//       ewbDt:        ewbResp?.ewbDt        || "",
//       ewbValidTill: ewbResp?.ewbValidTill || "",
//       status:       ewbResp?.status       || "ACT",
//       // Part A
//       fromGstin:    seller.Gstin   || "",
//       fromName:     seller.LglNm   || seller.TrdNm || "",
//       fromAddr:     [seller.Addr1, seller.Addr2].filter(Boolean).join(", "),
//       fromPlace:    seller.Loc     || "",
//       fromState:    seller.Stcd    || "",
//       fromPin:      seller.Pin     || "",
//       toGstin:      buyer.Gstin    || "",
//       toName:       buyer.LglNm    || buyer.TrdNm || "",
//       toAddr:       [buyer.Addr1, buyer.Addr2].filter(Boolean).join(", "),
//       toPlace:      buyer.Loc      || "",
//       toState:      buyer.Stcd     || "",
//       toPin:        buyer.Pin      || "",
//       docNo:        doc.No         || "",
//       docDate:      doc.Dt         || "",
//       docType:      doc.Typ        || "INV",
//       supplyType:   ewbDtls.SupplyType || "Outward - Supply",
//       transType:    "Regular",
//       valueOfGoods: val.AssVal     || val.TotInvVal || 0,
//       totInvVal:    val.TotInvVal  || 0,
//       hsnCode:      items[0]?.HsnCd || "",
//   // Part B
// vehicleNo:    ewbResp?.vehicleNo    || ewbDtls.VehNo       || "",
// transMode:    (() => {
//   const m = ewbResp?.transMode || ewbDtls.TransMode || "1";
//   return m==="1" ? "Road" : m==="2" ? "Rail" : m==="3" ? "Air" : m==="4" ? "Ship" : "Road";
// })(),
// transporter:  ewbDtls.TransId       || ewbDtls.TransName   || "",
// transDocNo:   ewbResp?.transDocNo   || ewbDtls.TransDocNo  || "",
// transDocDate: ewbResp?.transDocDate || ewbDtls.TransDocDate || "",
// distance: Number(ewbResp?.distance) > 0 
//   ? Number(ewbResp.distance) 
//   : (Number(ewbDtls.Distance) > 0 
//     ? Number(ewbDtls.Distance) 
//     : Number(EntJsonEwb?.[0]?.EwbDtls?.Distance) || 0),
//       // IRN (only for EInvoice EWB)
//       irn:          irn    || "",
//       ackNo:        ackNo  || "",
//       ackDt:        ackDt  || "",
//       // Items
//       items,
//     });
//   } catch (err) {
//     showToast(err.message || "Print failed", "error");
//   } finally {
//     dispatch(setload_Screen(false));
//   }
// };

// // ──────────────────────────────────────────────────────────────
// //  OPEN PRINT WINDOW — GST Portal Exact Format
// // ──────────────────────────────────────────────────────────────
// const openPrintWindow = (d) => {
//   const isEInvoice  = !!d.irn;
//   const isCancelled = d.status === "CNL";

//   const fmtEwbNo = (n) => {
//     const s = String(n).replace(/\s/g, "");
//     return s.length === 12
//       ? `${s.slice(0,4)} ${s.slice(4,8)} ${s.slice(8)}`
//       : s;
//   };

//   const hsnList = [...new Set((d.items || [])
//     .map(it => String(it.HsnCd || it.hsnCode || ""))
//     .filter(Boolean))].join(", ");

//   const rawEwbNo = String(d.ewbNo).replace(/\s/g, "");

//   // QR content — same as GST portal (EWB No used as QR data)
//   const qrContent = rawEwbNo;

//   const vehicleRow = `
//     <tr>
//       <td>${d.transMode || "Road"}</td>
//       <td>${d.vehicleNo || "—"}${d.transDocNo ? " / " + d.transDocNo : ""}${d.transDocDate ? " & " + d.transDocDate : ""}</td>
//       <td>${d.fromPlace || "—"}</td>
//       <td>${d.ewbDt ? formatEWBDate(d.ewbDt) : "—"}</td>
//       <td>${d.fromGstin || "—"}</td>
//       <td>-</td>
//       <td>-</td>
//       <td>1</td>
//     </tr>`;

//   const html = `<!DOCTYPE html>
// <html>
// <head>
//   <title>e-Way Bill — ${fmtEwbNo(d.ewbNo)}</title>

//   <!-- QR Code library -->
//   <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
//   <!-- Barcode library -->
//   <script src="https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js"><\/script>

//   <style>
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body { font-family: Arial, sans-serif; font-size: 12px; color: #000; background: #fff; padding: 20px; }
//     .page-border { border: 2px solid #000; padding: 14px; max-width: 780px; margin: 0 auto; }
//     h1.title { text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 10px; }
//     .qr-bar { display: flex; justify-content: center; margin-bottom: 10px; }
//     #qrcode canvas, #qrcode img { display: block; }
//     table.info { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
//     table.info td { border: 1px solid #aaa; padding: 4px 8px; vertical-align: top; }
//     table.info td.label { font-weight: bold; width: 38%; background: #f5f5f5; }
//     .section-title { font-weight: bold; font-size: 13px; background: #e8e8e8;
//                      padding: 4px 8px; border: 1px solid #aaa; border-bottom: none; margin-top: 10px; }
//     table.part { width: 100%; border-collapse: collapse; }
//     table.part th { border: 1px solid #aaa; padding: 5px 6px; background: #f0f0f0; font-size: 11px; text-align: left; }
//     table.part td { border: 1px solid #aaa; padding: 4px 6px; font-size: 11px; }
//     .irn-box { border: 1px solid #aaa; padding: 6px 10px; margin-bottom: 8px; background: #fafafa; }
//     .irn-box .irn-label { font-weight: bold; font-size: 11px; margin-bottom: 4px; }
//     .irn-val { font-family: monospace; font-size: 11px; word-break: break-all; }
//     .barcode-area { text-align: center; margin-top: 14px; padding-top: 10px; border-top: 1px solid #ccc; }
//     .barcode-num  { font-size: 11px; margin-top: 4px; color: #333; letter-spacing: 2px; }
//     .note { font-size: 10px; color: #555; margin-top: 8px; font-style: italic; }
//     .print-btn { display: block; margin: 16px auto 0; padding: 9px 32px; background: #1a5276;
//                  color: #fff; border: none; border-radius: 5px; cursor: pointer; font-size: 13px; font-weight: 600; }
//     @media print { .print-btn { display: none; } body { padding: 0; } }
//   </style>
// </head>
// <body>
// <div class="page-border">

//   <h1 class="title">e-Way Bill</h1>

//   <!-- QR Code -->
//   <div class="qr-bar">
//     <div id="qrcode"></div>
//   </div>

//   <!-- Top Info -->
//   <table class="info">
//     <tr><td class="label">E-Way Bill No:</td>   <td><strong>${fmtEwbNo(d.ewbNo)}</strong></td></tr>
//     <tr><td class="label">E-Way Bill Date:</td>  <td>${formatEWBDate(d.ewbDt) || "—"}</td></tr>
//     <tr><td class="label">Generated By:</td>     <td>${d.fromGstin} - ${d.fromName}</td></tr>
//     <tr><td class="label">Valid From:</td>        <td>${formatEWBDate(d.ewbDt) || "—"} [${Math.round(Number(d.distance) || 0)}Kms]</td></tr>
//     <tr><td class="label">Valid Until:</td>       <td><strong>${formatEWBDate(d.ewbValidTill) || "—"}</strong>
//       ${isCancelled ? '<span style="color:red;font-weight:bold;"> (CANCELLED)</span>' : ""}
//     </td></tr>
//     <tr><td class="label">Portal:</td>            <td>1</td></tr>
//   </table>

//   ${isEInvoice ? `
//   <div class="irn-box">
//     <div class="irn-label">IRN Details</div>
//     <table class="info" style="margin:0">
//       <tr><td class="label">IRN:</td>      <td class="irn-val">${d.irn}</td></tr>
//       <tr><td class="label">Ack No:</td>   <td>${d.ackNo  || "—"}</td></tr>
//       <tr><td class="label">Ack Date:</td> <td>${formatEWBDate(d.ackDt) || "—"}</td></tr>
//     </table>
//   </div>` : ""}

//   <!-- Part A -->
//   <div class="section-title">Part - A</div>
//   <table class="info">
//     <tr><td class="label">GSTIN of Supplier:</td>      <td>${d.fromGstin}<br/><strong>${d.fromName}</strong></td></tr>
//     <tr><td class="label">Place of Dispatch:</td>       <td>${d.fromPlace}${d.fromState ? ", " + d.fromState : ""}${d.fromPin ? " " + d.fromPin : ""}</td></tr>
//     <tr><td class="label">GSTIN of Recipient:</td>      <td>${d.toGstin}<br/><strong>${d.toName}</strong></td></tr>
//     <tr><td class="label">Place of Delivery:</td>       <td>${d.toPlace}${d.toState ? ", " + d.toState : ""}${d.toPin ? " " + d.toPin : ""}</td></tr>
//     <tr><td class="label">Document No.</td>             <td>${d.docNo   || "—"}</td></tr>
//     <tr><td class="label">Document Date</td>            <td>${formatEWBDate(d.docDate) || "—"}</td></tr>
//     <tr><td class="label">Transaction Type:</td>        <td>${d.transType || "Regular"}</td></tr>
//     <tr><td class="label">Value of Goods</td>           <td>${Number(d.valueOfGoods || 0).toLocaleString("en-IN")}</td></tr>
//     <tr><td class="label">HSN Code</td>                 <td>${hsnList || "—"}</td></tr>
//     <tr><td class="label">Reason for Transportation</td><td>${d.supplyType || "Outward - Supply"}</td></tr>
//     <tr><td class="label">Transporter</td>              <td>${d.transporter || "—"}</td></tr>
//   </table>

//   <!-- Part B -->
//   <div class="section-title">Part - B</div>
//   <table class="part">
//     <thead>
//       <tr>
//         <th>Mode</th>
//         <th>Vehicle / Trans Doc No &amp; Dt.</th>
//         <th>From</th>
//         <th>Entered Date</th>
//         <th>Entered By</th>
//         <th>CEWB No. (If any)</th>
//         <th>Multi Veh.Info (If any)</th>
//         <th>Portal</th>
//       </tr>
//     </thead>
//     <tbody>${vehicleRow}</tbody>
//   </table>

//   <!-- Barcode -->
//   <div class="barcode-area">
//     <svg id="ewb-barcode"></svg>
//     <div class="barcode-num">${rawEwbNo}</div>
//   </div>

//   <p class="note">Note*: If any discrepancy in information please try after sometimes.</p>
// </div>

// <button class="print-btn" onclick="window.print()">🖨️ Print</button>

// <script>
//   // Wait for libraries to load, then render
//   window.onload = function() {
//     // ── QR Code ──
//     try {
//       new QRCode(document.getElementById("qrcode"), {
//         text:          "${qrContent}",
//         width:         90,
//         height:        90,
//         correctLevel:  QRCode.CorrectLevel.M
//       });
//     } catch(e) { console.error("QR failed", e); }

//     // ── Barcode ──
//     try {
//       JsBarcode("#ewb-barcode", "${rawEwbNo}", {
//         format:      "CODE128",
//         width:       2,
//         height:      55,
//         displayValue: false,
//         margin:      4
//       });
//     } catch(e) { console.error("Barcode failed", e); }

//     // ── Auto print after render ──
//     setTimeout(() => window.print(), 900);
//   };
// </script>
// </body>
// </html>`;

//   const pw = window.open("", "_blank", "width=820,height=750");
//   if (pw) { pw.document.write(html); pw.document.close(); }
//   else showToast("Popup blocked! Please allow popups for this site.", "error");
// };

//   // ──────────────────────────────────────────────────────────────
//   //  CLEAR / REFRESH
//   // ──────────────────────────────────────────────────────────────
//   const Clear_EWayBill = () => Load_EWayBill(_Common.iScrId, _HT.SelectedVouchId);

//   // ──────────────────────────────────────────────────────────────
//   //  SETTINGS
//   // ──────────────────────────────────────────────────────────────
//   const Area_Onchange = async (AreaId) => {
//     try {
//       setiAreaId(AreaId);
//       dispatch(setload_Screen(true));
//       await userApp.get(`GST/Area_Onchange/${Number(AreaId)}/${Number(iScrId)}/${localStorage.db}`).then((Res) => {
//         if (Res.data.strStatus === "Success") setarrEntCol(Res.data.EntCol);
//         else showToast(Res.data.strMessage, "info");
//       });
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   const View_GSTColumns = (col) => {
//     setstrColName(col.strGstcolName);
//     setstrAliasName(col.strAliasName);
//     setstrDatatype(col.strdatatype);
//     setstrTransName(col.strConditionCol);
//     setstrdefaultval(col.strdefaultvalue);
//     setstrval(col.strValue);
//     setiAreaId(col.iAreaId);
//     setiColId(col.iGstcolId);
//     setisShow(col.iShwinScr === 1);
//   };

//   const Clear_Colums = () => {
//     setstrColName(""); setstrAliasName(""); setstrDatatype("string");
//     setstrTransName(""); setstrdefaultval(""); setstrval("");
//     setiAreaId(0); setiColId(0); setisShow(true);
//   };

//   const Updat_GSTColumn = async () => {
//     try {
//       const InsUpdCol = {
//         strCompanyDB: localStorage.db,
//         EntArea: [],
//         EntCol: [{
//           iGstcolId:       iColId,
//           strGstcolName:   strColName,
//           strAliasName:    strAliasName,
//           strdatatype:     strDatatype,
//           strConditionCol: strTransName,
//           strdefaultvalue: strdefaultval,
//           strValue:        strval,
//           iShwinScr:       isShow ? 1 : 0,
//           iAreaId:         iAreaId,
//           iScrId:          iScrId,
//         }],
//       };
//       dispatch(setload_Screen(true));
//       await userApp.post("GST/InsUpd_GSTColumns", InsUpdCol).then((Res) => {
//         if (Res.data.strStatus === "Success") { Area_Onchange(iAreaId); Clear_Colums(); }
//         else showToast(Res.data.strMessage, "error");
//       });
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  DROPDOWN HELPERS
//   // ──────────────────────────────────────────────────────────────
//   const Option_list    = (col, EntDT) => { switch (col) { case "vehicleType": return VEHICLE_TYPES.map((v) => ({ val: v.val, Name: v.label })); case "transMode": return TRANS_MODES.map((v) => ({ val: v.val, Name: v.label })); default: return EntDT; } };
//   const Option_Value   = (Val, col)   => { switch (col) { case "vehicleType": case "transMode": return Val.val; default: return Val; } };
//   const Option_display = (Val, col)   => { switch (col) { case "vehicleType": case "transMode": return Val.Name; default: return Val; } };
//   const display_Value  = (Val, col)   => { switch (col) { case "vehicleType": return VEHICLE_TYPES.find((v) => v.val === Val)?.label || Val; case "transMode": return TRANS_MODES.find((v) => v.val === Val)?.label || Val; default: return Val; } };
//   const Hide_Option    = (val, element) => setarrEntCol((cols) => cols.map((col) => col.iGstcolId === element.iGstcolId ? { ...col, isShowOption: val } : col));

//   // ──────────────────────────────────────────────────────────────
//   //  CREATE HTML ELEMENT
//   // ──────────────────────────────────────────────────────────────
//   const CreateHTMLElemet = (element, area, Index) => {
//     if (element.iAreaId === area.iAreaId && area.iAreaId !== 9) {
//       const json = EntJsonEwb[0];
//       const val  = json ? (json[area.strAreaCol]?.[element.strGstcolName] ?? "") : "";
//       switch (element.strdatatype) {
//         case "string":
//           return (<div className="col-sm-6 col-md-3" key={Index}><label>{element.strAliasName}</label><input type="text" className="form-control" value={val} onChange={(e) => Input_Onchange(e.target.value, element, area)} /></div>);
//         case "cmb":
//           return (
//             <div className="col-sm-6 col-md-3" key={Index}>
//               <label>{element.strAliasName}</label>
//               <div className="custom-select" onMouseLeave={() => Hide_Option(false, element)}>
//                 <input type="text" className="form-control" disabled={false} placeholder="Select Value" value={display_Value(val, element.strGstcolName)} onClick={() => Hide_Option(true, element)} readOnly />
//                 <i className="fa-solid fa-caret-down"></i>
//                 {element.isShowOption && (
//                   <div className="custom-option">
//                     <div className="option-list">
//                       {Option_list(element.strGstcolName, element.arrOption).map((item, idx) => (
//                         <button key={idx} tabIndex={idx}
//                           onClick={() => { Input_Onchange(Option_Value(item, element.strGstcolName), element, area); Hide_Option(false, element); }}
//                           onKeyDown={(e) => {
//                             const len = element.arrOption.length - 1;
//                             if (e.key === "ArrowDown") $(`.option-list [tabindex=${idx === len ? 0 : idx + 1}]`).focus();
//                             if (e.key === "ArrowUp")   $(`.option-list [tabindex=${idx === 0 ? len : idx - 1}]`).focus();
//                             if (e.key === "Enter")     { Input_Onchange(Option_Value(item, element.strGstcolName), element, area); Hide_Option(false, element); }
//                           }}
//                         >{Option_display(item, element.strGstcolName)}</button>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         case "decimal":
//           return (<div className="col-sm-6 col-md-3" key={Index}><label>{element.strAliasName}</label><input type="number" className="form-control" value={val} onChange={(e) => Input_Onchange(e.target.value, element, area)} /></div>);
//         case "date":
//           return (<div className="col-sm-6 col-md-3" key={Index}><label>{element.strAliasName}</label><input type="date" className="form-control" value={val} onChange={(e) => Input_Onchange(e.target.value, element, area)} /></div>);
//         default: break;
//       }
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //  TABLE COLUMNS
//   // ──────────────────────────────────────────────────────────────
//   const ItemColumn = [
//     { Header: "Product Name",  accessor: "PrdDesc",    minWidth: 200 },
//     { Header: "HSN Code",      accessor: "HsnCd",      minWidth: 100 },
//     { Header: "Qty",           accessor: "Qty",         style: { justifyContent: "right" }, minWidth: 80 },
//     { Header: "Unit",          accessor: "Unit",        style: { justifyContent: "center" }, minWidth: 80 },
//     { Header: "Rate",          accessor: "UnitPrice",   style: { justifyContent: "right" }, minWidth: 100 },
//     { Header: "Taxable Amt",   accessor: "AssAmt",      style: { justifyContent: "right" }, minWidth: 120 },
//     { Header: "SGST",          accessor: "SgstAmt",     style: { justifyContent: "right" }, minWidth: 80 },
//     { Header: "CGST",          accessor: "CgstAmt",     style: { justifyContent: "right" }, minWidth: 80 },
//     { Header: "IGST",          accessor: "IgstAmt",     style: { justifyContent: "right" }, minWidth: 80 },
//     { Header: "CESS",          accessor: "CesAmt",      style: { justifyContent: "right" }, minWidth: 80 },
//     { Header: "Total Amt",     accessor: "TotItemVal",  style: { justifyContent: "right" }, minWidth: 120 },
//   ];

//   const GstColumn = [
//     { Header: "GST Column",    accessor: "strGstcolName" },
//     { Header: "Alias Name",    accessor: "strAliasName",    minWidth: 200 },
//     { Header: "Data Type",     accessor: "strdatatype",     minWidth: 100 },
//     { Header: "Trans Name",    accessor: "strConditionCol", minWidth: 100 },
//     { Header: "Default Value", accessor: "strdefaultvalue", minWidth: 200 },
//     { Header: "Value",         accessor: "strValue",        minWidth: 100, style: { justifyContent: "center" } },
//     {
//       Header: "Show",
//       accessor: "iShwinScr",
//       minWidth: 70,
//       style: { justifyContent: "center" },
//       cell: ({ rowinfo }) => <input type="checkbox" className="form-check" checked={rowinfo.iShwinScr} readOnly />,
//     },
//   ];

//   // ══════════════════════════════════════════════════════════════
//   //  RENDER
//   // ══════════════════════════════════════════════════════════════
//   return (
//     <>
//       <Toast toasts={toasts} onDismiss={dismissToast} />

//       {/* ── Credential Modal ── */}
//       {showCredPopup && (
//         <CredentialModal
//           cred={nicCred}
//           onChange={setNicCred}
//           onSave={Save_Credential}
//           onClose={() => { setShowCredPopup(false); setNicCred({ ApiUserName: "", ApiPassword: "" }); }}
//           saving={credSaving}
//         />
//       )}

//       {/* ── Validation Modal (exact EInvoice flow) ── */}
//       {showValidModal && (
//         <ValidationModal
//           errors={validErrors}
//           warnings={validWarnings}
//           ewb={EntJsonEwb?.[0]}
//           onProceed={() => {
//             setShowValidModal(false);
//             Create_EWayBill();
//           }}
//           onClose={() => setShowValidModal(false)}
//         />
//       )}

//       {/* ── Duplicate EWB Modal (Error 604) ── */}
//       {showDuplicateModal && (
//         <DuplicateEWBModal
//           onUseExisting={Handle_UseExistingEWB}
//           onClose={() => setShowDuplicateModal(false)}
//         />
//       )}

//       {/* ── Cancel Modal ── */}
//       {showCancelModal && (
//         <CancelEWBModal
//           ewbNo={ewbResp?.ewbNo}
//           onConfirm={(reason, remarks) => Cancel_EWayBill(ewbResp?.ewbNo, reason, remarks)}
//           onClose={() => setShowCancelModal(false)}
//           onAlert={showToast}
//         />
//       )}

//       {/* ── Update Vehicle Modal ── */}
//       {showVehicleModal && (
//         <UpdateVehicleModal
//           ewbNo={ewbResp?.ewbNo}
//           onConfirm={Update_VehicleNo}
//           onClose={() => setShowVehicleModal(false)}
//           onAlert={AlertMessage}
//         />
//       )}

//       {/* ── Extend Validity Modal ── */}
//       {showExtendModal && (
// <ExtendModal
//   ewbNo={ewbResp?.ewbNo}
//   onConfirm={Extend_EWayBill}
//   onClose={() => setShowExtendModal(false)}
//   onAlert={showToast}
// />
//       )}

//       <div className="popup-container">
//         <div className="popup-content">

//           {/* ── Header ── */}
//           <div className="popup-header">
//             <h5>E-Way Bill</h5>
//             <div className="icon-popup-btn-grp">
//               {!isSetting && (
//                 <span className="icon-btn" onClick={() => { setisSetting(true); Area_Onchange(1); }} title="Settings">
//                   <i className="fa-solid fa-gear"></i>
//                 </span>
//               )}
//               <span className="icon-btn" onClick={() => dispatch(ShowHide_Popup("IsEWayBill"))}>
//                 <i className="fa-regular fa-rectangle-xmark"></i>
//               </span>
//             </div>
//           </div>

//           {/* ── Body ── */}
//           <div className="popup-body">

//             {/* Form View */}
//             {!isSetting && (
//               <div className="row">
//                 {arrEntArea.map((area, Index) => (
//                   <div className="row" key={Index}>
//                     <h6 className="gstcol-h">{area.strAliasName}</h6>
//                     {arrEntCol.map((col, idx) => CreateHTMLElemet(col, area, idx))}
//                   </div>
//                 ))}

//                 {/* Item Table */}
//                 <div className="TransactionTable">
//                   <ReactTable
//                     sortable={true}
//                     data={ListEntItem}
//                     columns={ItemColumn}
//                     minRows={5}
//                     defaultPageSize={500}
//                     showPaginationBottom={false}
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Settings View */}
//             {isSetting && (
//               <div className="row p-2">
//                 <div className="col-sm-12 col-md-3">
//                   <label>GST Column Type</label>
//                   <CustomizedSelectoption
//                     optionparem="isoptionShow10"
//                     showoption={_selecrparem.isoptionShow10}
//                     placeholder="Select Column Type"
//                     select_value={(val) => Area_Onchange(val)}
//                     btnname="" btnshow={false} show_popup={""} valueonly={true}
//                     defaultval={iAreaId} displayName="strAreaCol" disvalue="iAreaId"
//                     arrydata={arrEntArea} EmptVal="Column Type"
//                   />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>GST Column Name</label>
//                   <input type="text" className="form-control" placeholder="GST Column" value={strColName} onChange={(e) => setstrColName(e.target.value)} spellCheck={false} autoComplete="off" />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Alias Name</label>
//                   <input type="text" className="form-control" placeholder="Alias Name" value={strAliasName} onChange={(e) => setstrAliasName(e.target.value)} spellCheck={false} autoComplete="off" />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Trans Name</label>
//                   <input type="text" className="form-control" placeholder="Trans Name" value={strTransName} onChange={(e) => setstrTransName(e.target.value)} spellCheck={false} autoComplete="off" />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Default Value</label>
//                   <input type="text" className="form-control" placeholder="Default Value" value={strdefaultval} onChange={(e) => setstrdefaultval(e.target.value)} spellCheck={false} autoComplete="off" />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Value</label>
//                   <input type="text" className="form-control" placeholder="Value" value={strval} onChange={(e) => setstrval(e.target.value)} spellCheck={false} autoComplete="off" />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Show Screen</label>
//                   <input type="checkbox" className="form-check" checked={isShow} onChange={() => setisShow(!isShow)} />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Data Type</label>
//                   <div className="row">
//                     {["string", "date", "decimal", "cmb"].map((dt) => (
//                       <div className="col-sm-4 col-md-4" key={dt}>
//                         <label>{dt}</label>
//                         <input type="checkbox" className="form-check" checked={strDatatype === dt} onChange={() => setstrDatatype(dt)} />
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="col-sm-12 mt-3">
//                   <ReactTable
//                     columns={GstColumn}
//                     data={arrEntCol}
//                     minRows={5}
//                     row_click={() => {}}
//                     row_doubleclick={(rowInfo) => View_GSTColumns(rowInfo)}
//                     background={true}
//                     className="full-table"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* EWB Response Card */}
//             {hasEWBNo && !isSetting && (
//               <div style={{ marginTop: 18, borderRadius: 12, border: `1.5px solid ${isCancelled ? "#fecaca" : "#bbf7d0"}`, background: isCancelled ? "#fff8f8" : "#f0fdf4", padding: "16px 20px", boxShadow: "0 4px 18px rgba(0,0,0,0.06)" }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
//                   <div style={{ width: 10, height: 10, borderRadius: "50%", background: isCancelled ? "#dc2626" : "#16a34a", boxShadow: `0 0 0 3px ${isCancelled ? "#fecaca" : "#bbf7d0"}` }}></div>
//                   <span style={{ fontWeight: 700, fontSize: 13, color: isCancelled ? "#dc2626" : "#15803d" }}>
//                     {isCancelled ? "⛔ E-Way Bill Cancelled" : "✔ E-Way Bill Active"}
//                   </span>
//                 </div>
//                 <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
//                   <div style={{ flex: 1, minWidth: 260 }}>
//                     <div style={{ marginBottom: 10 }}>
//                       <div style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 2 }}>E-Way Bill No</div>
//                       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                         <span style={{ fontFamily: "monospace", fontSize: 20, fontWeight: 800, color: "#0f172a", letterSpacing: 2 }}>{ewbResp.ewbNo}</span>
//                         <CopyEWBNo ewbNo={ewbResp.ewbNo} />
//                       </div>
//                     </div>
//                     <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 20px" }}>
//                       <div>
//                         <div style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 4 }}>Generated On</div>
//                         <div style={{ fontSize: 13, color: "#0f172a", fontWeight: 600 }}>{formatEWBDate(ewbResp.ewbDt) || "—"}</div>
//                       </div>
//                       <div>
//                         <div style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 4 }}>Valid Till</div>
//                         <div style={{ fontSize: 13, color: isCancelled ? "#dc2626" : "#0f172a", fontWeight: 700 }}>{formatEWBDate(ewbResp.ewbValidTill) || "—"}</div>
//                       </div>
//                     </div>
//                     {isCancelled && ewbResp.cancelDate && (
//                       <div style={{ marginTop: 12, padding: "9px 12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, fontSize: 12 }}>
//                         <span style={{ fontWeight: 700, color: "#dc2626" }}>Cancelled On: </span>
//                         <span style={{ color: "#7f1d1d" }}>{formatEWBDate(ewbResp.cancelDate)}</span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}

//           </div>{/* end popup-body */}

//           {/* ── Footer Buttons ── */}
//           <div className="popup-footer">
//             <div className="popup-btn-group">

//               {!isSetting && (
//                 <>
//                   {!hasEWBNo && (
//                     <button onClick={Handle_Generate_Click} className="btn-fabgreen">
//                       <i className="fas fa-file-invoice"></i>&nbsp;Generate E-Way Bill
//                     </button>
//                   )}

//                   {isActive && (
//                     <>
//                       <button onClick={() => Print_EWayBill(ewbResp.ewbNo)} className="btn-fabgreen">
//                         <i className="fas fa-print"></i>&nbsp;Print
//                       </button>
//                       <button onClick={() => setShowVehicleModal(true)} className="btn-fabgreen">
//                         <i className="fas fa-truck"></i>&nbsp;Update Vehicle
//                       </button>
//                       <button onClick={() => {
//                         if (ewbResp?.ewbValidTill) {
//                           // Parse "dd/MM/yyyy HH:mm:ss AM/PM" or ISO format
//                           let validTillMs = null;
//                           try {
//                             const raw = String(ewbResp.ewbValidTill).trim();
//                             // Try: "22/05/2026 11:59:00 PM" format
//                             const m = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
//                             if (m) {
//                               let h = parseInt(m[4]);
//                               const min = parseInt(m[5]);
//                               const ampm = (m[6] || "").toUpperCase();
//                               if (ampm === "PM" && h < 12) h += 12;
//                               if (ampm === "AM" && h === 12) h = 0;
//                               validTillMs = new Date(parseInt(m[3]), parseInt(m[2])-1, parseInt(m[1]), h, min).getTime();
//                             } else {
//                               validTillMs = new Date(raw).getTime();
//                             }
//                           } catch { validTillMs = null; }

//                           if (validTillMs && !isNaN(validTillMs)) {
//                             const now = Date.now();
//                             const diffHours = (validTillMs - now) / (1000 * 60 * 60);
//                             // NIC Rule 382: Only allow within 8 hours BEFORE expiry OR after expiry (up to 8 hrs after)
//                             if (diffHours > 8) {
//                               const allowFrom = new Date(validTillMs - 8 * 60 * 60 * 1000);
//                               const opts = { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit", hour12:true };
//                               showToast(
//                                 `Extend is allowed only within 8 hours of EWB expiry. Please try after ${allowFrom.toLocaleString("en-IN", opts)}.`,
//                                 "warning", 9000
//                               );
//                               return;
//                             }
//                             if (diffHours < -8) {
//                               showToast(
//                                 "EWB has expired more than 8 hours ago — Extend is no longer possible.",
//                                 "error", 7000
//                               );
//                               return;
//                             }
//                           }
//                         }
//                         setShowExtendModal(true);
//                       }} className="btn-fabgreen">
//                         <i className="fas fa-clock"></i>&nbsp;Extend
//                       </button>
//                       <button onClick={() => setShowCancelModal(true)} className="btn-fabred">
//                         <i className="fas fa-ban"></i>&nbsp;Cancel EWB
//                       </button>
//                     </>
//                   )}

//                   {isCancelled && (
//                     <>
//                       <button onClick={() => Print_EWayBill(ewbResp.ewbNo)} className="btn-fabgreen">
//                         <i className="fas fa-print"></i>&nbsp;Print
//                       </button>
//                       <span style={{ color: "#dc2626", fontWeight: 700, fontSize: 13, padding: "7px 16px", background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 8, display: "flex", alignItems: "center", gap: 6 }}>
//                         ⛔ E-Way Bill Cancelled
//                       </span>
//                     </>
//                   )}

//                   <button onClick={Clear_EWayBill} className="btn-fabgreen">
//                     <i className="fas fa-sync-alt"></i>&nbsp;Refresh
//                   </button>
//                 </>
//               )}

//               {isSetting && (
//                 <>
//                   <button onClick={Updat_GSTColumn}          className="btn-fabgreen">Update&nbsp;<i className="fas fa-save"></i></button>
//                   <button onClick={Clear_Colums}              className="btn-fabgreen">Clear&nbsp;<i className="fas fa-eraser"></i></button>
//                   <button onClick={() => setisSetting(false)} className="btn-fabgreen"><i className="bx bx-arrow-back"></i>&nbsp;Back</button>
//                 </>
//               )}

//             </div>
//           </div>

//         </div>
//       </div>

//       <style>{`
//         @keyframes pulse     { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.5; transform:scale(1.4); } }
//         @keyframes modalPop  { from { opacity:0; transform:scale(0.88); } to { opacity:1; transform:scale(1); } }
//         @keyframes toastSlide { from { opacity:0; transform:translateX(60px) scale(0.9); } to { opacity:1; transform:translateX(0) scale(1); } }
//       `}</style>
//     </>
//   );
// }

// export default EWayBill;


import React, { useEffect, useRef, useState, useCallback } from "react";
import { userApp } from "../Admin/Utility";
import ReactTable from "../General/ReactTable";
import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import CustomizedSelectoption from "./CustomizedSelectoption";
import { ShowHide_Popup } from "../ReduxStore/Transactionstates";

// ═══════════════════════════════════════════════════════════════
//  TOAST — exact match to EInvoice
// ═══════════════════════════════════════════════════════════════
function Toast({ toasts, onDismiss }) {
  const typeConfig = {
    success: { bg: "darkgreen", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "darkgreen", icon: "✔" },
    error:   { bg: "darkgreen", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "darkgreen", icon: "✕" },
    info:    { bg: "darkgreen", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "darkgreen", icon: "i" },
    warning: { bg: "darkgreen", textColor: "#ffffff", iconBg: "#ffffff", iconColor: "darkgreen", icon: "!" },
  };
  return (
    <div style={{ position: "fixed", top: 18, right: 18, zIndex: 99999, display: "flex", flexDirection: "column", gap: 8, pointerEvents: "none" }}>
      {toasts.map((t) => {
        const cfg = typeConfig[t.type] || typeConfig.info;
        return (
          <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 10, background: cfg.bg, color: cfg.textColor, padding: "10px 14px 10px 12px", borderRadius: 5, fontSize: 13, fontWeight: 600, minWidth: 300, maxWidth: 420, pointerEvents: "all", animation: "toastSlide 0.25s ease-out", boxShadow: "0 2px 8px rgba(0,0,0,0.25)", letterSpacing: "0.01em" }}>
            <div style={{ width: 20, height: 20, borderRadius: "50%", background: cfg.iconBg, color: cfg.iconColor, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 900, flexShrink: 0 }}>{cfg.icon}</div>
            <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>
            <button onClick={() => onDismiss && onDismiss(t.id)} style={{ background: "none", border: "none", color: cfg.textColor, cursor: "pointer", fontSize: 18, fontWeight: 400, lineHeight: 1, padding: "0 0 0 6px", opacity: 0.9, flexShrink: 0 }}>×</button>
          </div>
        );
      })}
      <style>{`@keyframes toastSlide { from { opacity:0; transform:translateX(50px); } to { opacity:1; transform:translateX(0); } }`}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  CREDENTIAL MODAL
// ═══════════════════════════════════════════════════════════════
function CredentialModal({ cred, onChange, onSave, onClose, saving }) {
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 10000, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 14, width: 420, boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)", overflow: "hidden" }}>
        <div style={{ background: "darkgreen", padding: "24px 28px", display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🔐</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>NIC E-Way Bill Credentials</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", marginTop: 2 }}>GST Portal Login — required for API access</div>
          </div>
        </div>
        <div style={{ padding: "24px 28px 20px" }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, letterSpacing: "0.5px", textTransform: "uppercase" }}>GST Username</label>
            <input type="text" className="form-control" placeholder="Enter GST portal username" value={cred.ApiUserName} onChange={(e) => onChange({ ...cred, ApiUserName: e.target.value })} autoComplete="off" style={{ fontSize: 13 }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, letterSpacing: "0.5px", textTransform: "uppercase" }}>GST Password</label>
            <input type="password" className="form-control" placeholder="Enter GST portal password" value={cred.ApiPassword} onChange={(e) => onChange({ ...cred, ApiPassword: e.target.value })} autoComplete="new-password" style={{ fontSize: 13 }} />
          </div>
          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 12px", marginBottom: 20, fontSize: 11.5, color: "#1e40af", lineHeight: 1.5 }}>
            ℹ️ These credentials are used only for NIC E-Way Bill API authentication. They are stored securely and encrypted.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={onClose} disabled={saving} style={{ flex: 1, padding: "10px", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 13, cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.5 : 1 }}>Cancel</button>
            <button onClick={onSave} disabled={saving} style={{ flex: 1, padding: "10px", borderRadius: 8, border: "none", background: saving ? "#9ca3af" : "darkgreen", color: "#fff", fontWeight: 700, fontSize: 13, cursor: saving ? "not-allowed" : "pointer" }}>
              {saving ? "Saving..." : "Save & Generate"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  VALIDATION MODAL — EWayBill (exact EInvoice flow)
// ═══════════════════════════════════════════════════════════════
function ValidationModal({ errors, warnings, ewb, onProceed, onClose }) {
  const hasErrors  = errors.length > 0;
  const inv        = ewb || {};
  const doc        = inv.DocDtls   || {};
  const seller     = inv.SellerDtls || {};
  const buyer      = inv.BuyerDtls  || {};
  const ewbDtls    = inv.EwbDtls    || {};
  const val        = inv.ValDtls    || {};
  const items      = inv.itemList   || [];

  const checks = [
    { label: "Invoice Number",    ok: !!doc.No,                                       val: doc.No          || "Missing" },
    { label: "Invoice Date",      ok: !!doc.Dt,                                       val: doc.Dt          || "Missing" },
    { label: "From GSTIN",        ok: (seller.Gstin || "").length === 15 || seller.Gstin === "URP", val: seller.Gstin || "Missing" },
    { label: "To GSTIN",          ok: (buyer.Gstin  || "").length === 15 || buyer.Gstin  === "URP", val: buyer.Gstin  || "Missing" },
    { label: "From Pincode",      ok: /^\d{6}$/.test(String(seller.Pin || "")),       val: String(seller.Pin || "Missing") },
    { label: "To Pincode",        ok: /^\d{6}$/.test(String(buyer.Pin  || "")),       val: String(buyer.Pin  || "Missing") },
    { label: "Transport Mode",    ok: ["1","2","3","4"].includes(String(ewbDtls.TransMode || "")), val: ewbDtls.TransMode ? String(ewbDtls.TransMode) : "Missing" },
    { label: "Vehicle Number",    ok: (String(ewbDtls.VehNo || "").trim().length >= 4), val: ewbDtls.VehNo  || "Missing" },
    { label: "Distance (km)",     ok: Number(ewbDtls.Distance || 0) >= 0,              val: String(ewbDtls.Distance || 0) + " km" },
    { label: "Total Invoice Val", ok: Number(val.TotInvVal || 0) > 0,                 val: "₹" + Number(val.TotInvVal || 0).toLocaleString("en-IN") },
    { label: "Items",             ok: items.length > 0,                               val: items.length + " item(s)" },
  ];

  const passCount  = checks.filter((c) => c.ok).length;
  const totalCount = checks.length;
  const progress   = Math.round((passCount / totalCount) * 100);

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 16, width: 580, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: "0 32px 100px rgba(0,0,0,0.35)", animation: "modalPop 0.28s cubic-bezier(0.34,1.56,0.64,1)", overflow: "hidden" }}>

        {/* ── Header ── */}
        <div style={{ background: hasErrors ? "#dc2626" : "darkgreen", padding: "22px 24px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>
                {hasErrors ? "🛑" : "✅"}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
                  {hasErrors
                    ? `${errors.length} Error${errors.length > 1 ? "s" : ""} Found — Cannot Generate`
                    : "All Checks Passed — Ready to Generate"}
                </div>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.65)", marginTop: 2 }}>
                  {hasErrors
                    ? "Fix the errors in the invoice and try again"
                    : `${warnings.length > 0 ? warnings.length + " warning(s) noted · " : ""}Confirm to submit to NIC portal`}
                </div>
              </div>
            </div>
            <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
          </div>

          {/* Progress bar */}
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", fontWeight: 600 }}>VALIDATION PROGRESS</span>
              <span style={{ fontSize: 11, color: "rgba(255,255,255,0.9)", fontWeight: 700 }}>{passCount}/{totalCount} checks passed</span>
            </div>
            <div style={{ height: 6, background: "rgba(255,255,255,0.2)", borderRadius: 3, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${progress}%`, background: hasErrors ? "#fca5a5" : "rgba(255,255,255,0.75)", borderRadius: 3, transition: "width 0.5s ease" }} />
            </div>
          </div>
        </div>

        {/* ── Body ── */}
        <div style={{ overflowY: "auto", flex: 1 }}>

          {/* Field Checklist */}
          <div style={{ padding: "16px 24px 0" }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", letterSpacing: "0.7px", marginBottom: 10, textTransform: "uppercase" }}>Field Validation Checklist</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 10px" }}>
              {checks.map((c, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", borderRadius: 7, background: c.ok ? "#f0fdf4" : "#fef2f2", border: `1px solid ${c.ok ? "#bbf7d0" : "#fecaca"}` }}>
                  <span style={{ width: 18, height: 18, borderRadius: "50%", flexShrink: 0, background: c.ok ? "#dcfce7" : "#fee2e2", color: c.ok ? "#15803d" : "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700 }}>
                    {c.ok ? "✓" : "✕"}
                  </span>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 10.5, fontWeight: 700, color: c.ok ? "darkgreen" : "#991b1b" }}>{c.label}</div>
                    <div style={{ fontSize: 10, color: c.ok ? "darkgreen" : "#f87171", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>{c.val}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Errors */}
          {errors.length > 0 && (
            <div style={{ padding: "16px 24px 0" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <div style={{ background: "#dc2626", color: "#fff", borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700, letterSpacing: "0.5px" }}>
                  {errors.length} ERROR{errors.length > 1 ? "S" : ""}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}>Must be fixed in the invoice before generating</div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {errors.map((e, i) => (
                  <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 12px" }}>
                    <span style={{ width: 18, height: 18, borderRadius: "50%", background: "#fee2e2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✕</span>
                    <span style={{ fontSize: 12, color: "#7f1d1d", lineHeight: 1.5 }}>{e}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Warnings */}
          {warnings.length > 0 && (
            <div style={{ padding: "16px 24px 0" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <div style={{ background: "#d97706", color: "#fff", borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700, letterSpacing: "0.5px" }}>
                  {warnings.length} WARNING{warnings.length > 1 ? "S" : ""}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}>Safe to proceed — but verify these</div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {warnings.map((w, i) => (
                  <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 12px" }}>
                    <span style={{ width: 18, height: 18, borderRadius: "50%", background: "#fef3c7", color: "#d97706", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>!</span>
                    <span style={{ fontSize: 12, color: "#78350f", lineHeight: 1.5 }}>{w}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Items Summary */}
          {items.length > 0 && (
            <div style={{ padding: "16px 24px 0" }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", letterSpacing: "0.7px", marginBottom: 10, textTransform: "uppercase" }}>Item Summary</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {items.slice(0, 5).map((item, i) => {
                  const hsnOk  = !!item.HsnCd  && /^\d{4,8}$/.test(String(item.HsnCd));
                  const qtyOk  = Number(item.Qty || 0) > 0;
                  const amtOk  = Number(item.AssAmt ?? item.TotAmt ?? 0) > 0;
                  const itemOk = hsnOk && qtyOk && amtOk;
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: itemOk ? "#f0fdf4" : "#fef2f2", border: `1px solid ${itemOk ? "#bbf7d0" : "#fecaca"}`, borderRadius: 8, padding: "8px 12px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ width: 18, height: 18, borderRadius: "50%", flexShrink: 0, background: itemOk ? "#dcfce7" : "#fee2e2", color: itemOk ? "#15803d" : "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700 }}>
                          {itemOk ? "✓" : "✕"}
                        </span>
                        <div>
                          <div style={{ fontSize: 11.5, fontWeight: 600, color: "#0f172a" }}>{item.PrdDesc || "—"}</div>
                          <div style={{ fontSize: 10, color: "#6b7280" }}>
                            HSN: {item.HsnCd || <span style={{ color: "#dc2626" }}>Missing</span>} &nbsp;·&nbsp; Qty: {item.Qty} {item.Unit} &nbsp;·&nbsp; Taxable: ₹{Number(item.AssAmt || 0).toLocaleString("en-IN")}
                          </div>
                        </div>
                      </div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#1e40af" }}>
                        ₹{Number(item.TotItemVal || 0).toLocaleString("en-IN")}
                      </div>
                    </div>
                  );
                })}
                {items.length > 5 && (
                  <div style={{ fontSize: 11, color: "#6b7280", textAlign: "center", padding: "4px 0" }}>
                    + {items.length - 5} more item(s)
                  </div>
                )}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "linear-gradient(135deg,#0f172a,#1e3a5f)", borderRadius: 9, padding: "12px 16px", marginTop: 10 }}>
                <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, fontWeight: 600 }}>Total Invoice Value</span>
                <span style={{ color: "#fbbf24", fontSize: 17, fontWeight: 700 }}>₹{Number(val.TotInvVal || 0).toLocaleString("en-IN")}</span>
              </div>
            </div>
          )}

          <div style={{ height: 16 }} />
        </div>

        {/* ── Footer ── */}
        <div style={{ padding: "14px 24px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fafafa" }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: hasErrors ? "#dc2626" : "darkgreen" }}>
            {hasErrors
              ? `❌ ${errors.length} error${errors.length > 1 ? "s" : ""} — fix in invoice first`
              : warnings.length > 0
                ? `⚠ ${warnings.length} warning${warnings.length > 1 ? "s" : ""} noted · safe to proceed`
                : "✅ All validations passed"}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            {hasErrors ? (
             
              <button
                onClick={onClose}
                style={{
                  padding: "9px 22px", borderRadius: 8, border: "none",
                  background: "#dc2626", color: "#fff",
                  fontWeight: 700, fontSize: 13, cursor: "pointer",
                  display: "flex", alignItems: "center", gap: 8,
                  boxShadow: "0 4px 16px rgba(220,38,38,0.35)"
                }}
              >
                🔧 Go &amp; Fix Errors
              </button>
            ) : (
             
              <>
                <button
                  onClick={onClose}
                  style={{
                    padding: "9px 22px", borderRadius: 8,
                    border: "1.5px solid #e5e7eb", background: "#fff",
                    color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={onProceed}
                  style={{
                    padding: "9px 22px", borderRadius: 8, border: "none",
                    background: "darkgreen", color: "#fff",
                    fontWeight: 700, fontSize: 13, cursor: "pointer",
                    boxShadow: "0 4px 16px rgba(22,101,52,0.35)",
                    display: "flex", alignItems: "center", gap: 8
                  }}
                >
                  ✅ Confirm &amp; Generate
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  DUPLICATE EWB POPUP — Error 604
// ═══════════════════════════════════════════════════════════════
function DuplicateEWBModal({ onUseExisting, onClose }) {
  const [ewbNo,     setEwbNo]     = useState("");
  const [ewbDt,     setEwbDt]     = useState("");
  const [validTill, setValidTill] = useState("");
  const [error,     setError]     = useState("");

  const handleConfirm = () => {
    const trimmed = ewbNo.trim();
    if (!trimmed) { setError("Please enter the E-Way Bill Number."); return; }
    if (!/^\d{12}$/.test(trimmed)) { setError("EWB Number must be exactly 12 digits."); return; }
    onUseExisting({ ewbNo: trimmed, ewbDt, ewbValidTill: validTill, status: "ACT", cancelDate: null });
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 10001, background: "rgba(0,0,0,0.65)", backdropFilter: "blur(5px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 16, width: 480, boxShadow: "0 32px 80px rgba(0,0,0,0.35)", animation: "modalPop 0.28s cubic-bezier(0.34,1.56,0.64,1)", overflow: "hidden" }}>
        <div style={{ background: "linear-gradient(135deg,#78350f,#b45309)", padding: "20px 24px", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>⚠️</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#fff" }}>E-Way Bill Already Generated</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.72)", marginTop: 2 }}>Error 604 — Same document number</div>
          </div>
        </div>
        <div style={{ padding: "22px 24px" }}>
          <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "12px 14px", marginBottom: 18, fontSize: 13, color: "#92400e", lineHeight: 1.6 }}>
            GST Portal says an E-Way Bill is already generated for this document.<br />
            <strong>Enter the existing EWB Number below</strong> to view, print, or cancel it.
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, letterSpacing: "0.5px", textTransform: "uppercase" }}>E-Way Bill Number <span style={{ color: "#dc2626" }}>*</span></label>
            <input type="text" className="form-control" placeholder="Enter 12-digit EWB Number" value={ewbNo} onChange={(e) => { setEwbNo(e.target.value.replace(/\D/g, "").slice(0, 12)); setError(""); }} maxLength={12} autoFocus style={{ fontSize: 16, fontFamily: "monospace", letterSpacing: 2, fontWeight: 700 }} />
            {error && <div style={{ color: "#dc2626", fontSize: 12, marginTop: 5 }}>⚠ {error}</div>}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: 20 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, textTransform: "uppercase" }}>Generated Date (optional)</label>
              <input type="date" className="form-control" value={ewbDt} onChange={(e) => setEwbDt(e.target.value)} style={{ fontSize: 13 }} />
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6, textTransform: "uppercase" }}>Valid Till (optional)</label>
              <input type="date" className="form-control" value={validTill} onChange={(e) => setValidTill(e.target.value)} style={{ fontSize: 13 }} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={onClose} style={{ flex: 1, padding: "10px 0", borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Cancel</button>
            <button onClick={handleConfirm} style={{ flex: 1.6, padding: "10px 0", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#0f172a,#1e3a5f)", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
              ✔ Use This EWB — Show Print &amp; Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  SHARED CONSTANTS
// ═══════════════════════════════════════════════════════════════
const CANCEL_REASONS = [
  { val: "1", label: "Duplicate" },
  { val: "2", label: "Order Cancelled" },
  { val: "3", label: "Data Entry Mistake" },
  { val: "4", label: "Others" },
];

const TRANS_MODES   = [{ val: "1", label: "Road" }, { val: "2", label: "Rail" }, { val: "3", label: "Air" }, { val: "4", label: "Ship" }];
const VEHICLE_TYPES = [{ val: "R", label: "Regular" }, { val: "O", label: "Over Dimensional Cargo (ODC)" }];

const VEHICLE_UPDATE_REASONS = [
  { val: "1", label: "Break Down" },
  { val: "2", label: "Trans Shipment" },
  { val: "3", label: "Others" },
  { val: "4", label: "First Time" },
];

const EXTEND_REASONS = [
  { val: "1",  label: "Natural Calamity" },
  { val: "2",  label: "Law & Order Situation" },
  { val: "3",  label: "Transhipment" },
  { val: "4",  label: "Accident" },
  { val: "99", label: "Others" },
];

const INDIA_STATES = [
  { val: "1",  label: "01 — Jammu & Kashmir" },
  { val: "2",  label: "02 — Himachal Pradesh" },
  { val: "3",  label: "03 — Punjab" },
  { val: "4",  label: "04 — Chandigarh" },
  { val: "5",  label: "05 — Uttarakhand" },
  { val: "6",  label: "06 — Haryana" },
  { val: "7",  label: "07 — Delhi" },
  { val: "8",  label: "08 — Rajasthan" },
  { val: "9",  label: "09 — Uttar Pradesh" },
  { val: "10", label: "10 — Bihar" },
  { val: "11", label: "11 — Sikkim" },
  { val: "12", label: "12 — Arunachal Pradesh" },
  { val: "13", label: "13 — Nagaland" },
  { val: "14", label: "14 — Manipur" },
  { val: "15", label: "15 — Mizoram" },
  { val: "16", label: "16 — Tripura" },
  { val: "17", label: "17 — Meghalaya" },
  { val: "18", label: "18 — Assam" },
  { val: "19", label: "19 — West Bengal" },
  { val: "20", label: "20 — Jharkhand" },
  { val: "21", label: "21 — Odisha" },
  { val: "22", label: "22 — Chhattisgarh" },
  { val: "23", label: "23 — Madhya Pradesh" },
  { val: "24", label: "24 — Gujarat" },
  { val: "25", label: "25 — Daman & Diu" },
  { val: "26", label: "26 — Dadra & Nagar Haveli" },
  { val: "27", label: "27 — Maharashtra" },
  { val: "28", label: "28 — Andhra Pradesh (Old)" },
  { val: "29", label: "29 — Karnataka" },
  { val: "30", label: "30 — Goa" },
  { val: "31", label: "31 — Lakshadweep" },
  { val: "32", label: "32 — Kerala" },
  { val: "33", label: "33 — Tamil Nadu" },
  { val: "34", label: "34 — Puducherry" },
  { val: "35", label: "35 — Andaman & Nicobar Islands" },
  { val: "36", label: "36 — Telangana" },
  { val: "37", label: "37 — Andhra Pradesh" },
  { val: "38", label: "38 — Ladakh" },
  { val: "97", label: "97 — Other Territory" },
  { val: "99", label: "99 — Centre Jurisdiction" },
];

// ═══════════════════════════════════════════════════════════════
//  CANCEL MODAL — Others → Remarks mandatory
// ═══════════════════════════════════════════════════════════════
function CancelEWBModal({ ewbNo, onConfirm, onClose, onAlert }) {
  const [reason,  setReason]  = useState("1");
  const [remarks, setRemarks] = useState("");

  const isOthers = reason === "4";

  const handleConfirm = () => {
    if (isOthers && !remarks.trim()) {
      onAlert("Remarks is required when Cancel Reason is 'Others'.", "error");
      return;
    }
    onConfirm(reason, remarks.trim() || "Cancelled by user");
  };

  const inputStyle = { width: "100%", padding: "8px 10px", border: "1.5px solid #d1d5db", borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 14, width: 460, padding: "32px 32px 24px", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)", border: "1px solid #fee2e2" }}>

        {/* Header */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: 20 }}>
          <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#fef2f2", border: "2px solid #fecaca", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14, fontSize: 24 }}>⛔</div>
          <div style={{ fontWeight: 700, fontSize: 17, color: "#111", marginBottom: 6 }}>Cancel E-Way Bill?</div>
          <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>This will cancel the EWB on the GST portal. This action is permanent.</div>
        </div>

        {/* EWB Number chip */}
        <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", marginBottom: 18 }}>
          <div style={{ fontSize: 10, color: "#9ca3af", fontWeight: 700, letterSpacing: "0.8px", marginBottom: 4 }}>E-WAY BILL NUMBER</div>
          <div style={{ fontFamily: "monospace", fontSize: 14, color: "#374151", fontWeight: 700 }}>{ewbNo}</div>
        </div>

        {/* Reason */}
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6, display: "block" }}>
            Cancel Reason <span style={{ color: "#dc2626" }}>*</span>
          </label>
          <select
            value={reason}
            onChange={(e) => { setReason(e.target.value); setRemarks(""); }}
            style={inputStyle}
          >
            {CANCEL_REASONS.map((r) => <option key={r.val} value={r.val}>{r.label}</option>)}
          </select>
        </div>

        {/* Remarks — always visible, mandatory only for Others */}
        <div style={{ marginBottom: 22 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
            Remarks
            {isOthers && <span style={{ color: "#dc2626" }}>*</span>}
            {isOthers && (
              <span style={{ fontSize: 10, color: "#dc2626", fontWeight: 500, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 4, padding: "1px 6px" }}>
                Required for Others
              </span>
            )}
          </label>
          <input
            type="text"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder={isOthers ? "Describe the reason for cancellation..." : "Optional remarks"}
            maxLength={100}
            style={{
              ...inputStyle,
              borderColor: isOthers && !remarks.trim() ? "#fca5a5" : "#d1d5db",
              background:  isOthers && !remarks.trim() ? "#fff7f7" : "#fff",
            }}
          />
          {isOthers && !remarks.trim() && (
            <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>
              ⚠ Please describe the reason before cancelling.
            </div>
          )}
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onClose}
            style={{ flex: 1, padding: 11, borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
          >
            Keep EWB
          </button>
          <button
            onClick={handleConfirm}
            style={{ flex: 1, padding: 11, borderRadius: 8, border: "none", background: "#dc2626", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}
          >
            ⛔ Cancel EWB
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  UPDATE VEHICLE MODAL — Reason dropdown + Others → Remarks + State dropdown
// ═══════════════════════════════════════════════════════════════
function UpdateVehicleModal({ ewbNo, onConfirm, onClose, onAlert }) {
  const [form, setForm] = useState({
    VehicleNo: "", VehicleType: "R",
    TransMode: "1",
    ReasonCode: "1", Remarks: "",
    FromPlace: "", FromState: "",
    RemainingDistance: "",
    TransDocNo: "", TransDocDate: "",
  });

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const isOthers = form.ReasonCode === "3";

  const handleConfirm = () => {
    if (!form.VehicleNo.trim())
      { onAlert("Vehicle Number is required.", "error"); return; }
    if (!form.FromPlace.trim())
      { onAlert("From Place is required.", "error"); return; }
    if (!form.FromState)
      { onAlert("From State is required.", "error"); return; }
    if (isOthers && !form.Remarks.trim())
      { onAlert("Remarks is required when reason is 'Others'.", "error"); return; }
    onConfirm(form);
  };

  const inputStyle  = { width: "100%", padding: "7px 10px", border: "1.5px solid #d1d5db", borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" };
  const labelStyle  = { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4, display: "block" };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 14, width: 560, padding: "28px 28px 22px", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
          <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#eff6ff", border: "2px solid #bfdbfe", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🚛</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#111" }}>Update Vehicle</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>EWB: <span style={{ fontFamily: "monospace", fontWeight: 600 }}>{ewbNo}</span></div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "13px 18px", marginBottom: 18 }}>

       
          <div>
            <label style={labelStyle}>Vehicle No <span style={{ color: "#dc2626" }}>*</span></label>
            <input style={inputStyle} value={form.VehicleNo} onChange={(e) => set("VehicleNo", e.target.value.toUpperCase())} placeholder="e.g. TN38AK1234" maxLength={20} />
          </div>
          <div>
            <label style={labelStyle}>Vehicle Type</label>
            <select style={inputStyle} value={form.VehicleType} onChange={(e) => set("VehicleType", e.target.value)}>
              {VEHICLE_TYPES.map((v) => <option key={v.val} value={v.val}>{v.label}</option>)}
            </select>
          </div>

          
          <div>
            <label style={labelStyle}>Transport Mode</label>
            <select style={inputStyle} value={form.TransMode} onChange={(e) => set("TransMode", e.target.value)}>
              {TRANS_MODES.map((m) => <option key={m.val} value={m.val}>{m.label}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Update Reason <span style={{ color: "#dc2626" }}>*</span></label>
            <select style={inputStyle} value={form.ReasonCode} onChange={(e) => { set("ReasonCode", e.target.value); set("Remarks", ""); }}>
              {VEHICLE_UPDATE_REASONS.map((r) => <option key={r.val} value={r.val}>{r.label}</option>)}
            </select>
          </div>

          {/* Others Remarks — full width, conditional */}
          {isOthers && (
            <div style={{ gridColumn: "1/-1" }}>
              <label style={{ ...labelStyle, display: "flex", alignItems: "center", gap: 6 }}>
                Remarks <span style={{ color: "#dc2626" }}>*</span>
                <span style={{ fontSize: 10, color: "#dc2626", fontWeight: 500, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 4, padding: "1px 6px" }}>
                  Required for Others
                </span>
              </label>
              <input
                style={{ ...inputStyle, borderColor: !form.Remarks.trim() ? "#fca5a5" : "#d1d5db", background: !form.Remarks.trim() ? "#fff7f7" : "#fff" }}
                value={form.Remarks}
                onChange={(e) => set("Remarks", e.target.value)}
                placeholder="Describe reason for vehicle update..."
                maxLength={100}
                autoFocus
              />
              {!form.Remarks.trim() && (
                <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>⚠ Please describe the reason.</div>
              )}
            </div>
          )}

          {/* Row 3 — From Place + From State (Dropdown) */}
          <div>
            <label style={labelStyle}>From Place <span style={{ color: "#dc2626" }}>*</span></label>
            <input style={inputStyle} value={form.FromPlace} onChange={(e) => set("FromPlace", e.target.value)} placeholder="City / Town" maxLength={50} />
          </div>
          <div>
            <label style={labelStyle}>From State <span style={{ color: "#dc2626" }}>*</span></label>
            <select style={inputStyle} value={form.FromState} onChange={(e) => set("FromState", e.target.value)}>
              <option value="">— Select State —</option>
              {INDIA_STATES.map((s) => <option key={s.val} value={s.val}>{s.label}</option>)}
            </select>
          </div>

          {/* Row 4 — Remaining Distance + Trans Doc No */}
          <div>
            <label style={labelStyle}>Remaining Distance (KM)</label>
            <input style={inputStyle} type="number" value={form.RemainingDistance} onChange={(e) => set("RemainingDistance", e.target.value)} placeholder="e.g. 200" min={0} />
          </div>
          <div>
            <label style={labelStyle}>Trans Doc No</label>
            <input style={inputStyle} value={form.TransDocNo} onChange={(e) => set("TransDocNo", e.target.value)} placeholder="Optional" maxLength={15} />
          </div>

          {/* Row 5 — Trans Doc Date */}
          <div style={{ gridColumn: "1/-1" }}>
            <label style={labelStyle}>Trans Doc Date</label>
            <input style={inputStyle} type="date" value={form.TransDocDate} onChange={(e) => set("TransDocDate", e.target.value)} max={new Date().toISOString().split("T")[0]} />
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, padding: 11, borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
            Cancel
          </button>
          <button onClick={handleConfirm} style={{ flex: 1, padding: 11, borderRadius: 8, border: "none", background: "#1d4ed8", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
            🚛 Update Vehicle
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  EXTEND VALIDITY MODAL — Others → ExtnRemarks + State dropdown
// ═══════════════════════════════════════════════════════════════
function ExtendModal({ ewbNo, onConfirm, onClose, onAlert }) {
  const [form, setForm] = useState({
    VehicleNo: "", VehicleType: "R",
    TransMode: "1", Consignment: "M",
    FromPlace: "", FromState: "", FromPincode: "",
    RemainingDistance: "",
    ExtnRsnCode: "1", ExtnRemarks: "",
    TransDocNo: "", TransDocDate: "",
  });

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const isOthers = form.ExtnRsnCode === "99";

  const handleConfirm = () => {
    if (!form.VehicleNo.trim())
      { onAlert("Vehicle Number is required.", "error"); return; }
    if (!form.FromPlace.trim())
      { onAlert("From Place is required.", "error"); return; }
    if (!form.FromState)
      { onAlert("From State is required.", "error"); return; }
    if (!form.FromPincode || String(form.FromPincode).length !== 6)
      { onAlert("From Pincode must be exactly 6 digits.", "error"); return; }
    if (!form.RemainingDistance || Number(form.RemainingDistance) <= 0)
      { onAlert("Remaining Distance (KM) must be greater than 0.", "error"); return; }
    if (isOthers && !form.ExtnRemarks.trim())
      { onAlert("Remarks is required when Extension Reason is 'Others'.", "error"); return; }
    onConfirm(form);
  };

  const inputStyle = { width: "100%", padding: "7px 10px", border: "1.5px solid #d1d5db", borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" };
  const labelStyle = { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4, display: "block" };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 14, width: 580, padding: "28px 28px 22px", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)", maxHeight: "92vh", overflowY: "auto" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
          <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#f0fdf4", border: "2px solid #bbf7d0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>⏳</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#111" }}>Extend EWB Validity</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>EWB: <span style={{ fontFamily: "monospace", fontWeight: 600 }}>{ewbNo}</span></div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "13px 18px", marginBottom: 18 }}>

          {/* Row 1 — Vehicle No + Type */}
          <div>
            <label style={labelStyle}>Vehicle No <span style={{ color: "#dc2626" }}>*</span></label>
            <input style={inputStyle} value={form.VehicleNo} onChange={(e) => set("VehicleNo", e.target.value.toUpperCase())} placeholder="e.g. TN38AK1234" maxLength={20} />
          </div>
          <div>
            <label style={labelStyle}>Vehicle Type</label>
            <select style={inputStyle} value={form.VehicleType} onChange={(e) => set("VehicleType", e.target.value)}>
              {VEHICLE_TYPES.map((v) => <option key={v.val} value={v.val}>{v.label}</option>)}
            </select>
          </div>

          {/* Row 2 — Trans Mode + Consignment */}
          <div>
            <label style={labelStyle}>Transport Mode</label>
            <select style={inputStyle} value={form.TransMode} onChange={(e) => set("TransMode", e.target.value)}>
              {TRANS_MODES.map((m) => <option key={m.val} value={m.val}>{m.label}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Consignment Type</label>
            <select style={inputStyle} value={form.Consignment} onChange={(e) => set("Consignment", e.target.value)}>
              <option value="M">Moving (M)</option>
              <option value="T">In Transit (T)</option>
              <option value="O">Others (O)</option>
            </select>
          </div>

          {/* Row 3 — From Place + From State (Dropdown) */}
          <div>
            <label style={labelStyle}>From Place <span style={{ color: "#dc2626" }}>*</span></label>
            <input style={inputStyle} value={form.FromPlace} onChange={(e) => set("FromPlace", e.target.value)} placeholder="City / Town" maxLength={50} />
          </div>
          <div>
            <label style={labelStyle}>From State <span style={{ color: "#dc2626" }}>*</span></label>
            <select style={inputStyle} value={form.FromState} onChange={(e) => set("FromState", e.target.value)}>
              <option value="">— Select State —</option>
              {INDIA_STATES.map((s) => <option key={s.val} value={s.val}>{s.label}</option>)}
            </select>
          </div>

          {/* Row 4 — From Pincode + Remaining Distance */}
          <div>
            <label style={labelStyle}>From Pincode <span style={{ color: "#dc2626" }}>*</span></label>
            <input
              style={inputStyle}
              type="text"
              inputMode="numeric"
              value={form.FromPincode}
              onChange={(e) => set("FromPincode", e.target.value.replace(/\D/g, "").slice(0, 6))}
              placeholder="e.g. 641001"
              maxLength={6}
            />
          </div>
          <div>
            <label style={labelStyle}>Remaining Distance (KM) <span style={{ color: "#dc2626" }}>*</span></label>
            <input style={inputStyle} type="number" value={form.RemainingDistance} onChange={(e) => set("RemainingDistance", e.target.value)} placeholder="e.g. 150" min={1} />
          </div>

          {/* Row 5 — Extension Reason + Trans Doc No */}
          <div>
            <label style={labelStyle}>Extension Reason <span style={{ color: "#dc2626" }}>*</span></label>
            <select style={inputStyle} value={form.ExtnRsnCode} onChange={(e) => { set("ExtnRsnCode", e.target.value); set("ExtnRemarks", ""); }}>
              {EXTEND_REASONS.map((r) => <option key={r.val} value={r.val}>{r.label}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Trans Doc No</label>
            <input style={inputStyle} value={form.TransDocNo} onChange={(e) => set("TransDocNo", e.target.value)} placeholder="Optional" maxLength={15} />
          </div>

          {/* Others Remarks — full width, conditional */}
          {isOthers && (
            <div style={{ gridColumn: "1/-1" }}>
              <label style={{ ...labelStyle, display: "flex", alignItems: "center", gap: 6 }}>
                Extension Remarks <span style={{ color: "#dc2626" }}>*</span>
                <span style={{ fontSize: 10, color: "#dc2626", fontWeight: 500, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 4, padding: "1px 6px" }}>
                  Required for Others
                </span>
              </label>
              <input
                style={{ ...inputStyle, borderColor: !form.ExtnRemarks.trim() ? "#fca5a5" : "#d1d5db", background: !form.ExtnRemarks.trim() ? "#fff7f7" : "#fff" }}
                value={form.ExtnRemarks}
                onChange={(e) => set("ExtnRemarks", e.target.value)}
                placeholder="Describe reason for validity extension..."
                maxLength={100}
                autoFocus
              />
              {!form.ExtnRemarks.trim() && (
                <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>⚠ Please describe the reason before extending.</div>
              )}
            </div>
          )}

          {/* Trans Doc Date — full width */}
          <div style={{ gridColumn: "1/-1" }}>
            <label style={labelStyle}>Trans Doc Date</label>
            <input style={inputStyle} type="date" value={form.TransDocDate} onChange={(e) => set("TransDocDate", e.target.value)} max={new Date().toISOString().split("T")[0]} />
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, padding: 11, borderRadius: 8, border: "1.5px solid #e5e7eb", background: "#f9fafb", color: "#374151", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
            Cancel
          </button>
          <button onClick={handleConfirm} style={{ flex: 1, padding: 11, borderRadius: 8, border: "none", background: "#16a34a", color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
            ⏳ Extend Validity
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  COPY EWB NUMBER
// ═══════════════════════════════════════════════════════════════
function CopyEWBNo({ ewbNo }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    if (!ewbNo) return;
    navigator.clipboard?.writeText(ewbNo)
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), 1800); })
      .catch(() => {
        const el = document.createElement("textarea");
        el.value = ewbNo;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        setCopied(true);
        setTimeout(() => setCopied(false), 1800);
      });
  };
  return (
    <button onClick={copy} title={copied ? "Copied!" : "Copy EWB No"} style={{ background: "none", border: "none", cursor: "pointer", padding: "2px 6px", borderRadius: 5, color: copied ? "#16a34a" : "#64748b", fontSize: 15, transition: "color 0.2s" }}>
      {copied ? "✔" : "⎘"}
    </button>
  );
}

// ═══════════════════════════════════════════════════════════════
//  FORMAT DATE HELPER
// ═══════════════════════════════════════════════════════════════
function formatEWBDate(raw) {
  if (!raw) return "";
  try {
    const str = String(raw).trim();

    // ── Format 1: "22/05/2026 11:59:00 PM"  or  "20/05/2026 11:48:00 AM"
    const m1 = str.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?)?$/i);
    if (m1) {
      const [, dd, mm, yyyy, hRaw, min, ampm] = m1;
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      const monStr = months[parseInt(mm, 10) - 1] || mm;
      if (hRaw) {
        let h = parseInt(hRaw, 10);
        const ap = (ampm || "").toUpperCase();
        if (ap === "PM" && h < 12) h += 12;
        if (ap === "AM" && h === 12) h = 0;
        const hDisp = h % 12 === 0 ? 12 : h % 12;
        const suffix = h < 12 ? "AM" : "PM";
        return `${dd} ${monStr} ${yyyy} · ${String(hDisp).padStart(2,"0")}:${min} ${suffix}`;
      }
      return `${dd} ${monStr} ${yyyy}`;
    }

    // ── Format 2: "2026-05-20T11:48:00" or "2026-05-20 11:48:00 AM"
    const parts = str.replace("T", " ").split(" ");
    const datePart = parts[0] || "";
    const timePart = parts[1] || "";
    const ampm     = parts[2] || "";

    let d;
    if (datePart.includes("/")) {
      const [dd, mm, yyyy] = datePart.split("/");
      d = new Date(`${yyyy}-${mm}-${dd}`);
    } else {
      d = new Date(datePart);
    }
    if (isNaN(d)) return raw;

    const day = String(d.getDate()).padStart(2, "0");
    const mon = d.toLocaleString("en-IN", { month: "short" });
    const yr  = d.getFullYear();

    const timeStr = timePart
      ? ` · ${timePart.substring(0, 5)}${ampm ? " " + ampm : ""}`
      : "";

    return `${day} ${mon} ${yr}${timeStr}`;
  } catch { return raw; }
}

// ═══════════════════════════════════════════════════════════════
//  MAIN COMPONENT — EWayBill
// ═══════════════════════════════════════════════════════════════
function EWayBill() {
  const dispatch     = useDispatch();
  const _Common      = useSelector((store) => store.states.Common);
  const _HT          = useSelector((store) => store.states.Header);
  const _selecrparem = useSelector((state) => state.SelectOption.parems);

  // ── States ─────────────────────────────────────────────────
  const [iScrId,        setiScrId]        = useState(0);
  const [isSetting,     setisSetting]     = useState(false);
  const [iAreaId,       setiAreaId]       = useState(0);
  const [iColId,        setiColId]        = useState(0);
  const [strColName,    setstrColName]    = useState("");
  const [strAliasName,  setstrAliasName]  = useState("");
  const [strDatatype,   setstrDatatype]   = useState("string");
  const [strTransName,  setstrTransName]  = useState("");
  const [strdefaultval, setstrdefaultval] = useState("");
  const [strval,        setstrval]        = useState("");
  const [isShow,        setisShow]        = useState(true);

  const [ListEntItem, setListEntItem] = useState([]);
  const [arrEntArea,  setarrEntArea]  = useState([]);
  const [arrEntCol,   setarrEntCol]   = useState([]);
  const [EntJsonEwb,  setEntJsonEwb]  = useState([]);

  // ── EWB Response ────────────────────────────────────────────
  const [ewbResp, setEwbResp] = useState(null);

  // ── Modal states ────────────────────────────────────────────
  const [showCancelModal,    setShowCancelModal]    = useState(false);
  const [showVehicleModal,   setShowVehicleModal]   = useState(false);
  const [showExtendModal,    setShowExtendModal]    = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  // ── Credential popup ────────────────────────────────────────
  const [showCredPopup, setShowCredPopup] = useState(false);
  const [nicCred,       setNicCred]       = useState({ ApiUserName: "", ApiPassword: "" });
  const [credSaving,    setCredSaving]    = useState(false);

  // ── Validation modal (exact EInvoice flow) ──────────────────
  const [showValidModal, setShowValidModal] = useState(false);
  const [validErrors,    setValidErrors]    = useState([]);
  const [validWarnings,  setValidWarnings]  = useState([]);

  // ── Toast ───────────────────────────────────────────────────
  const [toasts, setToasts] = useState([]);
  const showToast = useCallback((message, type = "success", duration = 3500) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), duration);
  }, []);
  const dismissToast = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

  // ── Alert helper ────────────────────────────────────────────
  const AlertMessage = (Message, Icon) => {
    dispatch(Show_MsgBox({ Message, Type: Icon, isMsg: true }));
  };

  // ── Status helpers ──────────────────────────────────────────
  const hasEWBNo    = ewbResp?.ewbNo;
  const isActive    = hasEWBNo && ewbResp?.status !== "CNL";
  const isCancelled = hasEWBNo && ewbResp?.status === "CNL";

 
  // Parent already passes the correct SelectedVouchId at mount time
  useEffect(() => {
    Load_EWayBill(_Common.iScrId, _HT.SelectedVouchId);
  }, []);

  // ──────────────────────────────────────────────────────────────
  //  LOAD
  // ──────────────────────────────────────────────────────────────
  const Load_EWayBill = async (ScrId, VouchId) => {
    try {
      setiScrId(ScrId);
      dispatch(setload_Screen(true));
      const Res = await userApp.get(
        `GST/Load_EWayBill/${ScrId}/${VouchId}/${Number(localStorage.ComId)}/${Number(localStorage.FYId)}/${localStorage.db}/${localStorage.Msdb}`
      );
      if (Res.data.strStatus === "Success") {
        await AssignVoucher_Data(ScrId, Res.data);
        const ewb = Res.data.EWayBill || Res.data.eWayBill || null;
        // DB returns PascalCase (EwbNo, EwbDt, EwbValidTill, Status, CancelDate)
        // check both cases so either works
        const ewbNo = ewb?.EwbNo || ewb?.ewbNo || "";
if (ewb && ewbNo) {
  setEwbResp(prev => ({
    ...(prev || {}),
    ewbNo:        ewb.EwbNo        || ewb.ewbNo        || "",
    ewbDt:        ewb.EwbDt        || ewb.ewbDt        || "",
    ewbValidTill: ewb.EwbValidTill || ewb.ewbValidTill || "",
    status:       ewb.Status       || ewb.status       || "ACT",
    cancelDate:   ewb.CancelDate   || ewb.cancelDate   || null,
    vehicleNo:    ewb.VehicleNo    || ewb.vehicleNo    || prev?.vehicleNo || "",
    transMode:    ewb.TransMode    || ewb.transMode    || prev?.transMode || "",
    vehicleType:  ewb.VehicleType  || ewb.vehicleType  || prev?.vehicleType || "",
    transDocNo:   ewb.TransDocNo   || ewb.transDocNo   || prev?.transDocNo || "",
    transDocDate: ewb.TransDocDate || ewb.transDocDate || prev?.transDocDate || "",
    // ── EInvoice-linked fields (null if normal EWB) ──
    distance:     Number(ewb.Distance || ewb.distance || 0) || prev?.distance || 0,
    irn:   ewb.Irn   || ewb.irn   || null,
    ackNo: ewb.AckNo || ewb.ackNo || null,
    ackDt: ewb.AckDt || ewb.ackDt || null,
  }));
} else {
          setEwbResp(null);   // this invoice has no EWB — safe to clear now
        }
      } else {
        setEwbResp(null);
      }
    } catch (err) {
      showToast(err?.message || "Failed to load E-Way Bill data.", "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ──────────────────────────────────────────────────────────────
  //  ASSIGN VOUCHER DATA
  // ──────────────────────────────────────────────────────────────
  const AssignVoucher_Data = async (ScrId, InvtDT) => {
    const EntArea    = InvtDT.EntArea;
    const EntCol     = InvtDT.EntCol;
    const EntTax     = InvtDT.objEntTax;
    const EntSummary = InvtDT.objEntSummary;
    let   Summary    = EntSummary[0];
    const EntHT      = InvtDT.objEntHT;
    const EntParty   = InvtDT.Party;
    const EntShipAdd = InvtDT.EntShippingAdd;
    const EntCompany = InvtDT.Company;
    const EntItem    = InvtDT.objEntDT;
    const TaxRelId       = EntHT[0].iTaxTypeId;
    const iTCSApplicable = EntHT[0].iTCSApplicable;

    let dSGST = 0, dCGST = 0, dIGST = 0, dCESS = 0, dTCS = 0;

    const checkbuyerseller = (arrParty, arrcompany, type) => {
      switch (ScrId) {
        case 11: return type === "Sell" ? arrParty   : arrcompany;
        case 17: return type === "Sell" ? arrcompany : arrParty;
        case 67: return type === "Sell" ? arrcompany : arrParty;
        case 73: return type === "Sell" ? arrcompany : arrParty;
        case 76: return type === "Sell" ? arrParty   : arrcompany;
        case 78: return type === "Sell" ? arrParty   : arrcompany;
        default: return type === "Sell" ? arrParty   : arrcompany; // ✅ safe fallback — no undefined crash
      }
    };

    EntTax.forEach((dt) => {
      if      (dt.taxDesc.startsWith("SGST") && TaxRelId === 1) dSGST += dt.taxAmt;
      else if (dt.taxDesc.startsWith("CGST") && TaxRelId === 1) dCGST += dt.taxAmt;
      else if (dt.taxDesc.startsWith("IGST") && TaxRelId === 2) dIGST += dt.taxAmt;
      else if (dt.taxDesc.startsWith("CESS"))                   dCESS += dt.taxAmt;
      else if (dt.taxDesc.startsWith("TCS") && iTCSApplicable === 1) dTCS += dt.taxAmt;
    });

    Summary = { ...Summary, sgst: dSGST, cgst: dCGST, igst: dIGST, cess: dCESS, tcs: dTCS };

    const objData = [
      { iAreaId: 1, data: EntHT[0] },
      { iAreaId: 2, data: EntHT[0] },
      { iAreaId: 3, data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell") },
      { iAreaId: 4, data: checkbuyerseller(EntParty[0], EntCompany[0], "Buy") },
      { iAreaId: 5, data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell") },
      { iAreaId: 6, data: EntShipAdd || EntParty[0] || {} },
      { iAreaId: 7, data: Summary },
      { iAreaId: 8, data: EntHT[0] },
      { iAreaId: 9, data: EntItem },
    ];

    let objEwb = {};

    EntArea.forEach((area) => {
      const AreaCol = EntCol.filter((col) => col.iAreaId === area.iAreaId);
      const Entdt   = objData.filter((col) => col.iAreaId === area.iAreaId)[0].data;

      if (area.iAreaId !== 9) {
        let objDT = {};
        AreaCol.forEach((col) => {
          if (col.strConditionCol === "") {
            if (col.strdatatype === "cmb")
              objDT = { ...objDT, [col.strGstcolName]: col.strValue };
            else if (col.strdatatype === "decimal")
              objDT = { ...objDT, [col.strGstcolName]: Number(col.strdefaultvalue) };
            else
              objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
          } else {
            let value = Entdt[col.strConditionCol];
            if (col.strGstcolName === "docDate" || col.strGstcolName === "transDocDate") {
              if (value) {
                const dt = new Date(value);
                if (!isNaN(dt))
                  value = `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
                else value = "";
              }
            } else if (["fromPincode", "toPincode", "fromStateCode", "toStateCode"].includes(col.strGstcolName)) {
              value = value ? String(value) : "";
            } else if (col.strdatatype === "decimal") {
              value = value ? Number(value) : 0;
            }
            objDT = { ...objDT, [col.strGstcolName]: value };
          }
        });
        objEwb = { ...objEwb, [area.strAreaCol]: objDT };
      } else {
        const arrItem = [];
        Entdt.forEach((dt) => {
          let objDT = {};
          AreaCol.forEach((col) => {
            if (col.strConditionCol === "") {
              if (col.strdatatype === "decimal") {
switch (col.strGstcolName) {
  case "IgstAmt":
    objDT = { ...objDT, [col.strGstcolName]: TaxRelId === 2 ? Number(dt.taxAmt || 0) : 0 };
    break;
  case "CgstAmt":
  case "SgstAmt":
    objDT = { ...objDT, [col.strGstcolName]: TaxRelId === 1 ? Number(dt.taxAmt || 0) / 2 : 0 };
    break;
  default:
    objDT = { ...objDT, [col.strGstcolName]: Number(col.strdefaultvalue) };
    break;
}
              } else {
                objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
              }
            } else {
              let v = dt[col.strConditionCol];
              if (col.strdatatype === "decimal") v = v ? Number(v) : 0;
              else if (col.strGstcolName === "hsnCode") {
                v = v ? String(v) : null;
                if (v && v.length > 8) v = v.substring(0, 8);
              }
              objDT = { ...objDT, [col.strGstcolName]: v };
            }
          });
          arrItem.push(objDT);
        });
        setListEntItem(arrItem);
        objEwb = { ...objEwb, itemList: arrItem };
      }
    });

if (objEwb.DocDtls?.Dt?.includes("-")) {
      const p = objEwb.DocDtls.Dt.split("-");
      if (p.length === 3) objEwb.DocDtls.Dt = `${p[2]}/${p[1]}/${p[0]}`;
    }
    if (objEwb.docDetails?.docDate?.includes("-")) {
      const p = objEwb.docDetails.docDate.split("-");
      if (p.length === 3) objEwb.docDetails.docDate = `${p[2]}/${p[1]}/${p[0]}`;
    }

    // ══════════════════════════════════════════════════════════
    //  ✅ FIX — Same root cause as EInvoice NIC 2174
    //  "For inter-state transaction, CGST and SGST amounts are not
    //   applicable; only IGST amount is applicable"
    //
    //  ROOT CAUSE: CGST/SGST vs IGST was decided using the
    //  voucher's stored TaxRelId flag (or a Trans-Name column that
    //  bypasses it entirely). Under GST law, interstate vs
    //  intrastate is decided ONLY by comparing Seller's state code
    //  vs Buyer's state code — not by what was selected when the
    //  voucher was created.
    //
    //  FIX: after the full EWB object is built, do a final
    //  correction pass — compare the ACTUAL SellerDtls.Stcd vs
    //  BuyerDtls.Stcd and reallocate the already-computed total tax
    //  (IgstAmt + CgstAmt + SgstAmt, whatever their current split)
    //  onto the correct field(s) per item, keeping the total tax
    //  amount unchanged — only WHERE it's placed changes. Also
    //  resyncs ValDtls totals and the on-screen item table so what
    //  the user sees always matches exactly what gets sent to NIC.
    // ══════════════════════════════════════════════════════════
    const sellerStcdEwb = String(objEwb.SellerDtls?.Stcd || "");
    const buyerStcdEwb  = String(objEwb.BuyerDtls?.Stcd  || "");
    if (sellerStcdEwb && buyerStcdEwb && Array.isArray(objEwb.itemList)) {
      const isInterStateEwb = sellerStcdEwb !== buyerStcdEwb;
      objEwb.itemList = objEwb.itemList.map((item) => {
        const totalTax = Number(item.IgstAmt || 0) + Number(item.CgstAmt || 0) + Number(item.SgstAmt || 0);
        const it = { ...item };
        if (isInterStateEwb) {
          it.IgstAmt = Number(totalTax.toFixed(2));
          it.CgstAmt = 0;
          it.SgstAmt = 0;
        } else {
          const half = Number((totalTax / 2).toFixed(2));
          it.CgstAmt = half;
          it.SgstAmt = half;
          it.IgstAmt = 0;
        }
        return it;
      });
      if (objEwb.ValDtls) {
        objEwb.ValDtls.IgstVal = Number(
          objEwb.itemList.reduce((s, it) => s + Number(it.IgstAmt || 0), 0).toFixed(2),
        );
        objEwb.ValDtls.CgstVal = Number(
          objEwb.itemList.reduce((s, it) => s + Number(it.CgstAmt || 0), 0).toFixed(2),
        );
        objEwb.ValDtls.SgstVal = Number(
          objEwb.itemList.reduce((s, it) => s + Number(it.SgstAmt || 0), 0).toFixed(2),
        );
      }
      setListEntItem(objEwb.itemList);
    }

    await View_Distance(objEwb);
    setarrEntArea(EntArea);
    setarrEntCol(EntCol);
  };

  // ──────────────────────────────────────────────────────────────
  //  DISTANCE CALCULATION
  // ──────────────────────────────────────────────────────────────
  const View_Distance = async (objEwb) => {
    try {
     const p1 = objEwb["SellerDtls"]?.["Pin"] || objEwb["fromDetails"]?.["fromPincode"];
const p2 = objEwb["BuyerDtls"]?.["Pin"]  || objEwb["ShipDtls"]?.["Pin"] || objEwb["toDetails"]?.["toPincode"];

      if (!objEwb["EwbDtls"]) objEwb["EwbDtls"] = {};

      if (!p1 || !p2) {
        objEwb["EwbDtls"]["Distance"] = 0;
      } else {
        const c1 = await fetchCoordinates(p1);
        const c2 = await fetchCoordinates(p2);
        if (!c1 || !c2) {
          objEwb["EwbDtls"]["Distance"] = 0;
        } else {
          let roadDistance = 0;
          try {
            const osrmRes  = await fetch(`https://router.project-osrm.org/route/v1/driving/${c1.lon},${c1.lat};${c2.lon},${c2.lat}?overview=false`);
            const osrmData = await osrmRes.json();
            if (osrmData.code === "Ok" && osrmData.routes?.length > 0)
              roadDistance = Math.round(osrmData.routes[0].distance / 1000);
            else throw new Error("OSRM no route");
          } catch {
            const R = 6371e3,
              φ1 = (c1.lat * Math.PI) / 180, φ2 = (c2.lat * Math.PI) / 180,
              Δφ = ((c2.lat - c1.lat) * Math.PI) / 180,
              Δλ = ((c2.lon - c1.lon) * Math.PI) / 180;
            const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
            roadDistance = Math.round(((R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) / 1000) * 1.35);
          }
          objEwb["EwbDtls"]["Distance"] = roadDistance;
        }
      }
      setEntJsonEwb([objEwb]);
    } catch (err) {
      showToast(err.message, "error");
      setEntJsonEwb([objEwb]);
    }
  };

  const fetchCoordinates = async (pincode) => {
    try {
      const res  = await fetch(`https://nominatim.openstreetmap.org/search?q=${pincode}&countrycodes=in&format=json`);
      const data = await res.json();
      return data?.length > 0 ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) } : null;
    } catch { return null; }
  };

  // ──────────────────────────────────────────────────────────────
  //  INPUT CHANGE
  // ──────────────────────────────────────────────────────────────
  const Input_Onchange = (val, element, area) => {
    setEntJsonEwb((prev) => {
      const arrJson = prev.map((json) => {
        const updated = { ...json };
        switch (element.strdatatype) {
          case "decimal":
            updated[area.strAreaCol] = { ...updated[area.strAreaCol], [element.strGstcolName]: Number(val) };
            break;
          default:
            updated[area.strAreaCol] = { ...updated[area.strAreaCol], [element.strGstcolName]: val };
            break;
        }
        return updated;
      });
      if (element.strGstcolName === "Pin" && String(val).length === 6) {
        const updatedEwb = arrJson[0];
        if (updatedEwb) setTimeout(() => View_Distance(updatedEwb), 0);
      }
      return arrJson;
    });
  };

  // ──────────────────────────────────────────────────────────────
  //  VALIDATE — full NIC EWB rules
  // ──────────────────────────────────────────────────────────────
  const validateEWayBill = () => {
    const ewb = EntJsonEwb?.[0];
    const errors = [], warnings = [];

    if (!ewb) {
      errors.push("EWB data not loaded. Please refresh and try again.");
      return { errors, warnings };
    }

    // ── Document ──────────────────────────────────────────────
    const docNo = ewb.DocDtls?.No || "";
    if (!docNo)
      errors.push("Invoice / Document Number is missing.");
    else if (!/^([a-zA-Z1-9]{1}[a-zA-Z0-9\/\-]{0,15})$/.test(docNo.trim()))
      errors.push(`Invoice Number "${docNo}" is invalid — only letters, numbers, / and - allowed. Max 16 chars.`);

    if (!ewb.DocDtls?.Dt) {
      errors.push("Document Date is missing.");
    } else {
      const docDt = ewb.DocDtls.Dt;
      const parts = docDt.includes("-") ? docDt.split("-").reverse() : docDt.split("/");
      const dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      if (isNaN(dt))
        errors.push(`Document Date "${docDt}" is invalid. Expected format: DD/MM/YYYY.`);
      else if (dt > new Date())
        errors.push(`Document Date "${docDt}" is a future date — NIC does not allow future-dated documents.`);
    }

    // ── From (Seller) ─────────────────────────────────────────
    const fromGstin = ewb.SellerDtls?.Gstin || "";
    if (!fromGstin)
      errors.push("Seller (From) GSTIN is missing — mandatory for E-Way Bill.");
    else if (fromGstin.length !== 15 && fromGstin !== "URP")
      errors.push(`Supplier GSTIN "${fromGstin}" must be 15 characters or 'URP'.`);

    const fromPin = String(ewb.SellerDtls?.Pin || "");
    if (!fromPin || fromPin.length !== 6 || isNaN(fromPin))
      errors.push(`From Pincode "${fromPin || "empty"}" must be exactly 6 digits.`);

    const fromLoc = ewb.SellerDtls?.Loc || "";
    if (!fromLoc) errors.push("Seller Location (city/town name) is missing.");

    const fromAddr1 = ewb.SellerDtls?.Addr1 || "";
    if (!fromAddr1) errors.push("Seller Address Line 1 is missing — required by NIC portal.");

    const fromStcd = String(ewb.SellerDtls?.Stcd || "");
    if (!fromStcd) errors.push("Seller State Code is missing — required for GST computation.");

    // ── To (Buyer) ────────────────────────────────────────────
    const toGstin = ewb.BuyerDtls?.Gstin || "";
    if (!toGstin)
      errors.push('Recipient GSTIN is missing — mandatory for E-Way Bill (use "URP" for unregistered buyers).');
    else if (toGstin.length !== 15 && toGstin !== "URP")
      errors.push(`Recipient GSTIN "${toGstin}" must be 15 characters or 'URP'.`);

    const toPin = String(ewb.BuyerDtls?.Pin || "");
    if (!toPin || toPin.length !== 6 || isNaN(toPin))
      errors.push(`To Pincode "${toPin || "empty"}" must be exactly 6 digits.`);

    const toLoc = ewb.BuyerDtls?.Loc || "";
    if (!toLoc) errors.push("Buyer Location (city/town name) is missing.");

    const toAddr1 = ewb.BuyerDtls?.Addr1 || "";
    if (!toAddr1) errors.push("Buyer Address Line 1 is missing — required by NIC portal.");

    const toStcd = String(ewb.BuyerDtls?.Stcd || "");
    if (!toStcd) errors.push("Buyer State Code (Place of Supply) is missing — required for GST computation.");

    // ── EWB Transport Details ─────────────────────────────────
    const ewbDtls = ewb.EwbDtls || {};
    const transId = String(ewbDtls.TransId || "").trim();
    {
      const transMode = String(ewbDtls.TransMode || "").trim();
      if (!transMode)
        errors.push("Transport Mode is missing — select: 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).");
      else if (!["1", "2", "3", "4"].includes(transMode))
        errors.push(`Transport Mode "${transMode}" is invalid — must be 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).`);

      const vehNo = String(ewbDtls.VehNo || "").trim();
      if (!vehNo && !transId)
        errors.push("Vehicle Number is missing — NIC requires Vehicle Number (4–20 characters, e.g. TN01AB1234) when no Transporter ID is provided.");
      else if (vehNo && vehNo.length < 4)
        errors.push(`Vehicle Number "${vehNo}" is too short — minimum 4 characters required.`);
      else if (vehNo && vehNo.length > 20)
        errors.push(`Vehicle Number "${vehNo}" is too long — maximum 20 characters allowed.`);
      else if (vehNo && !/^[A-Z0-9]+$/i.test(vehNo))
        errors.push(`Vehicle Number "${vehNo}" contains invalid characters — only letters and numbers allowed.`);

      if (ewbDtls.Distance === undefined || ewbDtls.Distance === null || ewbDtls.Distance === "") {
        errors.push("Distance (km) is missing — mandatory for E-Way Bill generation.");
      } else {
        const distance = Number(ewbDtls.Distance || 0);
        if (distance <= 0)
          errors.push("Distance must be greater than 0 km — verify seller and buyer pincodes are correct.");
        else if (distance > 4000)
          warnings.push(`Distance of ${distance} km seems unusually high — please verify pincodes.`);
      }

      const vehType = ewbDtls.VehType || "";
      if (vehType && !["R", "O"].includes(vehType))
        errors.push(`Vehicle Type "${vehType}" is invalid — must be R (Regular) or O (ODC).`);

      const transDocNo = String(ewbDtls.TransDocNo || "").trim();
      if (transDocNo && (transDocNo.length < 1 || transDocNo.length > 15))
        errors.push(`Transport Document No "${transDocNo}" must be between 1 and 15 characters.`);
    }

    // ── Items ─────────────────────────────────────────────────
    const items = ewb.itemList || [];
    if (!items.length)
      errors.push("No items found — at least 1 item is required.");
    else if (items.length > 250)
      errors.push(`Invoice has ${items.length} items — NIC EWB allows maximum 250 items.`);
    else {
      items.forEach((item, i) => {
        const n    = i + 1;
        const name = item.PrdDesc || `Item ${n}`;

        if (!item.PrdDesc || String(item.PrdDesc).trim().length < 3)
          errors.push(`Item ${n}: Product Description is missing or too short — minimum 3 characters required.`);

        const hsnCd = String(item.HsnCd || "").trim();
        if (!hsnCd)
          errors.push(`Item ${n} (${name}): HSN Code is missing.`);
        else if (!/^\d+$/.test(hsnCd))
          errors.push(`Item ${n} (${name}): HSN Code must contain digits only.`);
        else if (hsnCd.length < 4 || hsnCd.length > 8)
          errors.push(`Item ${n} (${name}): HSN Code must be 4–8 digits.`);

        if (!item.Unit)
          errors.push(`Item ${n} (${name}): Unit of measurement is missing (e.g. NOS, KGS, MTR, LTR).`);

        if (!(Number(item.AssAmt ?? item.TotAmt ?? 0) > 0))
          errors.push(`Item ${n} (${name}): Taxable Amount must be greater than 0.`);
        if (!(Number(item.Qty || 0) > 0))
          errors.push(`Item ${n} (${name}): Quantity must be greater than 0.`);

        const gstRt = Number(item.GstRt || 0);
        if (gstRt < 0)
          errors.push(`Item ${n} (${name}): GST Rate cannot be negative.`);
        else if (![0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28].includes(gstRt))
          warnings.push(`Item ${n} (${name}): GST Rate ${gstRt}% is non-standard — verify it's a valid GST slab.`);
      });
    }

    // ── Value Details ─────────────────────────────────────────
    if (!(Number(ewb.ValDtls?.TotInvVal || 0) > 0))
      errors.push("Total Invoice Value must be greater than 0.");

    const assAmt = Number(ewb.ValDtls?.AssVal || 0);
    if (assAmt <= 0)
      warnings.push("Assessable Value (AssVal) in Value Details is 0 — please verify invoice totals are correct.");

    return { errors, warnings };
  };

  // ──────────────────────────────────────────────────────────────
  //  HANDLE GENERATE CLICK — exact EInvoice flow
  //  1. guard: already generated?  2. validate  3. open ValidationModal
  // ──────────────────────────────────────────────────────────────
  const Handle_Generate_Click = () => {
    // ── GUARD: EWB already exists for this invoice ──────────────
    if (ewbResp?.ewbNo) {
      showToast(
        `E-Way Bill ${ewbResp.ewbNo} already generated for this invoice. Use Print / Cancel / Extend buttons.`,
        "warning",
        5000
      );
      return;
    }
    const { errors, warnings } = validateEWayBill();
    setValidErrors(errors);
    setValidWarnings(warnings);
    setShowValidModal(true);
  };

  // ──────────────────────────────────────────────────────────────
  //  BUILD EWB PAYLOAD
  // ──────────────────────────────────────────────────────────────
const buildEwbPayload = (ewb) => {
    const toEwbDate = (d) => {
      if (!d) return "";
      if (d.includes("-")) { const [y, m, dd] = d.split("-"); return `${dd}/${m}/${y}`; }
      return d;
    };
    return {
      supplyType:        "O",
      subSupplyType:     "1",
      docType:           ewb.DocDtls?.Typ  || "INV",
      docNo:             ewb.DocDtls?.No   || "",
      docDate:           toEwbDate(ewb.DocDtls?.Dt || ""),

      fromGstin:         ewb.SellerDtls?.Gstin  || "",
      fromTrdName:       ewb.SellerDtls?.TrdNm  || "",
      fromAddr1:         ewb.SellerDtls?.Addr1  || "",
      fromAddr2:         ewb.SellerDtls?.Addr2  || "",
      fromPlace:         ewb.SellerDtls?.Loc    || "",
      fromPincode:       Number(ewb.SellerDtls?.Pin)  || 0,
      fromStateCode:     Number(ewb.SellerDtls?.Stcd) || 0,
      actFromStateCode:  Number(ewb.SellerDtls?.Stcd) || 0,

      toGstin:           ewb.BuyerDtls?.Gstin   || "",
      toTrdName:         ewb.BuyerDtls?.TrdNm   || "",
      toAddr1:           ewb.BuyerDtls?.Addr1   || "",
      toAddr2:           ewb.BuyerDtls?.Addr2   || "",
      toPlace:           ewb.BuyerDtls?.Loc     || "",
      toPincode:         Number(ewb.BuyerDtls?.Pin)   || 0,
      toStateCode:       Number(ewb.BuyerDtls?.Stcd)  || 0,
      actToStateCode:    Number(ewb.BuyerDtls?.Stcd)  || 0,

      transactionType:   1,

      totalValue:        Number(ewb.ValDtls?.AssVal)    || 0,
      cgstValue:         Number(ewb.ValDtls?.CgstVal)   || 0,
      sgstValue:         Number(ewb.ValDtls?.SgstVal)   || 0,
      igstValue:         Number(ewb.ValDtls?.IgstVal)   || 0,
      cessValue:         Number(ewb.ValDtls?.CesVal)    || 0,
      cessNonAdvolValue: 0,
      totInvValue:       Number(ewb.ValDtls?.TotInvVal) || 0,

      transporterId:     "",
      transporterName:   "",
      transDocNo:        ewb.EwbDtls?.TransDocNo   || "",
      transDocDate:      ewb.EwbDtls?.TransDocDate || "",
      transMode:         ewb.EwbDtls?.TransMode    || "1",
      transDistance:     Number(ewb.EwbDtls?.Distance) || 1,
      vehicleNo:         ewb.EwbDtls?.VehNo    || "",
      vehicleType:       ewb.EwbDtls?.VehType  || "R",

      // ✅ FIX — rate fields ku RATE(%) pass pannanum, AMOUNT illa.
      // item.GstRt = actual % slab (18, 12, 5...). item.IgstAmt/CgstAmt/SgstAmt
      // ella "amount" (₹) — andha rendaiyum swap pannadha, NIC "Invalid Tax Rate" (254) throw pannum.
      itemList: (ewb.itemList || []).map((item, i) => {
        const gstRate = Number(item.GstRt) || 0;
        const isIgst  = Number(item.IgstAmt) > 0;   // interstate item-ah check

        return {
          itemNo:        i + 1,
          productName:   item.PrdDesc   || "",
          productDesc:   item.PrdDesc   || "",
          hsnCode:       String(item.HsnCd || ""),
          quantity:      Number(item.Qty)     || 0,
          qtyUnit:       item.Unit            || "NOS",
          taxableAmount: Number(item.AssAmt)  || 0,
          sgstRate:      isIgst ? 0 : Number((gstRate / 2).toFixed(2)),
          cgstRate:      isIgst ? 0 : Number((gstRate / 2).toFixed(2)),
          igstRate:      isIgst ? gstRate : 0,
          cessRate:      Number(item.CesRt) || 0,   // ✅ CesAmt இல்ல, CesRt (rate)
        };
      }),
    };
  };

  // ──────────────────────────────────────────────────────────────
  //  GENERATE EWB — called from ValidationModal onProceed
  // ──────────────────────────────────────────────────────────────
  const Create_EWayBill = async () => {
    try {
      // ── Safety net: if EWB was loaded between modal open and confirm ──
      if (ewbResp?.ewbNo) {
        showToast(
          `E-Way Bill ${ewbResp.ewbNo} already exists. Generation aborted.`,
          "warning",
          5000
        );
        return;
      }

      dispatch(setload_Screen(true));

      const ewbJson = buildEwbPayload(EntJsonEwb[0]);
      console.log("FULL EWB JSON:", JSON.stringify(EntJsonEwb[0], null, 2));

      const payload = {
        iSalInvId:    _HT.SelectedVouchId,
        iClientId:    Number(localStorage.ClientId),
        strCompanyDB: localStorage.db,
        EntJsonEwb:   JSON.stringify(ewbJson),
      };

      const res = await userApp.post("GST/Generate_EWayBill", payload);

      if (res?.data?.strStatus === "Success") {
        const d = res.data.data;
        const mapped = {
          // Backend EWayBillResponseModel props (EwbNo, EwbDt, EwbValidTill)
          // + actual TaxPro API fields (ewayBillNo, ewayBillDate, validUpto) as fallback
          ewbNo:        d?.EwbNo        || d?.ewbNo        || d?.ewayBillNo?.toString()  || "",
          ewbDt:        d?.EwbDt        || d?.ewbDt        || d?.ewayBillDate             || "",
          ewbValidTill: d?.EwbValidTill || d?.ewbValidTill || d?.validUpto                || "",
          status:       d?.Status       || d?.status       || "ACT",
          cancelDate:   d?.CancelDate   || d?.cancelDate   || null,
        };
        if (!mapped.ewbNo) {
          showToast("EWB Number not received from server. Please try again.", "error");
          return;
        }
        setEwbResp(mapped);
        setShowValidModal(false); // ✅ Validation modal close பண்ணு
        showToast("E-Way Bill generated successfully!", "success");
      } else {
        showToast(res.data?.strMessage || "Generation failed. Please try again.", "error");
      }
    } catch (err) {
      const msg = err?.response?.data?.strMessage || err?.response?.data?.message || err.message || "Unexpected error";

      // Credential not found → show credential popup
      if (msg?.toLowerCase().includes("nic credential not found") || msg?.toLowerCase().includes("credential not found")) {
        setShowCredPopup(true);
        return;
      }

      // Duplicate EWB (Error 604) — try DB first, then show popup
      if (
        msg === "DUPLICATE_EWB_NOT_IN_DB" ||
        msg?.includes("604") ||
        msg?.toLowerCase().includes("duplicate") ||
        msg?.toLowerCase().includes("already generated") ||
        msg?.toLowerCase().includes("same document number")
      ) {
        showToast("EWB already generated. Checking database...", "info");
        try {
          await Load_EWayBill(iScrId, _HT.SelectedVouchId);
          setTimeout(() => { setShowDuplicateModal(true); }, 800);
        } catch {
          setShowDuplicateModal(true);
        }
        return;
      }

      showToast(msg, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ──────────────────────────────────────────────────────────────
  //  USE EXISTING EWB (from Duplicate modal)
  // ──────────────────────────────────────────────────────────────
  const Handle_UseExistingEWB = (ewbData) => {
    setEwbResp(ewbData);
    setShowDuplicateModal(false);
    showToast(`EWB ${ewbData.ewbNo} loaded — you can now Print or Cancel.`, "success");
  };

  // ──────────────────────────────────────────────────────────────
  //  SAVE CREDENTIAL
  // ──────────────────────────────────────────────────────────────
  const Save_Credential = async () => {
    if (!nicCred.ApiUserName.trim() || !nicCred.ApiPassword.trim()) {
      showToast("Please enter both Username and Password.", "error");
      return;
    }
    try {
      setCredSaving(true);
      const gstin = EntJsonEwb?.[0]?.SellerDtls?.Gstin || "";
      const res = await userApp.post("GST/Save_NIC_Credential", {
        ClientId:    Number(localStorage.ClientId),
        GSTIN:       gstin,
        ApiUserName: nicCred.ApiUserName.trim(),
        ApiPassword: nicCred.ApiPassword.trim(),
      });
      if (res.data?.strStatus === "Success") {
        showToast("Credential saved successfully!", "success");
        setShowCredPopup(false);
        setNicCred({ ApiUserName: "", ApiPassword: "" });
        await Create_EWayBill();
      } else {
        showToast(res.data?.strMessage || "Failed to save credential.", "error");
      }
    } catch (err) {
      showToast(err?.response?.data?.strMessage || err.message || "Error saving credential.", "error");
    } finally {
      setCredSaving(false);
    }
  };

  // ──────────────────────────────────────────────────────────────
  //  CANCEL EWB
  // ──────────────────────────────────────────────────────────────
  const Cancel_EWayBill = async (ewbNo, reason, remarks) => {
    try {
      dispatch(setload_Screen(true));
      const payload = {
        EwbNo:         ewbNo,
        CancelRsnCode: Number(reason),
        CancelRmrk:    remarks || "Cancelled by user",
        iSalInvId:     _HT.SelectedVouchId,
        iClientId:     Number(localStorage.ClientId),
        strCompanyDB:  localStorage.db,
      };
      const res = await userApp.post("GST/Cancel_EWayBill", payload);
      if (res.data.strStatus === "Success") {
        setShowCancelModal(false);
        showToast("E-Way Bill cancelled successfully.", "success");
        await Load_EWayBill(iScrId, _HT.SelectedVouchId);
      } else {
        const msg = res.data.strMessage || "Cancel failed.";
        if (msg.includes("312") || msg.toLowerCase().includes("24 hour") || msg.toLowerCase().includes("cannot cancel") || msg.toLowerCase().includes("time limit")) {
          showToast("Cannot cancel — EWB can only be cancelled within 24 hours of generation.", "error", 7000);
        } else {
          showToast(msg, "error");
        }
      }
    } catch (err) {
      showToast(err.message || "Unexpected error", "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ──────────────────────────────────────────────────────────────
  //  UPDATE VEHICLE NO
  // ──────────────────────────────────────────────────────────────
const Update_VehicleNo = async (form) => {
  try {
    dispatch(setload_Screen(true));

    let transDocDate = "";
    if (form.TransDocDate && form.TransDocDate.trim().length === 10) {
      const raw = form.TransDocDate.trim();
      try {
        if (raw[4] === "-") {
          // "yyyy-MM-dd" → "dd/MM/yyyy"
          const [y, m, d] = raw.split("-");
          const dt = new Date(`${y}-${m}-${d}`);
          const today = new Date(); today.setHours(0, 0, 0, 0);
          if (!isNaN(dt) && dt <= today)
            transDocDate = `${d}/${m}/${y}`;
        } else if (raw[2] === "/") {
          // Already "dd/MM/yyyy" — validate not future
          const [d, m, y] = raw.split("/");
          const dt = new Date(`${y}-${m}-${d}`);
          const today = new Date(); today.setHours(0, 0, 0, 0);
          if (!isNaN(dt) && dt <= today)
            transDocDate = raw;
        }
      } catch { transDocDate = ""; }
    }

    const payload = {
      VouchId:           _HT.SelectedVouchId,
      EwbNo:             ewbResp.ewbNo,
      VehicleNo:         form.VehicleNo.trim().toUpperCase(),
      FromPlace:         form.FromPlace.trim(),
      FromState:         Number(form.FromState),
      RemainingDistance: form.RemainingDistance ? Number(form.RemainingDistance) : 0,
      TransDocNo:        form.TransDocNo?.trim() || "",
      TransDocDate:      transDocDate,
      TransMode:         form.TransMode   || "1",
      VehicleType:       form.VehicleType || "R",
      ReasonCode:        Number(form.ReasonCode) || 1,
      Remarks:           form.Remarks?.trim() || "",
      iClientId:         Number(localStorage.ClientId),
      strCompanyDB:      localStorage.db,
    };

    const res = await userApp.post("GST/Update_VehicleNo", payload);
    if (res.data.strStatus === "Success") {
      setShowVehicleModal(false);

      setEwbResp(prev => ({
        ...prev,
        vehicleNo:         form.VehicleNo.trim().toUpperCase(),
        transMode:         form.TransMode   || "1",
        vehicleType:       form.VehicleType || "R",
        transDocNo:        form.TransDocNo?.trim() || "",
        transDocDate:      transDocDate,
        remainingDistance: Number(form.RemainingDistance) > 0 ? Number(form.RemainingDistance) : prev?.remainingDistance || null,
      }));

      showToast("Vehicle number updated successfully.", "success");
      await Load_EWayBill(iScrId, _HT.SelectedVouchId);
    } else {
      showToast(res.data.strMessage || "Update failed.", "error");
    }
  } catch (err) {
    showToast(err?.response?.data?.strMessage || err.message || "Unexpected error", "error");
  } finally {
    dispatch(setload_Screen(false));
  }
};

  // ──────────────────────────────────────────────────────────────
  //  EXTEND EWB VALIDITY
  // ──────────────────────────────────────────────────────────────
const Extend_EWayBill = async (form) => {
  try {
    dispatch(setload_Screen(true));

    //  TransDocDate: "yyyy-MM-dd" → "dd/MM/yyyy"
    //  Empty or future date → "" (backend-ல null ஆகும்)
    let transDocDate = "";
    if (form.TransDocDate && form.TransDocDate.trim().length === 10) {
      const [y, m, d] = form.TransDocDate.split("-");
      if (y && m && d) {
        const entered = new Date(`${y}-${m}-${d}`);
        const today   = new Date(); today.setHours(0, 0, 0, 0);
       
        if (entered <= today) transDocDate = `${d}/${m}/${y}`;
      }
    }

    const payload = {
      EwbNo:             ewbResp.ewbNo,
      VehicleNo:         form.VehicleNo.trim().toUpperCase(),
      FromPlace:         form.FromPlace.trim(),
      FromState:         Number(form.FromState),
      FromPincode:       Number(form.FromPincode),
      RemainingDistance: Number(form.RemainingDistance) || 1, 
      TransDocNo:        form.TransDocNo?.trim() || "",
      TransDocDate:      transDocDate,
      TransMode:         form.TransMode  || "1",
      VehicleType:       form.VehicleType || "R",
      Consignment:       form.Consignment || "M",
      ExtnRsnCode:       Number(form.ExtnRsnCode) || 1,
      ExtnRemarks:       form.ExtnRemarks?.trim() || "Validity extended",
      iClientId:         Number(localStorage.ClientId),
      strCompanyDB:      localStorage.db,
    };

    console.log("[EXTEND] Payload:", JSON.stringify(payload, null, 2));

    const res = await userApp.post("GST/Extend_EWayBill", payload);

    if (res.data.strStatus === "Success") {
      setShowExtendModal(false);
      showToast("E-Way Bill validity extended successfully! ✅", "success");
      await Load_EWayBill(iScrId, _HT.SelectedVouchId);

    } else {
      const msg = res.data.strMessage || "";

      if (msg.includes("702")) {
        let nicDist = null;
        try {
          const jsonStart = msg.indexOf("{");
          if (jsonStart !== -1) {
            const parsed = JSON.parse(msg.substring(jsonStart));
            nicDist = parsed?.distance || null;
          }
        } catch { /* ignore parse error */ }

        showToast(
          nicDist
            ? `Distance too high — NIC maximum allowed is ${nicDist} km. Please enter ${nicDist} or less.`
            : "Remaining distance exceeds NIC limit. Please reduce and try again.",
          "warning",
          7000
        );
      } else if (msg.includes("382") || msg.toLowerCase().includes("8 hour") || msg.toLowerCase().includes("extend") && msg.toLowerCase().includes("validity")) {
        showToast(
          "Cannot extend now — only allowed within 8 hours before or after EWB expiry. Please try again closer to the expiry time.",
          "warning",
          8000
        );
      } else {
        showToast(msg || "Extend failed. Please try again.", "error");
      }
    }

  } catch (err) {
    showToast(
      err?.response?.data?.strMessage || err.message || "Unexpected error",
      "error"
    );
  } finally {
    dispatch(setload_Screen(false));
  }
};

  // ──────────────────────────────────────────────────────────────
  //  PRINT EWB
  // ──────────────────────────────────────────────────────────────
// ──────────────────────────────────────────────────────────────
//  PRINT EWB — GST Portal Format (Normal + EInvoice combined)
// ──────────────────────────────────────────────────────────────
const Print_EWayBill = async (ewbNo) => {
  try {
    dispatch(setload_Screen(true));
    const ewb     = EntJsonEwb?.[0] || {};
    const seller  = ewb.SellerDtls  || {};
    const buyer   = ewb.BuyerDtls   || {};
    const ewbDtls = ewb.EwbDtls     || {};
    const doc     = ewb.DocDtls     || {};
    const val     = ewb.ValDtls     || {};
    const items   = ewb.itemList    || [];

      // IRN details — from ewbResp state (loaded via DB JOIN with EInvoice table)
      const irn   = ewbResp?.irn   || null;
      const ackNo = ewbResp?.ackNo || null;
      const ackDt = ewbResp?.ackDt || null;

    openPrintWindow({
      ewbNo:        ewbResp?.ewbNo        || ewbNo,
      ewbDt:        ewbResp?.ewbDt        || "",
      ewbValidTill: ewbResp?.ewbValidTill || "",
      status:       ewbResp?.status       || "ACT",
      // Part A
      fromGstin:    seller.Gstin   || "",
      fromName:     seller.LglNm   || seller.TrdNm || "",
      fromAddr:     [seller.Addr1, seller.Addr2].filter(Boolean).join(", "),
      fromPlace:    seller.Loc     || "",
      fromState:    seller.Stcd    || "",
      fromPin:      seller.Pin     || "",
      toGstin:      buyer.Gstin    || "",
      toName:       buyer.LglNm    || buyer.TrdNm || "",
      toAddr:       [buyer.Addr1, buyer.Addr2].filter(Boolean).join(", "),
      toPlace:      buyer.Loc      || "",
      toState:      buyer.Stcd     || "",
      toPin:        buyer.Pin      || "",
      docNo:        doc.No         || "",
      docDate:      doc.Dt         || "",
      docType:      doc.Typ        || "INV",
      supplyType:   ewbDtls.SupplyType || "Outward - Supply",
      transType:    "Regular",
      valueOfGoods: val.TotInvVal || val.AssVal || 0,
      totInvVal:    val.TotInvVal  || 0,
      hsnCode:      items[0]?.HsnCd || "",
  // Part B
vehicleNo:    ewbResp?.vehicleNo    || ewbDtls.VehNo       || "",
transMode:    (() => {
  const m = ewbResp?.transMode || ewbDtls.TransMode || "1";
  return m==="1" ? "Road" : m==="2" ? "Rail" : m==="3" ? "Air" : m==="4" ? "Ship" : "Road";
})(),
transporter:  ewbDtls.TransId       || ewbDtls.TransName   || "",
transDocNo:   ewbResp?.transDocNo   || ewbDtls.TransDocNo  || "",
transDocDate: ewbResp?.transDocDate || ewbDtls.TransDocDate || "",
distance: Number(ewbResp?.distance) > 0 
  ? Number(ewbResp.distance) 
  : (Number(ewbDtls.Distance) > 0 
    ? Number(ewbDtls.Distance) 
    : Number(EntJsonEwb?.[0]?.EwbDtls?.Distance) || 0),
      // IRN (only for EInvoice EWB)
      irn:          irn    || "",
      ackNo:        ackNo  || "",
      ackDt:        ackDt  || "",
      // Items
      items,
    });
  } catch (err) {
    showToast(err.message || "Print failed", "error");
  } finally {
    dispatch(setload_Screen(false));
  }
};


  const UNIT_CODE_MAP = {
    "BAGS": "BAG", "BALE": "BAL", "BUNDLES": "BDL", "BOX": "BOX",
    "BOTTLES": "BTL", "CANS": "CAN", "CARTONS": "CTN", "DOZENS": "DOZ",
    "DOZEN": "DOZ", "DRUMS": "DRM", "GRAMS": "GMS", "GRAM": "GMS",
    "KG": "KGS", "KGS": "KGS", "LTR": "LTR", "LITRE": "LTR",
    "LITRES": "LTR", "METER": "MTR", "MTR": "MTR", "NUMBERS": "NOS",
    "NUMBER": "NOS", "NOS": "NOS", "PACKS": "PAC", "PACK": "PAC",
    "PAIRS": "PRS", "PAIR": "PRS", "ROLLS": "ROL", "ROLL": "ROL",
    "SETS": "SET", "SET": "SET", "SQUARE FEET": "SQF",
    "SQUARE METERS": "SQM", "TABLETS": "TBS", "TONNES": "TON",
    "TONNE": "TON", "UNITS": "UNT", "UNIT": "UNT", "YARDS": "YDS",
    "YARD": "YDS", "OTHERS": "OTH", "OTHER": "OTH", "PCS": "NOS",
    "PIECES": "NOS", "PIECE": "NOS",
  };

  // ──────────────────────────────────────────────────────────────
  //  BUILD CLEAN E-WAY BILL JSON — strips empty "" optional fields,
  //  same rule as E-Invoice. (Renamed from buildCleanEInvoiceJSON;
  //  also fixes a bug where it read "inv.ItemList" but the real EWB
  //  object stores items under lowercase "itemList".)
  // ──────────────────────────────────────────────────────────────
  const buildCleanEwbJSON = (rawInv) => {
    const inv = JSON.parse(JSON.stringify(rawInv));

    const stripEmptyKeys = (obj) => {
      if (!obj || typeof obj !== "object") return;
      Object.keys(obj).forEach((k) => { if (k.trim() === "") delete obj[k]; });
    };
    ["TranDtls","DocDtls","SellerDtls","BuyerDtls","DispDtls","ShipDtls","ValDtls","EwbDtls"]
      .forEach((sec) => stripEmptyKeys(inv[sec]));

    ["SellerDtls", "BuyerDtls", "DispDtls", "ShipDtls"].forEach((sec) => {
      if (inv[sec]) {
        if (inv[sec].Pin !== undefined) inv[sec].Pin = Number(inv[sec].Pin);
        if (inv[sec].Stcd !== undefined) inv[sec].Stcd = String(inv[sec].Stcd);
      }
    });
    if (inv.BuyerDtls?.Pos !== undefined) inv.BuyerDtls.Pos = String(inv.BuyerDtls.Pos);

    if (inv.TranDtls && (!inv.TranDtls.EcmGstin || inv.TranDtls.EcmGstin.length !== 15)) {
      delete inv.TranDtls.EcmGstin;
    }

    const emailRx = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    const cleanParty = (party) => {
      if (!party) return;
      const em = party.Em || "";
      if (!em || em.length < 6 || em.length > 100 || !emailRx.test(em)) delete party.Em;
      if (!party.Ph || String(party.Ph).trim() === "") delete party.Ph;
    };
    cleanParty(inv.SellerDtls);
    cleanParty(inv.BuyerDtls);

    const sellerStcd = String(inv.SellerDtls?.Stcd || "");
    const buyerStcd  = String(inv.BuyerDtls?.Stcd  || "");
    const isInterState = sellerStcd && buyerStcd && sellerStcd !== buyerStcd;

    // ✅ FIX — real EWB data stores items under "itemList" (lowercase),
    // not "ItemList". The old code silently did nothing here.
    if (Array.isArray(inv.itemList)) {
      inv.itemList = inv.itemList.map((item) => {
        const it = { ...item };
        const unit = String(it.Unit || "").trim().toUpperCase();
        it.Unit = UNIT_CODE_MAP[unit] || (unit.length === 3 ? unit : "OTH");

        delete it.igstAmt;
        delete it.cgstAmt;
        delete it.sgstAmt;

        if (isInterState) {
          it.IgstAmt = Number(it.IgstAmt || 0);
          delete it.CgstAmt;
          delete it.SgstAmt;
        } else {
          it.CgstAmt = Number(it.CgstAmt || 0);
          it.SgstAmt = Number(it.SgstAmt || 0);
          delete it.IgstAmt;
        }
        return it;
      });
    }

    if (inv.DocDtls?.Dt?.includes("-")) {
      const [y, m, d] = inv.DocDtls.Dt.split("-");
      inv.DocDtls.Dt = `${d}/${m}/${y}`;
    }

    // ── Remove empty "" optional fields — same rule as E-Invoice ──
    const stripEmptyOptionalStrings = (obj, keys) => {
      if (!obj) return;
      keys.forEach((k) => {
        if (obj[k] !== undefined && String(obj[k]).trim() === "") delete obj[k];
      });
    };
    stripEmptyOptionalStrings(inv.SellerDtls, ["Addr2", "TrdNm"]);
    stripEmptyOptionalStrings(inv.BuyerDtls, ["Addr2", "TrdNm"]);
    stripEmptyOptionalStrings(inv.DispDtls, ["Addr2", "TrdNm"]);
    stripEmptyOptionalStrings(inv.ShipDtls, ["Addr2", "TrdNm"]);
    stripEmptyOptionalStrings(inv.EwbDtls, ["TransId", "TransName", "TransDocNo", "TransDocDate", "VehType"]);

    // ── FINAL SAFETY NET ─────────────────────────────────────────
    // The list above only covers fields we thought of (this is exactly
    // how "ShipDtls.TrdNm" slipped through earlier). To guarantee NO
    // empty "" string ever reaches the NIC portal — no matter which
    // field, no matter how deeply nested (SellerDtls, BuyerDtls,
    // DispDtls, ShipDtls, EwbDtls, or any future field added later) —
    // this does one final recursive sweep and deletes every key whose
    // value is an empty/whitespace-only string. Numbers, 0, false,
    // and real text are never touched.
    const stripEmptyStringsDeep = (node) => {
      if (!node || typeof node !== "object") return;
      Object.keys(node).forEach((k) => {
        const v = node[k];
        if (typeof v === "string" && v.trim() === "") {
          delete node[k];
        } else if (v && typeof v === "object") {
          stripEmptyStringsDeep(v);
        }
      });
    };
    stripEmptyStringsDeep(inv);

    if (inv.ShipDtls && Object.keys(inv.ShipDtls).length <= 2) {
      delete inv.ShipDtls;
    }

    return inv;
  };
// ──────────────────────────────────────────────────────────────
//  OPEN PRINT WINDOW — GST Portal Exact Format
// ──────────────────────────────────────────────────────────────
const openPrintWindow = (d) => {
  const isEInvoice  = !!d.irn;
  const isCancelled = d.status === "CNL";

  const fmtEwbNo = (n) => {
    const s = String(n).replace(/\s/g, "");
    return s.length === 12
      ? `${s.slice(0,4)} ${s.slice(4,8)} ${s.slice(8)}`
      : s;
  };

  const hsnList = [...new Set((d.items || [])
    .map(it => String(it.HsnCd || it.hsnCode || ""))
    .filter(Boolean))].join(", ");

  const rawEwbNo = String(d.ewbNo).replace(/\s/g, "");

  // QR content — same as GST portal (EWB No used as QR data)
  const qrContent = rawEwbNo;

  const vehicleRow = `
    <tr>
      <td>${d.transMode || "Road"}</td>
      <td>${d.vehicleNo || "—"}${d.transDocNo ? " / " + d.transDocNo : ""}${d.transDocDate ? " & " + d.transDocDate : ""}</td>
      <td>${d.fromPlace || "—"}</td>
      <td>${d.ewbDt ? formatEWBDate(d.ewbDt) : "—"}</td>
      <td>${d.fromGstin || "—"}</td>
      <td>-</td>
      <td>-</td>
      <td>1</td>
    </tr>`;

  const html = `<!DOCTYPE html>
<html>
<head>
  <title>e-Way Bill — ${fmtEwbNo(d.ewbNo)}</title>

  <!-- QR Code library -->
  <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
  <!-- Barcode library -->
  <script src="https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js"><\/script>

  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, sans-serif; font-size: 12px; color: #000; background: #fff; padding: 20px; }
    .page-border { border: 2px solid #000; padding: 14px; max-width: 780px; margin: 0 auto; }
    h1.title { text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 10px; }
    .qr-bar { display: flex; justify-content: center; margin-bottom: 10px; }
    #qrcode canvas, #qrcode img { display: block; }
    table.info { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
    table.info td { border: 1px solid #aaa; padding: 4px 8px; vertical-align: top; }
    table.info td.label { font-weight: bold; width: 38%; background: #f5f5f5; }
    .section-title { font-weight: bold; font-size: 13px; background: #e8e8e8;
                     padding: 4px 8px; border: 1px solid #aaa; border-bottom: none; margin-top: 10px; }
    table.part { width: 100%; border-collapse: collapse; }
    table.part th { border: 1px solid #aaa; padding: 5px 6px; background: #f0f0f0; font-size: 11px; text-align: left; }
    table.part td { border: 1px solid #aaa; padding: 4px 6px; font-size: 11px; }
    .irn-box { border: 1px solid #aaa; padding: 6px 10px; margin-bottom: 8px; background: #fafafa; }
    .irn-box .irn-label { font-weight: bold; font-size: 11px; margin-bottom: 4px; }
    .irn-val { font-family: monospace; font-size: 11px; word-break: break-all; }
    .barcode-area { text-align: center; margin-top: 14px; padding-top: 10px; border-top: 1px solid #ccc; }
    .barcode-num  { font-size: 11px; margin-top: 4px; color: #333; letter-spacing: 2px; }
    .note { font-size: 10px; color: #555; margin-top: 8px; font-style: italic; }
    .print-btn { display: block; margin: 16px auto 0; padding: 9px 32px; background: #1a5276;
                 color: #fff; border: none; border-radius: 5px; cursor: pointer; font-size: 13px; font-weight: 600; }
    @media print { .print-btn { display: none; } body { padding: 0; } }
  </style>
</head>
<body>
<div class="page-border">

  <h1 class="title">e-Way Bill</h1>

  <!-- QR Code -->
  <div class="qr-bar">
    <div id="qrcode"></div>
  </div>

  <!-- Top Info -->
  <table class="info">
    <tr><td class="label">E-Way Bill No:</td>   <td><strong>${fmtEwbNo(d.ewbNo)}</strong></td></tr>
    <tr><td class="label">E-Way Bill Date:</td>  <td>${formatEWBDate(d.ewbDt) || "—"}</td></tr>
    <tr><td class="label">Generated By:</td>     <td>${d.fromGstin} - ${d.fromName}</td></tr>
    <tr><td class="label">Valid From:</td>        <td>${formatEWBDate(d.ewbDt) || "—"} [${Math.round(Number(d.distance) || 0)}Kms]</td></tr>
    <tr><td class="label">Valid Until:</td>       <td><strong>${formatEWBDate(d.ewbValidTill) || "—"}</strong>
      ${isCancelled ? '<span style="color:red;font-weight:bold;"> (CANCELLED)</span>' : ""}
    </td></tr>
    <tr><td class="label">Portal:</td>            <td>1</td></tr>
  </table>

  ${isEInvoice ? `
  <div class="irn-box">
    <div class="irn-label">IRN Details</div>
    <table class="info" style="margin:0">
      <tr><td class="label">IRN:</td>      <td class="irn-val">${d.irn}</td></tr>
      <tr><td class="label">Ack No:</td>   <td>${d.ackNo  || "—"}</td></tr>
      <tr><td class="label">Ack Date:</td> <td>${formatEWBDate(d.ackDt) || "—"}</td></tr>
    </table>
  </div>` : ""}

  <!-- Part A -->
  <div class="section-title">Part - A</div>
  <table class="info">
    <tr><td class="label">GSTIN of Supplier:</td>      <td>${d.fromGstin}<br/><strong>${d.fromName}</strong></td></tr>
    <tr><td class="label">Place of Dispatch:</td>       <td>${d.fromPlace}${d.fromState ? ", " + d.fromState : ""}${d.fromPin ? " " + d.fromPin : ""}</td></tr>
    <tr><td class="label">GSTIN of Recipient:</td>      <td>${d.toGstin}<br/><strong>${d.toName}</strong></td></tr>
    <tr><td class="label">Place of Delivery:</td>       <td>${d.toPlace}${d.toState ? ", " + d.toState : ""}${d.toPin ? " " + d.toPin : ""}</td></tr>
    <tr><td class="label">Document No.</td>             <td>${d.docNo   || "—"}</td></tr>
    <tr><td class="label">Document Date</td>            <td>${formatEWBDate(d.docDate) || "—"}</td></tr>
    <tr><td class="label">Transaction Type:</td>        <td>${d.transType || "Regular"}</td></tr>
    <tr><td class="label">Value of Goods</td>           <td>${Number(d.valueOfGoods || 0).toLocaleString("en-IN")}</td></tr>
    <tr><td class="label">HSN Code</td>                 <td>${hsnList || "—"}</td></tr>
    <tr><td class="label">Reason for Transportation</td><td>${d.supplyType || "Outward - Supply"}</td></tr>
    <tr><td class="label">Transporter</td>              <td>${d.transporter || "—"}</td></tr>
  </table>

  <!-- Part B -->
  <div class="section-title">Part - B</div>
  <table class="part">
    <thead>
      <tr>
        <th>Mode</th>
        <th>Vehicle / Trans Doc No &amp; Dt.</th>
        <th>From</th>
        <th>Entered Date</th>
        <th>Entered By</th>
        <th>CEWB No. (If any)</th>
        <th>Multi Veh.Info (If any)</th>
        <th>Portal</th>
      </tr>
    </thead>
    <tbody>${vehicleRow}</tbody>
  </table>

  <!-- Barcode -->
  <div class="barcode-area">
    <svg id="ewb-barcode"></svg>
    <div class="barcode-num">${rawEwbNo}</div>
  </div>

  <p class="note">Note*: If any discrepancy in information please try after sometimes.</p>
</div>

<button class="print-btn" onclick="window.print()">🖨️ Print</button>

<script>
  // Wait for libraries to load, then render
  window.onload = function() {
    // ── QR Code ──
    try {
      new QRCode(document.getElementById("qrcode"), {
        text:          "${qrContent}",
        width:         90,
        height:        90,
        correctLevel:  QRCode.CorrectLevel.M
      });
    } catch(e) { console.error("QR failed", e); }

    // ── Barcode ──
    try {
      JsBarcode("#ewb-barcode", "${rawEwbNo}", {
        format:      "CODE128",
        width:       2,
        height:      55,
        displayValue: false,
        margin:      4
      });
    } catch(e) { console.error("Barcode failed", e); }

    // ── Auto print after render ──
    setTimeout(() => window.print(), 900);
  };
</script>
</body>
</html>`;

  const pw = window.open("", "_blank", "width=820,height=750");
  if (pw) { pw.document.write(html); pw.document.close(); }
  else showToast("Popup blocked! Please allow popups for this site.", "error");
};

  // ──────────────────────────────────────────────────────────────
  //  CLEAR / REFRESH
  // ──────────────────────────────────────────────────────────────
  const Clear_EWayBill = () => Load_EWayBill(_Common.iScrId, _HT.SelectedVouchId);

  // ──────────────────────────────────────────────────────────────
  //  SETTINGS
  // ──────────────────────────────────────────────────────────────
  const Area_Onchange = async (AreaId) => {
    try {
      setiAreaId(AreaId);
      dispatch(setload_Screen(true));
      await userApp.get(`GST/Area_Onchange/${Number(AreaId)}/${Number(iScrId)}/${localStorage.db}`).then((Res) => {
        if (Res.data.strStatus === "Success") setarrEntCol(Res.data.EntCol);
        else showToast(Res.data.strMessage, "info");
      });
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  const View_GSTColumns = (col) => {
    setstrColName(col.strGstcolName);
    setstrAliasName(col.strAliasName);
    setstrDatatype(col.strdatatype);
    setstrTransName(col.strConditionCol);
    setstrdefaultval(col.strdefaultvalue);
    setstrval(col.strValue);
    setiAreaId(col.iAreaId);
    setiColId(col.iGstcolId);
    setisShow(col.iShwinScr === 1);
  };

  const Clear_Colums = () => {
    setstrColName(""); setstrAliasName(""); setstrDatatype("string");
    setstrTransName(""); setstrdefaultval(""); setstrval("");
    setiAreaId(0); setiColId(0); setisShow(true);
  };

  const Updat_GSTColumn = async () => {
    try {
      const InsUpdCol = {
        strCompanyDB: localStorage.db,
        EntArea: [],
        EntCol: [{
          iGstcolId:       iColId,
          strGstcolName:   strColName,
          strAliasName:    strAliasName,
          strdatatype:     strDatatype,
          strConditionCol: strTransName,
          strdefaultvalue: strdefaultval,
          strValue:        strval,
          iShwinScr:       isShow ? 1 : 0,
          iAreaId:         iAreaId,
          iScrId:          iScrId,
        }],
      };
      dispatch(setload_Screen(true));
      await userApp.post("GST/InsUpd_GSTColumns", InsUpdCol).then((Res) => {
        if (Res.data.strStatus === "Success") { Area_Onchange(iAreaId); Clear_Colums(); }
        else showToast(Res.data.strMessage, "error");
      });
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ──────────────────────────────────────────────────────────────
  //  DROPDOWN HELPERS
  // ──────────────────────────────────────────────────────────────
  const Option_list    = (col, EntDT) => { switch (col) { case "vehicleType": return VEHICLE_TYPES.map((v) => ({ val: v.val, Name: v.label })); case "transMode": return TRANS_MODES.map((v) => ({ val: v.val, Name: v.label })); default: return EntDT; } };
  const Option_Value   = (Val, col)   => { switch (col) { case "vehicleType": case "transMode": return Val.val; default: return Val; } };
  const Option_display = (Val, col)   => { switch (col) { case "vehicleType": case "transMode": return Val.Name; default: return Val; } };
  const display_Value  = (Val, col)   => { switch (col) { case "vehicleType": return VEHICLE_TYPES.find((v) => v.val === Val)?.label || Val; case "transMode": return TRANS_MODES.find((v) => v.val === Val)?.label || Val; default: return Val; } };
  const Hide_Option    = (val, element) => setarrEntCol((cols) => cols.map((col) => col.iGstcolId === element.iGstcolId ? { ...col, isShowOption: val } : col));

  // ──────────────────────────────────────────────────────────────
  //  CREATE HTML ELEMENT
  // ──────────────────────────────────────────────────────────────
  const CreateHTMLElemet = (element, area, Index) => {
    if (element.iAreaId === area.iAreaId && area.iAreaId !== 9) {
      const json = EntJsonEwb[0];
      const val  = json ? (json[area.strAreaCol]?.[element.strGstcolName] ?? "") : "";
      switch (element.strdatatype) {
        case "string":
          return (<div className="col-sm-6 col-md-3" key={Index}><label>{element.strAliasName}</label><input type="text" className="form-control" value={val} onChange={(e) => Input_Onchange(e.target.value, element, area)} /></div>);
        case "cmb":
          return (
            <div className="col-sm-6 col-md-3" key={Index}>
              <label>{element.strAliasName}</label>
              <div className="custom-select" onMouseLeave={() => Hide_Option(false, element)}>
                <input type="text" className="form-control" disabled={false} placeholder="Select Value" value={display_Value(val, element.strGstcolName)} onClick={() => Hide_Option(true, element)} readOnly />
                <i className="fa-solid fa-caret-down"></i>
                {element.isShowOption && (
                  <div className="custom-option">
                    <div className="option-list">
                      {Option_list(element.strGstcolName, element.arrOption).map((item, idx) => (
                        <button key={idx} tabIndex={idx}
                          onClick={() => { Input_Onchange(Option_Value(item, element.strGstcolName), element, area); Hide_Option(false, element); }}
                          onKeyDown={(e) => {
                            const len = element.arrOption.length - 1;
                            if (e.key === "ArrowDown") $(`.option-list [tabindex=${idx === len ? 0 : idx + 1}]`).focus();
                            if (e.key === "ArrowUp")   $(`.option-list [tabindex=${idx === 0 ? len : idx - 1}]`).focus();
                            if (e.key === "Enter")     { Input_Onchange(Option_Value(item, element.strGstcolName), element, area); Hide_Option(false, element); }
                          }}
                        >{Option_display(item, element.strGstcolName)}</button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        case "decimal":
          return (<div className="col-sm-6 col-md-3" key={Index}><label>{element.strAliasName}</label><input type="number" className="form-control" value={val} onChange={(e) => Input_Onchange(e.target.value, element, area)} /></div>);
        case "date":
          return (<div className="col-sm-6 col-md-3" key={Index}><label>{element.strAliasName}</label><input type="date" className="form-control" value={val} onChange={(e) => Input_Onchange(e.target.value, element, area)} /></div>);
        default: break;
      }
    }
  };

  // ──────────────────────────────────────────────────────────────
  //  TABLE COLUMNS
  // ──────────────────────────────────────────────────────────────
  const ItemColumn = [
    { Header: "Product Name",  accessor: "PrdDesc",    minWidth: 200 },
    { Header: "HSN Code",      accessor: "HsnCd",      minWidth: 100 },
    { Header: "Qty",           accessor: "Qty",         style: { justifyContent: "right" }, minWidth: 80 },
    { Header: "Unit",          accessor: "Unit",        style: { justifyContent: "center" }, minWidth: 80 },
    { Header: "Rate",          accessor: "UnitPrice",   style: { justifyContent: "right" }, minWidth: 100 },
    { Header: "Taxable Amt",   accessor: "AssAmt",      style: { justifyContent: "right" }, minWidth: 120 },
    { Header: "SGST",          accessor: "SgstAmt",     style: { justifyContent: "right" }, minWidth: 80 },
    { Header: "CGST",          accessor: "CgstAmt",     style: { justifyContent: "right" }, minWidth: 80 },
    { Header: "IGST",          accessor: "IgstAmt",     style: { justifyContent: "right" }, minWidth: 80 },
    { Header: "CESS",          accessor: "CesAmt",      style: { justifyContent: "right" }, minWidth: 80 },
    { Header: "Total Amt",     accessor: "TotItemVal",  style: { justifyContent: "right" }, minWidth: 120 },
  ];

  const GstColumn = [
    { Header: "GST Column",    accessor: "strGstcolName" },
    { Header: "Alias Name",    accessor: "strAliasName",    minWidth: 200 },
    { Header: "Data Type",     accessor: "strdatatype",     minWidth: 100 },
    { Header: "Trans Name",    accessor: "strConditionCol", minWidth: 100 },
    { Header: "Default Value", accessor: "strdefaultvalue", minWidth: 200 },
    { Header: "Value",         accessor: "strValue",        minWidth: 100, style: { justifyContent: "center" } },
    {
      Header: "Show",
      accessor: "iShwinScr",
      minWidth: 70,
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => <input type="checkbox" className="form-check" checked={rowinfo.iShwinScr} readOnly />,
    },
  ];

  // ══════════════════════════════════════════════════════════════
  //  RENDER
  // ══════════════════════════════════════════════════════════════
  return (
    <>
      <Toast toasts={toasts} onDismiss={dismissToast} />

      {/* ── Credential Modal ── */}
      {showCredPopup && (
        <CredentialModal
          cred={nicCred}
          onChange={setNicCred}
          onSave={Save_Credential}
          onClose={() => { setShowCredPopup(false); setNicCred({ ApiUserName: "", ApiPassword: "" }); }}
          saving={credSaving}
        />
      )}

      {/* ── Validation Modal (exact EInvoice flow) ── */}
      {showValidModal && (
        <ValidationModal
          errors={validErrors}
          warnings={validWarnings}
          ewb={EntJsonEwb?.[0]}
          onProceed={() => {
            setShowValidModal(false);
            Create_EWayBill();
          }}
          onClose={() => setShowValidModal(false)}
        />
      )}

      {/* ── Duplicate EWB Modal (Error 604) ── */}
      {showDuplicateModal && (
        <DuplicateEWBModal
          onUseExisting={Handle_UseExistingEWB}
          onClose={() => setShowDuplicateModal(false)}
        />
      )}

      {/* ── Cancel Modal ── */}
      {showCancelModal && (
        <CancelEWBModal
          ewbNo={ewbResp?.ewbNo}
          onConfirm={(reason, remarks) => Cancel_EWayBill(ewbResp?.ewbNo, reason, remarks)}
          onClose={() => setShowCancelModal(false)}
          onAlert={showToast}
        />
      )}

      {/* ── Update Vehicle Modal ── */}
      {showVehicleModal && (
        <UpdateVehicleModal
          ewbNo={ewbResp?.ewbNo}
          onConfirm={Update_VehicleNo}
          onClose={() => setShowVehicleModal(false)}
          onAlert={AlertMessage}
        />
      )}

      {/* ── Extend Validity Modal ── */}
      {showExtendModal && (
<ExtendModal
  ewbNo={ewbResp?.ewbNo}
  onConfirm={Extend_EWayBill}
  onClose={() => setShowExtendModal(false)}
  onAlert={showToast}
/>
      )}

      <div className="popup-container">
        <div className="popup-content">

          {/* ── Header ── */}
          <div className="popup-header">
            <h5>E-Way Bill</h5>
            <div className="icon-popup-btn-grp">
              {!isSetting && (
                <span className="icon-btn" onClick={() => { setisSetting(true); Area_Onchange(1); }} title="Settings">
                  <i className="fa-solid fa-gear"></i>
                </span>
              )}
              <span className="icon-btn" onClick={() => dispatch(ShowHide_Popup("IsEWayBill"))}>
                <i className="fa-regular fa-rectangle-xmark"></i>
              </span>
            </div>
          </div>

          {/* ── Body ── */}
          <div className="popup-body">

            {/* Form View */}
            {!isSetting && (
              <div className="row">
                {arrEntArea.map((area, Index) => (
                  <div className="row" key={Index}>
                    <h6 className="gstcol-h">{area.strAliasName}</h6>
                    {arrEntCol.map((col, idx) => CreateHTMLElemet(col, area, idx))}
                  </div>
                ))}

                {/* Item Table */}
                <div className="TransactionTable">
                  <ReactTable
                    sortable={true}
                    data={ListEntItem}
                    columns={ItemColumn}
                    minRows={5}
                    defaultPageSize={500}
                    showPaginationBottom={false}
                  />
                </div>
              </div>
            )}

            {/* Settings View */}
            {isSetting && (
              <div className="row p-2">
                <div className="col-sm-12 col-md-3">
                  <label>GST Column Type</label>
                  <CustomizedSelectoption
                    optionparem="isoptionShow10"
                    showoption={_selecrparem.isoptionShow10}
                    placeholder="Select Column Type"
                    select_value={(val) => Area_Onchange(val)}
                    btnname="" btnshow={false} show_popup={""} valueonly={true}
                    defaultval={iAreaId} displayName="strAreaCol" disvalue="iAreaId"
                    arrydata={arrEntArea} EmptVal="Column Type"
                  />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>GST Column Name</label>
                  <input type="text" className="form-control" placeholder="GST Column" value={strColName} onChange={(e) => setstrColName(e.target.value)} spellCheck={false} autoComplete="off" />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Alias Name</label>
                  <input type="text" className="form-control" placeholder="Alias Name" value={strAliasName} onChange={(e) => setstrAliasName(e.target.value)} spellCheck={false} autoComplete="off" />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Trans Name</label>
                  <input type="text" className="form-control" placeholder="Trans Name" value={strTransName} onChange={(e) => setstrTransName(e.target.value)} spellCheck={false} autoComplete="off" />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Default Value</label>
                  <input type="text" className="form-control" placeholder="Default Value" value={strdefaultval} onChange={(e) => setstrdefaultval(e.target.value)} spellCheck={false} autoComplete="off" />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Value</label>
                  <input type="text" className="form-control" placeholder="Value" value={strval} onChange={(e) => setstrval(e.target.value)} spellCheck={false} autoComplete="off" />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Show Screen</label>
                  <input type="checkbox" className="form-check" checked={isShow} onChange={() => setisShow(!isShow)} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Data Type</label>
                  <div className="row">
                    {["string", "date", "decimal", "cmb"].map((dt) => (
                      <div className="col-sm-4 col-md-4" key={dt}>
                        <label>{dt}</label>
                        <input type="checkbox" className="form-check" checked={strDatatype === dt} onChange={() => setstrDatatype(dt)} />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-sm-12 mt-3">
                  <ReactTable
                    columns={GstColumn}
                    data={arrEntCol}
                    minRows={5}
                    row_click={() => {}}
                    row_doubleclick={(rowInfo) => View_GSTColumns(rowInfo)}
                    background={true}
                    className="full-table"
                  />
                </div>
              </div>
            )}

            {/* EWB Response Card */}
            {hasEWBNo && !isSetting && (
              <div style={{ marginTop: 18, borderRadius: 12, border: `1.5px solid ${isCancelled ? "#fecaca" : "#bbf7d0"}`, background: isCancelled ? "#fff8f8" : "#f0fdf4", padding: "16px 20px", boxShadow: "0 4px 18px rgba(0,0,0,0.06)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                  <div style={{ width: 10, height: 10, borderRadius: "50%", background: isCancelled ? "#dc2626" : "#16a34a", boxShadow: `0 0 0 3px ${isCancelled ? "#fecaca" : "#bbf7d0"}` }}></div>
                  <span style={{ fontWeight: 700, fontSize: 13, color: isCancelled ? "#dc2626" : "#15803d" }}>
                    {isCancelled ? "⛔ E-Way Bill Cancelled" : "✔ E-Way Bill Active"}
                  </span>
                </div>
                <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                  <div style={{ flex: 1, minWidth: 260 }}>
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 2 }}>E-Way Bill No</div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontFamily: "monospace", fontSize: 20, fontWeight: 800, color: "#0f172a", letterSpacing: 2 }}>{ewbResp.ewbNo}</span>
                        <CopyEWBNo ewbNo={ewbResp.ewbNo} />
                      </div>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 20px" }}>
                      <div>
                        <div style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 4 }}>Generated On</div>
                        <div style={{ fontSize: 13, color: "#0f172a", fontWeight: 600 }}>{formatEWBDate(ewbResp.ewbDt) || "—"}</div>
                      </div>
                      <div>
                        <div style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 4 }}>Valid Till</div>
                        <div style={{ fontSize: 13, color: isCancelled ? "#dc2626" : "#0f172a", fontWeight: 700 }}>{formatEWBDate(ewbResp.ewbValidTill) || "—"}</div>
                      </div>
                    </div>
                    {isCancelled && ewbResp.cancelDate && (
                      <div style={{ marginTop: 12, padding: "9px 12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, fontSize: 12 }}>
                        <span style={{ fontWeight: 700, color: "#dc2626" }}>Cancelled On: </span>
                        <span style={{ color: "#7f1d1d" }}>{formatEWBDate(ewbResp.cancelDate)}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

          </div>{/* end popup-body */}

          {/* ── Footer Buttons ── */}
          <div className="popup-footer">
            <div className="popup-btn-group">

              {!isSetting && (
                <>
                  {!hasEWBNo && (
                    <>
                      <button onClick={Handle_Generate_Click} className="btn-fabgreen">
                        <i className="fas fa-file-invoice"></i>&nbsp;Generate E-Way Bill
                      </button>
                      <button
                        onClick={() => {
                          if (!EntJsonEwb?.[0]) return;
                          const { errors } = validateEWayBill();
                          if (errors.length > 0) {
                            showToast(`Cannot download — fix ${errors.length} error(s) first: ${errors[0]}`, "error");
                            return;
                          }
                          const cleanJson = buildCleanEwbJSON(EntJsonEwb[0]);
                          const arrayWrapped = [cleanJson];
                          const blob = new Blob([JSON.stringify(arrayWrapped, null, 2)], { type: "application/json" });
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = `EWayBill_${_HT.SelectedVouchId || "payload"}.json`;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                          URL.revokeObjectURL(url);
                        }}
                        className="btn-fabgreen"
                      >
                        <i className="fas fa-download"></i>&nbsp;Download JSON
                      </button>
                      {/* <button
                        onClick={() => {
                          if (!EntJsonEwb?.[0]) return;
                          const blob = new Blob([JSON.stringify(EntJsonEwb[0], null, 2)], { type: "application/json" });
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = `EWayBill_${_HT.SelectedVouchId || "payload"}.json`;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                          URL.revokeObjectURL(url);
                        }}
                        className="btn-fabgreen"
                      >
                        <i className="fas fa-download"></i>&nbsp;Download JSON
                      </button> */}
                    </>
                  )}

                  {isActive && (
                    <>
                      <button onClick={() => Print_EWayBill(ewbResp.ewbNo)} className="btn-fabgreen">
                        <i className="fas fa-print"></i>&nbsp;Print
                      </button>
                      <button onClick={() => setShowVehicleModal(true)} className="btn-fabgreen">
                        <i className="fas fa-truck"></i>&nbsp;Update Vehicle
                      </button>
                      <button onClick={() => {
                        if (ewbResp?.ewbValidTill) {
                          // Parse "dd/MM/yyyy HH:mm:ss AM/PM" or ISO format
                          let validTillMs = null;
                          try {
                            const raw = String(ewbResp.ewbValidTill).trim();
                            // Try: "22/05/2026 11:59:00 PM" format
                            const m = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
                            if (m) {
                              let h = parseInt(m[4]);
                              const min = parseInt(m[5]);
                              const ampm = (m[6] || "").toUpperCase();
                              if (ampm === "PM" && h < 12) h += 12;
                              if (ampm === "AM" && h === 12) h = 0;
                              validTillMs = new Date(parseInt(m[3]), parseInt(m[2])-1, parseInt(m[1]), h, min).getTime();
                            } else {
                              validTillMs = new Date(raw).getTime();
                            }
                          } catch { validTillMs = null; }

                          if (validTillMs && !isNaN(validTillMs)) {
                            const now = Date.now();
                            const diffHours = (validTillMs - now) / (1000 * 60 * 60);
                            // NIC Rule 382: Only allow within 8 hours BEFORE expiry OR after expiry (up to 8 hrs after)
                            if (diffHours > 8) {
                              const allowFrom = new Date(validTillMs - 8 * 60 * 60 * 1000);
                              const opts = { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit", hour12:true };
                              showToast(
                                `Extend is allowed only within 8 hours of EWB expiry. Please try after ${allowFrom.toLocaleString("en-IN", opts)}.`,
                                "warning", 9000
                              );
                              return;
                            }
                            if (diffHours < -8) {
                              showToast(
                                "EWB has expired more than 8 hours ago — Extend is no longer possible.",
                                "error", 7000
                              );
                              return;
                            }
                          }
                        }
                        setShowExtendModal(true);
                      }} className="btn-fabgreen">
                        <i className="fas fa-clock"></i>&nbsp;Extend
                      </button>
                      <button onClick={() => setShowCancelModal(true)} className="btn-fabred">
                        <i className="fas fa-ban"></i>&nbsp;Cancel EWB
                      </button>
                    </>
                  )}

                  {isCancelled && (
                    <>
                      <button onClick={() => Print_EWayBill(ewbResp.ewbNo)} className="btn-fabgreen">
                        <i className="fas fa-print"></i>&nbsp;Print
                      </button>
                      <span style={{ color: "#dc2626", fontWeight: 700, fontSize: 13, padding: "7px 16px", background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 8, display: "flex", alignItems: "center", gap: 6 }}>
                        ⛔ E-Way Bill Cancelled
                      </span>
                    </>
                  )}

                  <button onClick={Clear_EWayBill} className="btn-fabgreen">
                    <i className="fas fa-sync-alt"></i>&nbsp;Refresh
                  </button>
                </>
              )}

              {isSetting && (
                <>
                  <button onClick={Updat_GSTColumn}          className="btn-fabgreen">Update&nbsp;<i className="fas fa-save"></i></button>
                  <button onClick={Clear_Colums}              className="btn-fabgreen">Clear&nbsp;<i className="fas fa-eraser"></i></button>
                  <button onClick={() => setisSetting(false)} className="btn-fabgreen"><i className="bx bx-arrow-back"></i>&nbsp;Back</button>
                </>
              )}

            </div>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes pulse     { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.5; transform:scale(1.4); } }
        @keyframes modalPop  { from { opacity:0; transform:scale(0.88); } to { opacity:1; transform:scale(1); } }
        @keyframes toastSlide { from { opacity:0; transform:translateX(60px) scale(0.9); } to { opacity:1; transform:translateX(0) scale(1); } }
      `}</style>
    </>
  );
}

export default EWayBill;